var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWip1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-29"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-29",
    cx: 250,
    cy: 340.15,
    rx: 235.59,
    ry: 128.96,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-29",
    d: "M94.05,390.84c5.06,2.85,5.11,7.56.11,10.52s-13.15,3-18.22.19S70.83,394,75.83,391,89,388,94.05,390.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-29",
    d: "M228,354.53l-49-28a3.18,3.18,0,0,0-2.88,0l-.51.29c-.8.46-.79,1.2,0,1.64l16.69,9.34L175.2,347.7l-16.49-9.52a3.18,3.18,0,0,0-2.88,0l-.51.29a.88.88,0,0,0,0,1.67l49.8,28.75.54-.64.27.15,19.66-11.33.15.09.29-.34.42-.24-.15-.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-29",
    d: "M174.43,436.83l24.1-13.91a1,1,0,0,0,0-1.87l-24.1-13.91a3.62,3.62,0,0,0-3.24,0L147.1,421.05a1,1,0,0,0,0,1.87l24.09,13.91A3.56,3.56,0,0,0,174.43,436.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-29",
    d: "M347.69,421.39l24.09-13.92a1,1,0,0,0,0-1.87l-24.09-13.91a3.62,3.62,0,0,0-3.24,0L320.36,405.6a1,1,0,0,0,0,1.87l24.09,13.92A3.62,3.62,0,0,0,347.69,421.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-29",
    d: "M243.5,435.33l-28.32-16.41a.71.71,0,0,1,0-1.35L283,378.39a2.61,2.61,0,0,1,2.34,0l28.37,16.38a.71.71,0,0,1,0,1.35l-67.91,39.21A2.61,2.61,0,0,1,243.5,435.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-29",
    d: "M379.44,376.39l-59.86-34.56c-4.78-2.76-4.78-7.23,0-10l68-39.25c4.79-2.76,12.54-2.76,17.32,0l59.86,34.56c4.79,2.77,4.79,7.24,0,10l-68,39.25C392,379.15,384.22,379.15,379.44,376.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-29",
    d: "M56.91,382.49,34.7,369.67a1.32,1.32,0,0,1,0-2.5L270,231.3a4.79,4.79,0,0,1,4.33,0l22.21,12.82a1.32,1.32,0,0,1,0,2.5L61.24,382.49A4.79,4.79,0,0,1,56.91,382.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-29",
    d: "M145.2,362c5.94,3.35,6,8.87.13,12.34s-15.43,3.58-21.37.23-6-8.87-.13-12.34S139.26,358.64,145.2,362Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.15,65.25h0a.68.68,0,0,0-.74.12l-1.48,1.12-.28.94a1.79,1.79,0,0,0,.53,1.69,7.45,7.45,0,0,1,.76.82,1.06,1.06,0,0,0,1.47.22l3.45-2.61a.69.69,0,0,1,.72-.12Zm-4.67,13.59c-.7-2.88-2.66-4.22-5.06-3.86a6.86,6.86,0,0,1,.61,1.68c1.11,4.57-1.39,11.33-5.57,15.09A8.88,8.88,0,0,1,133,94.12c1.65,3,5.33,3.06,8.94-.18C146.09,90.18,148.58,83.42,147.48,78.84Zm-1.23-19.78h0A1,1,0,0,0,146,59l-2.75-.44a1.47,1.47,0,0,0-1.49.82l-2.24,5a2,2,0,0,1-.52.68h0a2.12,2.12,0,0,1-.41.33l1,2.6a.93.93,0,0,0,1.32.5,11.71,11.71,0,0,1,1.64-.66,3,3,0,0,0,.93-.57,2.28,2.28,0,0,0,.54-.69l2.22-5a1.5,1.5,0,0,1,1.49-.82l2.76.43a1,1,0,0,1,.28.09Zm-4.53,47.62a.75.75,0,0,1-.29-.39l-1.12-3a.92.92,0,0,0-1.32-.5,11.71,11.71,0,0,1-1.64.66,1.89,1.89,0,0,0-.51.26l.15.38a.79.79,0,0,0,.38.45h0Zm-8.17-44.31a.6.6,0,0,0-.3-.06.74.74,0,0,0-.48.23L128.9,66a1.07,1.07,0,0,0-.14.16,1.13,1.13,0,0,0-.1.13,3,3,0,0,0-.32.67.94.94,0,0,1,0,.16h0a1.91,1.91,0,0,0-.06.66l.5,3.86a3.15,3.15,0,0,1-.51,1.91c-.62.84-1.19,1.72-1.73,2.62a2,2,0,0,1-.85.76,2.09,2.09,0,0,1-.35.13l-.16,0a2,2,0,0,1-.24,0l-2.62,0h-.06l-.22,0-.19.06h0l-.21.1a2.36,2.36,0,0,0-.36.26,1.59,1.59,0,0,0-.38.56l-2.09,5.68a1,1,0,0,0,.5,1.3l3,1.48a1.3,1.3,0,0,1,.12.75c-.14.89-.24,1.79-.29,2.66a3.23,3.23,0,0,1-.75,1.84l0,0L118,95.45a.83.83,0,0,0-.16.21l0,0a1.19,1.19,0,0,0-.13.25,2.08,2.08,0,0,0-.18,1.33l.94,3.89a.82.82,0,0,0,.35.51l4.43,2.18a.71.71,0,0,1-.33-.5l-.94-3.89a1.76,1.76,0,0,1,0-.76,2.1,2.1,0,0,1,.5-1.06l3.34-3.51,0,0a3.4,3.4,0,0,0,.77-1.85,22.3,22.3,0,0,1,.28-2.65,1.33,1.33,0,0,0-.83-1.42l-2.17-.75a1,1,0,0,1-.64-1.36l2.09-5.68a1.5,1.5,0,0,1,.39-.56,1.62,1.62,0,0,1,1-.46l2.63,0a1.65,1.65,0,0,0,.75-.2,2,2,0,0,0,.85-.75c.53-.9,1.11-1.78,1.72-2.62a3.11,3.11,0,0,0,.51-1.92l-.5-3.85a1.57,1.57,0,0,1,.06-.67,2.26,2.26,0,0,1,.6-1.11l3.86-3.47a.71.71,0,0,1,.8-.16Zm-3.38,41.49a1.81,1.81,0,0,0-.54-1.68,6.52,6.52,0,0,1-.75-.82,1,1,0,0,0-1.47-.23l-2,1.49-1.23,4.14a.91.91,0,0,0,.44,1.08h0L129.1,110a.89.89,0,0,1-.44-1.08Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.15,65.25h0a.68.68,0,0,0-.74.12l-1.48,1.12-.28.94a1.79,1.79,0,0,0,.53,1.69,7.45,7.45,0,0,1,.76.82,1.06,1.06,0,0,0,1.47.22l3.45-2.61a.69.69,0,0,1,.72-.12Zm-4.67,13.59c-.7-2.88-2.66-4.22-5.06-3.86a6.86,6.86,0,0,1,.61,1.68c1.11,4.57-1.39,11.33-5.57,15.09A8.88,8.88,0,0,1,133,94.12c1.65,3,5.33,3.06,8.94-.18C146.09,90.18,148.58,83.42,147.48,78.84Zm-1.23-19.78h0A1,1,0,0,0,146,59l-2.75-.44a1.47,1.47,0,0,0-1.49.82l-2.24,5a2,2,0,0,1-.52.68h0a2.12,2.12,0,0,1-.41.33l1,2.6a.93.93,0,0,0,1.32.5,11.71,11.71,0,0,1,1.64-.66,3,3,0,0,0,.93-.57,2.28,2.28,0,0,0,.54-.69l2.22-5a1.5,1.5,0,0,1,1.49-.82l2.76.43a1,1,0,0,1,.28.09Zm-4.53,47.62a.75.75,0,0,1-.29-.39l-1.12-3a.92.92,0,0,0-1.32-.5,11.71,11.71,0,0,1-1.64.66,1.89,1.89,0,0,0-.51.26l.15.38a.79.79,0,0,0,.38.45h0Zm-8.17-44.31a.6.6,0,0,0-.3-.06.74.74,0,0,0-.48.23L128.9,66a1.07,1.07,0,0,0-.14.16,1.13,1.13,0,0,0-.1.13,3,3,0,0,0-.32.67.94.94,0,0,1,0,.16h0a1.91,1.91,0,0,0-.06.66l.5,3.86a3.15,3.15,0,0,1-.51,1.91c-.62.84-1.19,1.72-1.73,2.62a2,2,0,0,1-.85.76,2.09,2.09,0,0,1-.35.13l-.16,0a2,2,0,0,1-.24,0l-2.62,0h-.06l-.22,0-.19.06h0l-.21.1a2.36,2.36,0,0,0-.36.26,1.59,1.59,0,0,0-.38.56l-2.09,5.68a1,1,0,0,0,.5,1.3l3,1.48a1.3,1.3,0,0,1,.12.75c-.14.89-.24,1.79-.29,2.66a3.23,3.23,0,0,1-.75,1.84l0,0L118,95.45a.83.83,0,0,0-.16.21l0,0a1.19,1.19,0,0,0-.13.25,2.08,2.08,0,0,0-.18,1.33l.94,3.89a.82.82,0,0,0,.35.51l4.43,2.18a.71.71,0,0,1-.33-.5l-.94-3.89a1.76,1.76,0,0,1,0-.76,2.1,2.1,0,0,1,.5-1.06l3.34-3.51,0,0a3.4,3.4,0,0,0,.77-1.85,22.3,22.3,0,0,1,.28-2.65,1.33,1.33,0,0,0-.83-1.42l-2.17-.75a1,1,0,0,1-.64-1.36l2.09-5.68a1.5,1.5,0,0,1,.39-.56,1.62,1.62,0,0,1,1-.46l2.63,0a1.65,1.65,0,0,0,.75-.2,2,2,0,0,0,.85-.75c.53-.9,1.11-1.78,1.72-2.62a3.11,3.11,0,0,0,.51-1.92l-.5-3.85a1.57,1.57,0,0,1,.06-.67,2.26,2.26,0,0,1,.6-1.11l3.86-3.47a.71.71,0,0,1,.8-.16Zm-3.38,41.49a1.81,1.81,0,0,0-.54-1.68,6.52,6.52,0,0,1-.75-.82,1,1,0,0,0-1.47-.23l-2,1.49-1.23,4.14a.91.91,0,0,0,.44,1.08h0L129.1,110a.89.89,0,0,1-.44-1.08Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.15,65.25h0a.68.68,0,0,0-.74.12l-1.48,1.12-.28.94a1.79,1.79,0,0,0,.53,1.69,7.45,7.45,0,0,1,.76.82,1.06,1.06,0,0,0,1.47.22l3.45-2.61a.69.69,0,0,1,.72-.12Zm-4.67,13.59c-.7-2.88-2.66-4.22-5.06-3.86a6.86,6.86,0,0,1,.61,1.68c1.11,4.57-1.39,11.33-5.57,15.09A8.88,8.88,0,0,1,133,94.12c1.65,3,5.33,3.06,8.94-.18C146.09,90.18,148.58,83.42,147.48,78.84Zm-1.23-19.78h0A1,1,0,0,0,146,59l-2.75-.44a1.47,1.47,0,0,0-1.49.82l-2.24,5a2,2,0,0,1-.52.68h0a2.12,2.12,0,0,1-.41.33l1,2.6a.93.93,0,0,0,1.32.5,11.71,11.71,0,0,1,1.64-.66,3,3,0,0,0,.93-.57,2.28,2.28,0,0,0,.54-.69l2.22-5a1.5,1.5,0,0,1,1.49-.82l2.76.43a1,1,0,0,1,.28.09Zm-4.53,47.62a.75.75,0,0,1-.29-.39l-1.12-3a.92.92,0,0,0-1.32-.5,11.71,11.71,0,0,1-1.64.66,1.89,1.89,0,0,0-.51.26l.15.38a.79.79,0,0,0,.38.45h0Zm-8.17-44.31a.6.6,0,0,0-.3-.06.74.74,0,0,0-.48.23L128.9,66a1.07,1.07,0,0,0-.14.16,1.13,1.13,0,0,0-.1.13,3,3,0,0,0-.32.67.94.94,0,0,1,0,.16h0a1.91,1.91,0,0,0-.06.66l.5,3.86a3.15,3.15,0,0,1-.51,1.91c-.62.84-1.19,1.72-1.73,2.62a2,2,0,0,1-.85.76,2.09,2.09,0,0,1-.35.13l-.16,0a2,2,0,0,1-.24,0l-2.62,0h-.06l-.22,0-.19.06h0l-.21.1a2.36,2.36,0,0,0-.36.26,1.59,1.59,0,0,0-.38.56l-2.09,5.68a1,1,0,0,0,.5,1.3l3,1.48a1.3,1.3,0,0,1,.12.75c-.14.89-.24,1.79-.29,2.66a3.23,3.23,0,0,1-.75,1.84l0,0L118,95.45a.83.83,0,0,0-.16.21l0,0a1.19,1.19,0,0,0-.13.25,2.08,2.08,0,0,0-.18,1.33l.94,3.89a.82.82,0,0,0,.35.51l4.43,2.18a.71.71,0,0,1-.33-.5l-.94-3.89a1.76,1.76,0,0,1,0-.76,2.1,2.1,0,0,1,.5-1.06l3.34-3.51,0,0a3.4,3.4,0,0,0,.77-1.85,22.3,22.3,0,0,1,.28-2.65,1.33,1.33,0,0,0-.83-1.42l-2.17-.75a1,1,0,0,1-.64-1.36l2.09-5.68a1.5,1.5,0,0,1,.39-.56,1.62,1.62,0,0,1,1-.46l2.63,0a1.65,1.65,0,0,0,.75-.2,2,2,0,0,0,.85-.75c.53-.9,1.11-1.78,1.72-2.62a3.11,3.11,0,0,0,.51-1.92l-.5-3.85a1.57,1.57,0,0,1,.06-.67,2.26,2.26,0,0,1,.6-1.11l3.86-3.47a.71.71,0,0,1,.8-.16Zm-3.38,41.49a1.81,1.81,0,0,0-.54-1.68,6.52,6.52,0,0,1-.75-.82,1,1,0,0,0-1.47-.23l-2,1.49-1.23,4.14a.91.91,0,0,0,.44,1.08h0L129.1,110a.89.89,0,0,1-.44-1.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75,94.13l-3.34,3.51a2.1,2.1,0,0,0-.5,1.06l-4.43-2.18a2.28,2.28,0,0,1,.17-.58,1.19,1.19,0,0,1,.13-.25l0,0a.83.83,0,0,1,.16-.21l3.35-3.51Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.11,79.11a1.65,1.65,0,0,1-.75.2l-2.63,0a1.62,1.62,0,0,0-1,.46l-4.45-2.19a2.36,2.36,0,0,1,.36-.26l.21-.1h0l.19-.06.22,0h.06l2.62,0a2,2,0,0,0,.24,0l.16,0,.34-.14h0Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58,67.42a.68.68,0,0,0-.72.14l-3.45,2.61a1.05,1.05,0,0,1-1.47-.24,8.36,8.36,0,0,0-.76-.81,1.79,1.79,0,0,1-.53-1.69l.28-.94,1.48-1.12a.68.68,0,0,1,.74-.12h0Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.68,61.24a1,1,0,0,0-.28-.09l-2.76-.43a1.5,1.5,0,0,0-1.49.82l-2.22,5a2.28,2.28,0,0,1-.54.69L139,65.07a2,2,0,0,0,.52-.68l2.24-5a1.47,1.47,0,0,1,1.49-.82L146,59a1,1,0,0,1,.3.09h0Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,64.56a.71.71,0,0,0-.8.16l-3.86,3.47a2.26,2.26,0,0,0-.6,1.11l-4.45-2.18a.94.94,0,0,0,0-.16,3,3,0,0,1,.32-.67,1.13,1.13,0,0,1,.1-.13,1.07,1.07,0,0,1,.14-.16l3.87-3.46a.74.74,0,0,1,.48-.23.6.6,0,0,1,.3.06Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75,94.13l-3.34,3.51a2.1,2.1,0,0,0-.5,1.06l-4.43-2.18a2.28,2.28,0,0,1,.17-.58,1.19,1.19,0,0,1,.13-.25l0,0a.83.83,0,0,1,.16-.21l3.35-3.51Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.11,79.11a1.65,1.65,0,0,1-.75.2l-2.63,0a1.62,1.62,0,0,0-1,.46l-4.45-2.19a2.36,2.36,0,0,1,.36-.26l.21-.1h0l.19-.06.22,0h.06l2.62,0a2,2,0,0,0,.24,0l.16,0,.34-.14h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58,67.42a.68.68,0,0,0-.72.14l-3.45,2.61a1.05,1.05,0,0,1-1.47-.24,8.36,8.36,0,0,0-.76-.81,1.79,1.79,0,0,1-.53-1.69l.28-.94,1.48-1.12a.68.68,0,0,1,.74-.12h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.68,61.24a1,1,0,0,0-.28-.09l-2.76-.43a1.5,1.5,0,0,0-1.49.82l-2.22,5a2.28,2.28,0,0,1-.54.69L139,65.07a2,2,0,0,0,.52-.68l2.24-5a1.47,1.47,0,0,1,1.49-.82L146,59a1,1,0,0,1,.3.09h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,64.56a.71.71,0,0,0-.8.16l-3.86,3.47a2.26,2.26,0,0,0-.6,1.11l-4.45-2.18a.94.94,0,0,0,0-.16,3,3,0,0,1,.32-.67,1.13,1.13,0,0,1,.1-.13,1.07,1.07,0,0,1,.14-.16l3.87-3.46a.74.74,0,0,1,.48-.23.6.6,0,0,1,.3.06Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.9,71.84,157,68a.65.65,0,0,0-1.11-.39l-3.44,2.61a1.05,1.05,0,0,1-1.47-.24,8.36,8.36,0,0,0-.76-.81,1.79,1.79,0,0,1-.53-1.69l1.51-5.09a.92.92,0,0,0-.76-1.19l-2.75-.42a1.44,1.44,0,0,0-1.49.81l-2.24,5a2.72,2.72,0,0,1-1.46,1.27,12.22,12.22,0,0,0-1.64.66.93.93,0,0,1-1.32-.5l-1.12-3a.68.68,0,0,0-1.17-.29l-3.86,3.47a2.31,2.31,0,0,0-.66,1.78l.5,3.85a3,3,0,0,1-.51,1.92c-.61.84-1.19,1.72-1.72,2.62a2.11,2.11,0,0,1-1.6,1l-2.62,0a1.7,1.7,0,0,0-1.45,1l-2.09,5.68a1,1,0,0,0,.64,1.35l2.17.77a1.29,1.29,0,0,1,.82,1.4c-.14.9-.23,1.79-.28,2.66a3.24,3.24,0,0,1-.76,1.85l-3.38,3.55a2.18,2.18,0,0,0-.49,1.82l.94,3.88a.64.64,0,0,0,1.1.4l3.45-2.61a1,1,0,0,1,1.46.23,6.54,6.54,0,0,0,.76.81,1.78,1.78,0,0,1,.54,1.69L128.66,109a.91.91,0,0,0,.75,1.19l2.76.43a1.47,1.47,0,0,0,1.49-.81l2.23-5a2.65,2.65,0,0,1,1.47-1.26,15.47,15.47,0,0,0,1.63-.66.92.92,0,0,1,1.32.5l1.12,3a.68.68,0,0,0,1.18.29l3.85-3.47a2.25,2.25,0,0,0,.66-1.77l-.5-3.86a3.06,3.06,0,0,1,.51-1.91c.62-.85,1.19-1.72,1.73-2.63a2.09,2.09,0,0,1,1.6-1l2.62,0a1.68,1.68,0,0,0,1.44-1l2.1-5.68a1.07,1.07,0,0,0-.64-1.36l-2.18-.76a1.31,1.31,0,0,1-.82-1.41,24.78,24.78,0,0,0,.28-2.66,3.35,3.35,0,0,1,.76-1.84l3.39-3.56A2.16,2.16,0,0,0,157.9,71.84Zm-16,22.1c-4.18,3.76-8.47,3.09-9.57-1.49s1.39-11.33,5.57-15.09,8.46-3.1,9.57,1.48S146.09,90.18,141.91,93.94Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.9,71.84,157,68a.65.65,0,0,0-1.11-.39l-3.44,2.61a1.05,1.05,0,0,1-1.47-.24,8.36,8.36,0,0,0-.76-.81,1.79,1.79,0,0,1-.53-1.69l1.51-5.09a.92.92,0,0,0-.76-1.19l-2.75-.42a1.44,1.44,0,0,0-1.49.81l-2.24,5a2.72,2.72,0,0,1-1.46,1.27,12.22,12.22,0,0,0-1.64.66.93.93,0,0,1-1.32-.5l-1.12-3a.68.68,0,0,0-1.17-.29l-3.86,3.47a2.31,2.31,0,0,0-.66,1.78l.5,3.85a3,3,0,0,1-.51,1.92c-.61.84-1.19,1.72-1.72,2.62a2.11,2.11,0,0,1-1.6,1l-2.62,0a1.7,1.7,0,0,0-1.45,1l-2.09,5.68a1,1,0,0,0,.64,1.35l2.17.77a1.29,1.29,0,0,1,.82,1.4c-.14.9-.23,1.79-.28,2.66a3.24,3.24,0,0,1-.76,1.85l-3.38,3.55a2.18,2.18,0,0,0-.49,1.82l.94,3.88a.64.64,0,0,0,1.1.4l3.45-2.61a1,1,0,0,1,1.46.23,6.54,6.54,0,0,0,.76.81,1.78,1.78,0,0,1,.54,1.69L128.66,109a.91.91,0,0,0,.75,1.19l2.76.43a1.47,1.47,0,0,0,1.49-.81l2.23-5a2.65,2.65,0,0,1,1.47-1.26,15.47,15.47,0,0,0,1.63-.66.92.92,0,0,1,1.32.5l1.12,3a.68.68,0,0,0,1.18.29l3.85-3.47a2.25,2.25,0,0,0,.66-1.77l-.5-3.86a3.06,3.06,0,0,1,.51-1.91c.62-.85,1.19-1.72,1.73-2.63a2.09,2.09,0,0,1,1.6-1l2.62,0a1.68,1.68,0,0,0,1.44-1l2.1-5.68a1.07,1.07,0,0,0-.64-1.36l-2.18-.76a1.31,1.31,0,0,1-.82-1.41,24.78,24.78,0,0,0,.28-2.66,3.35,3.35,0,0,1,.76-1.84l3.39-3.56A2.16,2.16,0,0,0,157.9,71.84Zm-16,22.1c-4.18,3.76-8.47,3.09-9.57-1.49s1.39-11.33,5.57-15.09,8.46-3.1,9.57,1.48S146.09,90.18,141.91,93.94Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,74.19h0a1,1,0,0,0-1,.16l-2,1.54-.39,1.31a2.46,2.46,0,0,0,.74,2.32,9.48,9.48,0,0,1,1,1.13,1.45,1.45,0,0,0,2,.31l4.75-3.6a1,1,0,0,1,1-.17ZM91.53,92.92c-1-4-3.65-5.81-7-5.32a9.87,9.87,0,0,1,.84,2.31c1.52,6.3-1.92,15.61-7.67,20.79A12.31,12.31,0,0,1,71.56,114c2.27,4.14,7.34,4.21,12.31-.25C89.62,108.54,93.06,99.23,91.53,92.92ZM89.84,65.67h0a1.06,1.06,0,0,0-.4-.14L85.64,65a2,2,0,0,0-2,1.12L80.51,73a3,3,0,0,1-.72.95h0a3.35,3.35,0,0,1-.57.44L80.55,78a1.27,1.27,0,0,0,1.82.69,19.64,19.64,0,0,1,2.25-.91A3.81,3.81,0,0,0,85.91,77a3,3,0,0,0,.73-1l3.07-6.94A2.06,2.06,0,0,1,91.77,68l3.8.6a1.41,1.41,0,0,1,.38.11Zm-6.24,65.6a1,1,0,0,1-.39-.55l-1.55-4.11a1.26,1.26,0,0,0-1.81-.69,17.5,17.5,0,0,1-2.26.91,2.86,2.86,0,0,0-.7.35l.2.53a1.1,1.1,0,0,0,.52.62h0Zm-11.24-61a.85.85,0,0,0-.42-.08,1.09,1.09,0,0,0-.67.31L66,75.24a1.07,1.07,0,0,0-.2.22,1.15,1.15,0,0,0-.14.17,3.89,3.89,0,0,0-.43.92c0,.07,0,.15-.05.22h0a2.45,2.45,0,0,0-.09.91L65.73,83a4.17,4.17,0,0,1-.7,2.64c-.85,1.16-1.63,2.38-2.37,3.62a2.87,2.87,0,0,1-1.17,1,2.34,2.34,0,0,1-.48.18,1,1,0,0,1-.24.05,1.13,1.13,0,0,1-.32,0l-3.61.06h-.09l-.29,0a1.12,1.12,0,0,0-.26.08h0a1.92,1.92,0,0,0-.29.14,2.54,2.54,0,0,0-.5.36,2.22,2.22,0,0,0-.53.77L52,99.85a1.44,1.44,0,0,0,.69,1.78l4.16,2a1.79,1.79,0,0,1,.15,1,33.17,33.17,0,0,0-.38,3.66,4.57,4.57,0,0,1-1.05,2.54l0,0-4.62,4.84a2.09,2.09,0,0,0-.22.28l0,0a1.11,1.11,0,0,0-.18.34,2.85,2.85,0,0,0-.25,1.84l1.3,5.35a1.08,1.08,0,0,0,.48.71l6.1,3a1,1,0,0,1-.46-.69l-1.29-5.35a2.42,2.42,0,0,1,0-1,3,3,0,0,1,.68-1.47L61.61,114l0-.06a4.58,4.58,0,0,0,1.06-2.54,33.68,33.68,0,0,1,.38-3.66A1.8,1.8,0,0,0,62,105.78l-3-1a1.45,1.45,0,0,1-.89-1.87L61,95a1.88,1.88,0,0,1,.53-.77A2.29,2.29,0,0,1,63,93.63l3.62-.06a2.34,2.34,0,0,0,1-.28,2.81,2.81,0,0,0,1.17-1c.74-1.24,1.53-2.46,2.37-3.61A4.21,4.21,0,0,0,71.86,86l-.69-5.31a2.32,2.32,0,0,1,.08-.93,3,3,0,0,1,.83-1.52l5.31-4.78a1,1,0,0,1,1.1-.23ZM67.7,127.39a2.5,2.5,0,0,0-.75-2.33,9.26,9.26,0,0,1-1-1.12,1.44,1.44,0,0,0-2-.32l-2.71,2-1.69,5.71a1.24,1.24,0,0,0,.6,1.49h0l6.14,3a1.24,1.24,0,0,1-.6-1.5Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,74.19h0a1,1,0,0,0-1,.16l-2,1.54-.39,1.31a2.46,2.46,0,0,0,.74,2.32,9.48,9.48,0,0,1,1,1.13,1.45,1.45,0,0,0,2,.31l4.75-3.6a1,1,0,0,1,1-.17ZM91.53,92.92c-1-4-3.65-5.81-7-5.32a9.87,9.87,0,0,1,.84,2.31c1.52,6.3-1.92,15.61-7.67,20.79A12.31,12.31,0,0,1,71.56,114c2.27,4.14,7.34,4.21,12.31-.25C89.62,108.54,93.06,99.23,91.53,92.92ZM89.84,65.67h0a1.06,1.06,0,0,0-.4-.14L85.64,65a2,2,0,0,0-2,1.12L80.51,73a3,3,0,0,1-.72.95h0a3.35,3.35,0,0,1-.57.44L80.55,78a1.27,1.27,0,0,0,1.82.69,19.64,19.64,0,0,1,2.25-.91A3.81,3.81,0,0,0,85.91,77a3,3,0,0,0,.73-1l3.07-6.94A2.06,2.06,0,0,1,91.77,68l3.8.6a1.41,1.41,0,0,1,.38.11Zm-6.24,65.6a1,1,0,0,1-.39-.55l-1.55-4.11a1.26,1.26,0,0,0-1.81-.69,17.5,17.5,0,0,1-2.26.91,2.86,2.86,0,0,0-.7.35l.2.53a1.1,1.1,0,0,0,.52.62h0Zm-11.24-61a.85.85,0,0,0-.42-.08,1.09,1.09,0,0,0-.67.31L66,75.24a1.07,1.07,0,0,0-.2.22,1.15,1.15,0,0,0-.14.17,3.89,3.89,0,0,0-.43.92c0,.07,0,.15-.05.22h0a2.45,2.45,0,0,0-.09.91L65.73,83a4.17,4.17,0,0,1-.7,2.64c-.85,1.16-1.63,2.38-2.37,3.62a2.87,2.87,0,0,1-1.17,1,2.34,2.34,0,0,1-.48.18,1,1,0,0,1-.24.05,1.13,1.13,0,0,1-.32,0l-3.61.06h-.09l-.29,0a1.12,1.12,0,0,0-.26.08h0a1.92,1.92,0,0,0-.29.14,2.54,2.54,0,0,0-.5.36,2.22,2.22,0,0,0-.53.77L52,99.85a1.44,1.44,0,0,0,.69,1.78l4.16,2a1.79,1.79,0,0,1,.15,1,33.17,33.17,0,0,0-.38,3.66,4.57,4.57,0,0,1-1.05,2.54l0,0-4.62,4.84a2.09,2.09,0,0,0-.22.28l0,0a1.11,1.11,0,0,0-.18.34,2.85,2.85,0,0,0-.25,1.84l1.3,5.35a1.08,1.08,0,0,0,.48.71l6.1,3a1,1,0,0,1-.46-.69l-1.29-5.35a2.42,2.42,0,0,1,0-1,3,3,0,0,1,.68-1.47L61.61,114l0-.06a4.58,4.58,0,0,0,1.06-2.54,33.68,33.68,0,0,1,.38-3.66A1.8,1.8,0,0,0,62,105.78l-3-1a1.45,1.45,0,0,1-.89-1.87L61,95a1.88,1.88,0,0,1,.53-.77A2.29,2.29,0,0,1,63,93.63l3.62-.06a2.34,2.34,0,0,0,1-.28,2.81,2.81,0,0,0,1.17-1c.74-1.24,1.53-2.46,2.37-3.61A4.21,4.21,0,0,0,71.86,86l-.69-5.31a2.32,2.32,0,0,1,.08-.93,3,3,0,0,1,.83-1.52l5.31-4.78a1,1,0,0,1,1.1-.23ZM67.7,127.39a2.5,2.5,0,0,0-.75-2.33,9.26,9.26,0,0,1-1-1.12,1.44,1.44,0,0,0-2-.32l-2.71,2-1.69,5.71a1.24,1.24,0,0,0,.6,1.49h0l6.14,3a1.24,1.24,0,0,1-.6-1.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,74.19h0a1,1,0,0,0-1,.16l-2,1.54-.39,1.31a2.46,2.46,0,0,0,.74,2.32,9.48,9.48,0,0,1,1,1.13,1.45,1.45,0,0,0,2,.31l4.75-3.6a1,1,0,0,1,1-.17ZM91.53,92.92c-1-4-3.65-5.81-7-5.32a9.87,9.87,0,0,1,.84,2.31c1.52,6.3-1.92,15.61-7.67,20.79A12.31,12.31,0,0,1,71.56,114c2.27,4.14,7.34,4.21,12.31-.25C89.62,108.54,93.06,99.23,91.53,92.92ZM89.84,65.67h0a1.06,1.06,0,0,0-.4-.14L85.64,65a2,2,0,0,0-2,1.12L80.51,73a3,3,0,0,1-.72.95h0a3.35,3.35,0,0,1-.57.44L80.55,78a1.27,1.27,0,0,0,1.82.69,19.64,19.64,0,0,1,2.25-.91A3.81,3.81,0,0,0,85.91,77a3,3,0,0,0,.73-1l3.07-6.94A2.06,2.06,0,0,1,91.77,68l3.8.6a1.41,1.41,0,0,1,.38.11Zm-6.24,65.6a1,1,0,0,1-.39-.55l-1.55-4.11a1.26,1.26,0,0,0-1.81-.69,17.5,17.5,0,0,1-2.26.91,2.86,2.86,0,0,0-.7.35l.2.53a1.1,1.1,0,0,0,.52.62h0Zm-11.24-61a.85.85,0,0,0-.42-.08,1.09,1.09,0,0,0-.67.31L66,75.24a1.07,1.07,0,0,0-.2.22,1.15,1.15,0,0,0-.14.17,3.89,3.89,0,0,0-.43.92c0,.07,0,.15-.05.22h0a2.45,2.45,0,0,0-.09.91L65.73,83a4.17,4.17,0,0,1-.7,2.64c-.85,1.16-1.63,2.38-2.37,3.62a2.87,2.87,0,0,1-1.17,1,2.34,2.34,0,0,1-.48.18,1,1,0,0,1-.24.05,1.13,1.13,0,0,1-.32,0l-3.61.06h-.09l-.29,0a1.12,1.12,0,0,0-.26.08h0a1.92,1.92,0,0,0-.29.14,2.54,2.54,0,0,0-.5.36,2.22,2.22,0,0,0-.53.77L52,99.85a1.44,1.44,0,0,0,.69,1.78l4.16,2a1.79,1.79,0,0,1,.15,1,33.17,33.17,0,0,0-.38,3.66,4.57,4.57,0,0,1-1.05,2.54l0,0-4.62,4.84a2.09,2.09,0,0,0-.22.28l0,0a1.11,1.11,0,0,0-.18.34,2.85,2.85,0,0,0-.25,1.84l1.3,5.35a1.08,1.08,0,0,0,.48.71l6.1,3a1,1,0,0,1-.46-.69l-1.29-5.35a2.42,2.42,0,0,1,0-1,3,3,0,0,1,.68-1.47L61.61,114l0-.06a4.58,4.58,0,0,0,1.06-2.54,33.68,33.68,0,0,1,.38-3.66A1.8,1.8,0,0,0,62,105.78l-3-1a1.45,1.45,0,0,1-.89-1.87L61,95a1.88,1.88,0,0,1,.53-.77A2.29,2.29,0,0,1,63,93.63l3.62-.06a2.34,2.34,0,0,0,1-.28,2.81,2.81,0,0,0,1.17-1c.74-1.24,1.53-2.46,2.37-3.61A4.21,4.21,0,0,0,71.86,86l-.69-5.31a2.32,2.32,0,0,1,.08-.93,3,3,0,0,1,.83-1.52l5.31-4.78a1,1,0,0,1,1.1-.23ZM67.7,127.39a2.5,2.5,0,0,0-.75-2.33,9.26,9.26,0,0,1-1-1.12,1.44,1.44,0,0,0-2-.32l-2.71,2-1.69,5.71a1.24,1.24,0,0,0,.6,1.49h0l6.14,3a1.24,1.24,0,0,1-.6-1.5Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.61,114,57,118.81a3,3,0,0,0-.68,1.47l-6.11-3a3.53,3.53,0,0,1,.24-.8,1.11,1.11,0,0,1,.18-.34l0,0a2.09,2.09,0,0,1,.22-.28L55.49,111Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.61,93.29a2.34,2.34,0,0,1-1,.28L63,93.63a2.29,2.29,0,0,0-1.45.64l-6.13-3a2.54,2.54,0,0,1,.5-.36,1.92,1.92,0,0,1,.29-.14h0a1.12,1.12,0,0,1,.26-.08l.29,0h.09l3.61-.06a1.13,1.13,0,0,0,.32,0l.24-.05c.15,0,.3-.12.46-.19h0Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.08,77.19a1,1,0,0,0-1,.19L98.33,81a1.44,1.44,0,0,1-2-.32,9.33,9.33,0,0,0-1-1.12,2.47,2.47,0,0,1-.74-2.33l.39-1.29,2-1.55a1,1,0,0,1,1-.16h0Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,68.67a1.41,1.41,0,0,0-.38-.11l-3.8-.6a2.06,2.06,0,0,0-2.06,1.12L86.64,76a3,3,0,0,1-.73,1l-6.12-3a3,3,0,0,0,.72-.95l3.08-6.94a2,2,0,0,1,2-1.12l3.8.59a1.06,1.06,0,0,1,.4.14h0Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,73.24a1,1,0,0,0-1.1.23l-5.31,4.78a3,3,0,0,0-.83,1.52l-6.12-3c0-.07,0-.15.05-.22a3.89,3.89,0,0,1,.43-.92,1.15,1.15,0,0,1,.14-.17,1.07,1.07,0,0,1,.2-.22l5.32-4.78a1.09,1.09,0,0,1,.67-.31.85.85,0,0,1,.42.08Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.61,114,57,118.81a3,3,0,0,0-.68,1.47l-6.11-3a3.53,3.53,0,0,1,.24-.8,1.11,1.11,0,0,1,.18-.34l0,0a2.09,2.09,0,0,1,.22-.28L55.49,111Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.61,93.29a2.34,2.34,0,0,1-1,.28L63,93.63a2.29,2.29,0,0,0-1.45.64l-6.13-3a2.54,2.54,0,0,1,.5-.36,1.92,1.92,0,0,1,.29-.14h0a1.12,1.12,0,0,1,.26-.08l.29,0h.09l3.61-.06a1.13,1.13,0,0,0,.32,0l.24-.05c.15,0,.3-.12.46-.19h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.08,77.19a1,1,0,0,0-1,.19L98.33,81a1.44,1.44,0,0,1-2-.32,9.33,9.33,0,0,0-1-1.12,2.47,2.47,0,0,1-.74-2.33l.39-1.29,2-1.55a1,1,0,0,1,1-.16h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,68.67a1.41,1.41,0,0,0-.38-.11l-3.8-.6a2.06,2.06,0,0,0-2.06,1.12L86.64,76a3,3,0,0,1-.73,1l-6.12-3a3,3,0,0,0,.72-.95l3.08-6.94a2,2,0,0,1,2-1.12l3.8.59a1.06,1.06,0,0,1,.4.14h0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,73.24a1,1,0,0,0-1.1.23l-5.31,4.78a3,3,0,0,0-.83,1.52l-6.12-3c0-.07,0-.15.05-.22a3.89,3.89,0,0,1,.43-.92,1.15,1.15,0,0,1,.14-.17,1.07,1.07,0,0,1,.2-.22l5.32-4.78a1.09,1.09,0,0,1,.67-.31.85.85,0,0,1,.42.08Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.89,83.27l-1.29-5.35a.89.89,0,0,0-1.52-.54L98.33,81a1.44,1.44,0,0,1-2-.32,10.21,10.21,0,0,0-1-1.12,2.43,2.43,0,0,1-.73-2.32l2.07-7a1.25,1.25,0,0,0-1-1.64L91.77,68a2,2,0,0,0-2,1.12L86.64,76a3.65,3.65,0,0,1-2,1.74,17.39,17.39,0,0,0-2.25.91A1.27,1.27,0,0,1,80.55,78L79,73.87a.94.94,0,0,0-1.62-.4l-5.31,4.78a3.14,3.14,0,0,0-.91,2.45L71.86,86a4.26,4.26,0,0,1-.7,2.64c-.85,1.16-1.64,2.37-2.38,3.61a2.89,2.89,0,0,1-2.2,1.31L63,93.63A2.3,2.3,0,0,0,61,95l-2.89,7.82a1.45,1.45,0,0,0,.89,1.87l3,1a1.8,1.8,0,0,1,1.13,1.94,31.14,31.14,0,0,0-.38,3.66,4.51,4.51,0,0,1-1.06,2.54L57,118.82a3,3,0,0,0-.67,2.5l1.29,5.35a.9.9,0,0,0,1.52.55l4.75-3.6a1.44,1.44,0,0,1,2,.32,11.2,11.2,0,0,0,1,1.12,2.46,2.46,0,0,1,.74,2.32l-2.08,7a1.26,1.26,0,0,0,1,1.64l3.8.59a2,2,0,0,0,2-1.13l3.08-6.93a3.66,3.66,0,0,1,2-1.74,17,17,0,0,0,2.26-.91,1.28,1.28,0,0,1,1.82.69l1.54,4.11a.94.94,0,0,0,1.62.4l5.31-4.78a3.18,3.18,0,0,0,.91-2.45l-.69-5.31a4.2,4.2,0,0,1,.7-2.64c.85-1.16,1.64-2.37,2.38-3.61a2.87,2.87,0,0,1,2.2-1.31l3.61-.06a2.3,2.3,0,0,0,2-1.41l2.88-7.82a1.44,1.44,0,0,0-.88-1.87l-3-1a1.8,1.8,0,0,1-1.13-1.94,36.08,36.08,0,0,0,.38-3.66,4.57,4.57,0,0,1,1-2.54l4.67-4.9A3,3,0,0,0,105.89,83.27Zm-22,30.45c-5.76,5.17-11.66,4.26-13.18-2s1.92-15.62,7.68-20.79,11.65-4.27,13.18,2S89.62,108.54,83.86,113.72Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.89,83.27l-1.29-5.35a.89.89,0,0,0-1.52-.54L98.33,81a1.44,1.44,0,0,1-2-.32,10.21,10.21,0,0,0-1-1.12,2.43,2.43,0,0,1-.73-2.32l2.07-7a1.25,1.25,0,0,0-1-1.64L91.77,68a2,2,0,0,0-2,1.12L86.64,76a3.65,3.65,0,0,1-2,1.74,17.39,17.39,0,0,0-2.25.91A1.27,1.27,0,0,1,80.55,78L79,73.87a.94.94,0,0,0-1.62-.4l-5.31,4.78a3.14,3.14,0,0,0-.91,2.45L71.86,86a4.26,4.26,0,0,1-.7,2.64c-.85,1.16-1.64,2.37-2.38,3.61a2.89,2.89,0,0,1-2.2,1.31L63,93.63A2.3,2.3,0,0,0,61,95l-2.89,7.82a1.45,1.45,0,0,0,.89,1.87l3,1a1.8,1.8,0,0,1,1.13,1.94,31.14,31.14,0,0,0-.38,3.66,4.51,4.51,0,0,1-1.06,2.54L57,118.82a3,3,0,0,0-.67,2.5l1.29,5.35a.9.9,0,0,0,1.52.55l4.75-3.6a1.44,1.44,0,0,1,2,.32,11.2,11.2,0,0,0,1,1.12,2.46,2.46,0,0,1,.74,2.32l-2.08,7a1.26,1.26,0,0,0,1,1.64l3.8.59a2,2,0,0,0,2-1.13l3.08-6.93a3.66,3.66,0,0,1,2-1.74,17,17,0,0,0,2.26-.91,1.28,1.28,0,0,1,1.82.69l1.54,4.11a.94.94,0,0,0,1.62.4l5.31-4.78a3.18,3.18,0,0,0,.91-2.45l-.69-5.31a4.2,4.2,0,0,1,.7-2.64c.85-1.16,1.64-2.37,2.38-3.61a2.87,2.87,0,0,1,2.2-1.31l3.61-.06a2.3,2.3,0,0,0,2-1.41l2.88-7.82a1.44,1.44,0,0,0-.88-1.87l-3-1a1.8,1.8,0,0,1-1.13-1.94,36.08,36.08,0,0,0,.38-3.66,4.57,4.57,0,0,1,1-2.54l4.67-4.9A3,3,0,0,0,105.89,83.27Zm-22,30.45c-5.76,5.17-11.66,4.26-13.18-2s1.92-15.62,7.68-20.79,11.65-4.27,13.18,2S89.62,108.54,83.86,113.72Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cones--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cone--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,418.65l21.4-12.36a2.91,2.91,0,0,1,1.43-.34,3,3,0,0,1,1.44.34l21.39,12.36a1,1,0,0,1,.59.83V421a1,1,0,0,1-.59.83l-21.39,12.35a3,3,0,0,1-1.44.34,2.91,2.91,0,0,1-1.43-.34L150,421.87a1,1,0,0,1-.59-.83v-1.56A1,1,0,0,1,150,418.65Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.39,419.48V421a1,1,0,0,0,.59.83l21.4,12.35a2.91,2.91,0,0,0,1.43.34V406a2.91,2.91,0,0,0-1.43.34L150,418.65A1,1,0,0,0,149.39,419.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81,406v28.61a3,3,0,0,0,1.44-.34l21.39-12.35a1,1,0,0,0,.59-.83v-1.56a1,1,0,0,0-.59-.83l-21.39-12.36A3,3,0,0,0,172.81,406Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25,432.66l21.4-12.35a.88.88,0,0,0,0-1.66l-21.4-12.35a3.18,3.18,0,0,0-2.88,0L150,418.65a.88.88,0,0,0,0,1.66l21.39,12.35A3.18,3.18,0,0,0,174.25,432.66Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25,432.66l21.4-12.35a.88.88,0,0,0,0-1.66l-21.4-12.35a3.18,3.18,0,0,0-2.88,0L150,418.65a.88.88,0,0,0,0,1.66l21.39,12.35A3.18,3.18,0,0,0,174.25,432.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81,406a3,3,0,0,1,1.44.35l21.4,12.35a.88.88,0,0,1,0,1.66l-21.4,12.35a3,3,0,0,1-1.44.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6,417.92h0l9.47-28.43v-.05h0a2.14,2.14,0,0,1,1-1.1,6,6,0,0,1,5.39,0,2.23,2.23,0,0,1,1,1.1h0v0h0L186,417.92h0c.87,2.48-.35,5.15-3.67,7.07-5.27,3-13.81,3-19.07,0C160,423.07,158.73,420.4,159.6,417.92Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35,397.64v0l1.35-4a1.93,1.93,0,0,0,.59,2,3.88,3.88,0,0,0,.84.65,8.13,8.13,0,0,0,7.35,0,4.14,4.14,0,0,0,.84-.65,2,2,0,0,0,.58-2l1.35,4.05v0a2.32,2.32,0,0,1-.3,2,4.24,4.24,0,0,1-1.51,1.37,7.62,7.62,0,0,1-1.63.66,10.85,10.85,0,0,1-6,0,7.5,7.5,0,0,1-1.64-.66,4.33,4.33,0,0,1-1.51-1.37A2.32,2.32,0,0,1,166.35,397.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.93,413.93v0l1.34-4.05a3.6,3.6,0,0,0-.07,2,4.59,4.59,0,0,0,1.14,2.05,8.08,8.08,0,0,0,1.88,1.47,16.8,16.8,0,0,0,15.16,0,7.88,7.88,0,0,0,1.88-1.47,4.72,4.72,0,0,0,1.15-2.05,3.69,3.69,0,0,0-.08-2l1.34,4,0,0a4.17,4.17,0,0,1,.15,2c-.28,1.54-1.44,3-3.48,4.22-4.73,2.72-12.39,2.72-17.12,0-2-1.19-3.2-2.68-3.47-4.22A4.1,4.1,0,0,1,160.93,413.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.64,405.79v0l1.35-4.05a2.73,2.73,0,0,0,.12,2,4.85,4.85,0,0,0,2,2l.07,0a12.46,12.46,0,0,0,11.25,0l.06,0a4.79,4.79,0,0,0,2-2,2.78,2.78,0,0,0,.13-2l1.34,4.05v0a3.1,3.1,0,0,1,0,2,4.61,4.61,0,0,1-1.48,2,8.53,8.53,0,0,1-1.08.76,12,12,0,0,1-3.59,1.28,16.09,16.09,0,0,1-6,0,11.85,11.85,0,0,1-3.59-1.28,7.87,7.87,0,0,1-1.08-.76,4.56,4.56,0,0,1-1.49-2A3.24,3.24,0,0,1,163.64,405.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81,387.7a5.53,5.53,0,0,1,2.7.64,2.23,2.23,0,0,1,1,1.1h0v0h0L186,417.92h0c.87,2.48-.35,5.15-3.67,7.07a19.53,19.53,0,0,1-9.54,2.28l.08,0a8,8,0,0,0,6.56-9l-3.94-28.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,391.46c1.49-.86,1.49-2.26,0-3.12a6,6,0,0,0-5.39,0c-1.49.86-1.49,2.26,0,3.12A6,6,0,0,0,175.51,391.46Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,391.46c1.49-.86,1.49-2.26,0-3.12a6,6,0,0,0-5.39,0c-1.49.86-1.49,2.26,0,3.12A6,6,0,0,0,175.51,391.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cone--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.24,403.2l21.4-12.35a2.78,2.78,0,0,1,1.43-.35,2.85,2.85,0,0,1,1.44.35L368.9,403.2a1,1,0,0,1,.59.83v1.56a1,1,0,0,1-.59.83l-21.39,12.35a3,3,0,0,1-1.44.34,2.88,2.88,0,0,1-1.43-.34l-21.4-12.35a1,1,0,0,1-.59-.83V404A1,1,0,0,1,323.24,403.2Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.65,404v1.56a1,1,0,0,0,.59.83l21.4,12.35a2.88,2.88,0,0,0,1.43.34V390.5a2.78,2.78,0,0,0-1.43.35l-21.4,12.35A1,1,0,0,0,322.65,404Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.07,390.5v28.61a3,3,0,0,0,1.44-.34l21.39-12.35a1,1,0,0,0,.59-.83V404a1,1,0,0,0-.59-.83l-21.39-12.35A2.85,2.85,0,0,0,346.07,390.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.51,417.21l21.39-12.35a.87.87,0,0,0,0-1.66l-21.39-12.35a3.18,3.18,0,0,0-2.88,0L323.24,403.2a.87.87,0,0,0,0,1.66l21.39,12.35A3.18,3.18,0,0,0,347.51,417.21Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.51,417.21l21.39-12.35a.87.87,0,0,0,0-1.66l-21.39-12.35a3.18,3.18,0,0,0-2.88,0L323.24,403.2a.87.87,0,0,0,0,1.66l21.39,12.35A3.18,3.18,0,0,0,347.51,417.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.07,390.5a3,3,0,0,1,1.44.35L368.9,403.2a.87.87,0,0,1,0,1.66l-21.39,12.35a3,3,0,0,1-1.44.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.86,402.47h0L342.33,374V374h0a2.27,2.27,0,0,1,1-1.1,6,6,0,0,1,5.4,0,2.27,2.27,0,0,1,1,1.1h0v0h0l9.47,28.44h0c.87,2.48-.35,5.15-3.68,7.07-5.26,3-13.8,3-19.06,0C333.21,407.62,332,405,332.86,402.47Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.61,382.19v0l1.35-4a2,2,0,0,0,.58,2,4.22,4.22,0,0,0,.85.65,8.11,8.11,0,0,0,7.34,0,4.22,4.22,0,0,0,.85-.65,2,2,0,0,0,.58-2l1.35,4.06v0a2.32,2.32,0,0,1-.3,2,4.33,4.33,0,0,1-1.51,1.37,8.19,8.19,0,0,1-1.63.67,11.07,11.07,0,0,1-6,0,8.19,8.19,0,0,1-1.63-.67,4.33,4.33,0,0,1-1.51-1.37A2.32,2.32,0,0,1,339.61,382.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.19,398.48v0l1.35-4a3.6,3.6,0,0,0-.07,2,4.59,4.59,0,0,0,1.14,2.05,7.88,7.88,0,0,0,1.88,1.47,16.8,16.8,0,0,0,15.16,0,7.88,7.88,0,0,0,1.88-1.47,4.59,4.59,0,0,0,1.14-2.05,3.56,3.56,0,0,0-.07-2l1.34,4,0,0a4,4,0,0,1,.14,2,6.46,6.46,0,0,1-3.47,4.22c-4.73,2.72-12.39,2.72-17.12,0a6.46,6.46,0,0,1-3.47-4.22A4,4,0,0,1,334.19,398.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9,390.34v0l1.34-4.05a2.78,2.78,0,0,0,.13,2,4.79,4.79,0,0,0,2,2l.06,0a12.48,12.48,0,0,0,11.26,0l.06,0a4.79,4.79,0,0,0,2-2,2.78,2.78,0,0,0,.13-2l1.34,4.05v0a3.17,3.17,0,0,1,0,2,4.61,4.61,0,0,1-1.48,2,7.74,7.74,0,0,1-1.09.76,11.79,11.79,0,0,1-3.58,1.28,15.74,15.74,0,0,1-6,0,11.79,11.79,0,0,1-3.58-1.28,7.74,7.74,0,0,1-1.09-.76,4.61,4.61,0,0,1-1.48-2A3.24,3.24,0,0,1,336.9,390.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.07,372.25a5.53,5.53,0,0,1,2.7.64,2.27,2.27,0,0,1,1,1.1h0v0h0l9.47,28.44h0c.87,2.48-.35,5.15-3.68,7.07a19.47,19.47,0,0,1-9.53,2.28l.08,0a8,8,0,0,0,6.55-9l-3.93-28.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,376c1.49-.86,1.49-2.26,0-3.12a6,6,0,0,0-5.4,0c-1.49.86-1.49,2.26,0,3.12A6,6,0,0,0,348.77,376Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,376c1.49-.86,1.49-2.26,0-3.12a6,6,0,0,0-5.4,0c-1.49.86-1.49,2.26,0,3.12A6,6,0,0,0,348.77,376Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.34,358.06s2.45-12-.37-22.82-8.9-19-16.08-22-15.33,1.85-9,9.08,18.82,16.53,19.6,36Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.34,358.06s2.45-12-.37-22.82-8.9-19-16.08-22-15.33,1.85-9,9.08,18.82,16.53,19.6,36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.16,354.35h.08a.43.43,0,0,0,.39-.45c-1.54-21.68-13.73-34.5-20-38.24a.41.41,0,0,0-.57.14.42.42,0,0,0,.15.57c6.1,3.67,18.05,16.25,19.56,37.59A.42.42,0,0,0,50.16,354.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.59,339.07c-.79,2.42.93,4.1,2.56,5.46,1.24,1.05,2.61,2.18,3,3.78.69,3.22-3.12,6.19-2.3,9.38a5.18,5.18,0,0,0,2.69,3c1,.55,2.11.9,3.17,1.35a14.52,14.52,0,0,0,1.58.38,7.39,7.39,0,0,1,4.33,1.93c1.76,1.91,1.54,4.85,2.17,7.37l0,.09a7.78,7.78,0,0,0,12.06,4.25l8.9-6.34c3.53-4.74,2.64-13.24-3-16-1.2-.59-2.57-.93-3.53-1.87a6.54,6.54,0,0,1-1.51-4.5,13,13,0,0,0-.66-4.78,7,7,0,0,0-5.34-3.7c-2.61-.45-5.21.6-7.68-.3s-4.75-2.35-7.31-3c-2.8-.7-6-.32-8.12,1.94A4.47,4.47,0,0,0,15.59,339.07Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.66,353.31a.33.33,0,0,0-.11-.15c-6.62-9.38-17-13.82-20.5-14.61a.38.38,0,0,0-.44.28.37.37,0,0,0,.28.44c3.33.74,13,4.85,19.44,13.45a20.29,20.29,0,0,0-16.14,1.41.37.37,0,0,0-.11.51.4.4,0,0,0,.3.17.42.42,0,0,0,.21-.06,19.53,19.53,0,0,1,16.49-1,30.74,30.74,0,0,1,5.51,18.92.37.37,0,0,0,.33.37h0a.37.37,0,0,0,.38-.35A31.47,31.47,0,0,0,41.66,353.31Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.48,54.78l-5.12-3L50.14,190.48v181a3.83,3.83,0,0,0,1.6,3.53h0l5.13,3h0a3.84,3.84,0,0,0,3.86-.38L290,245.21a12.07,12.07,0,0,0,5.46-9.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.27,374.42c0,3.49,2.45,4.9,5.46,3.16L290,245.21a12.07,12.07,0,0,0,5.46-9.47v-181L55.27,193.46Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.27,374.42c0,3.49,2.45,4.9,5.46,3.16L290,245.21a12.07,12.07,0,0,0,5.46-9.47v-181L55.27,193.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.29,378.83a3.31,3.31,0,0,1-1.67-.44,4.32,4.32,0,0,1-1.85-4V193.17L55,193,296,53.92V235.74a12.65,12.65,0,0,1-5.71,9.9L61,378A5.48,5.48,0,0,1,58.29,378.83ZM55.77,193.75V374.42a3.39,3.39,0,0,0,1.35,3.11,3.38,3.38,0,0,0,3.36-.39L289.77,244.78a11.57,11.57,0,0,0,5.21-9V55.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.27 193.46 55.27 214.87 295.48 76.19 295.48 54.78 55.27 193.46",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.27 214.87 50.14 211.89 50.14 190.48 55.27 193.46 55.27 214.87",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.27 214.87 50.14 211.89 50.14 190.48 55.27 193.46 55.27 214.87",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,92.37v5.1c0,1,.74,1.47,1.64,1L280.1,79.07V70.19L246.67,89.53A3.64,3.64,0,0,0,245,92.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.71,65.21c.91-.52,1.64-.1,1.64,1v5.09a3.6,3.6,0,0,1-1.64,2.84l-8.61,5V70.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.08,72.2l-1-.3a5.84,5.84,0,0,0,.15-1.24,2.24,2.24,0,0,0-.88-2,1.36,1.36,0,0,0-1.4.06,5,5,0,0,0-1.92,4,2.25,2.25,0,0,0,.88,2,1.19,1.19,0,0,0,.61.17,1.57,1.57,0,0,0,.79-.24,4,4,0,0,0,1.55-2.07l1,.3H288a.35.35,0,0,0,.34-.25A.34.34,0,0,0,288.08,72.2ZM285,74a.66.66,0,0,1-.68.07,1.66,1.66,0,0,1-.52-1.44,4.28,4.28,0,0,1,1.56-3.38.9.9,0,0,1,.43-.14.59.59,0,0,1,.26.07,1.69,1.69,0,0,1,.52,1.44A4.29,4.29,0,0,1,285,74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.81,36.84c-1-.61-2.38-.54-3.92.35L55.61,169.55A12.11,12.11,0,0,0,50.14,179v11.46l5.13,3L295.48,54.78V43.33a3.86,3.86,0,0,0-1.58-3.53C293,39.27,289.69,37.39,288.81,36.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.27,182a12.09,12.09,0,0,1,5.46-9.47L290,40.17c3-1.74,5.47-.33,5.47,3.16V54.78L55.27,193.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,39.84c-1-.62-2.38-.56-3.94.34L60.74,172.53a11.28,11.28,0,0,0-3.87,4.08l-5.13-3a11.26,11.26,0,0,1,3.87-4.1L284.89,37.19c1.54-.89,2.93-.95,3.91-.35s4.18,2.43,5.1,3C293.91,39.81,293.94,39.82,294,39.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.71,60.69a5.67,5.67,0,0,0-2.56,4.44c0,1.64,1.15,2.3,2.56,1.48a5.67,5.67,0,0,0,2.57-4.44C267.28,60.53,266.13,59.87,264.71,60.69Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,55.52A5.67,5.67,0,0,0,271.12,60c0,1.64,1.15,2.3,2.57,1.48A5.67,5.67,0,0,0,276.25,57C276.25,55.37,275.1,54.7,273.69,55.52Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.66,50.35a5.66,5.66,0,0,0-2.56,4.44c0,1.64,1.14,2.3,2.56,1.48a5.63,5.63,0,0,0,2.56-4.44C285.22,50.2,284.08,49.53,282.66,50.35Z",
    style: {
      fill: "#44C9F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.68,304.61a1,1,0,0,1-.48-.13,1,1,0,0,1-.48-.84V245a1,1,0,0,1,.48-.83l70.35-40.62a1,1,0,0,1,1,0,1,1,0,0,1,.48.83V263a1,1,0,0,1-.48.83L73.17,304.48A1.05,1.05,0,0,1,72.68,304.61Zm1-59.08V302l68.42-39.51V206Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.51,291.11l-1.65-1,21.29-35.92a1,1,0,0,1,1.3-.34l13.72,7.78,14.49-29a1,1,0,0,1,.67-.51.94.94,0,0,1,.82.22l19.52,17.23L142.4,251l-18.58-16.4-14.38,28.78a1,1,0,0,1-1.33.41L94.32,256Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.46,247.22a2.92,2.92,0,0,1-1.48-.39,3.58,3.58,0,0,1-1.61-3.31,9.25,9.25,0,0,1,4.26-7.37,3.28,3.28,0,0,1,5.28,3,9.29,9.29,0,0,1-4.26,7.38A4.46,4.46,0,0,1,104.46,247.22Zm3.35-9.69a2.42,2.42,0,0,0-1.16.38,7.26,7.26,0,0,0-3.24,5.61,1.72,1.72,0,0,0,.59,1.55,1.75,1.75,0,0,0,1.63-.26,7.29,7.29,0,0,0,3.24-5.62,1.7,1.7,0,0,0-.59-1.54A.89.89,0,0,0,107.81,237.53Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.54,201.79l59.23-34.2c1.35-.77,2.44-.14,2.44,1.41v4.94a5.39,5.39,0,0,1-2.44,4.23l-59.23,34.2c-1.35.78-2.44.15-2.44-1.41V206A5.39,5.39,0,0,1,151.54,201.79Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.08,219.3,193.92,194c.54-.32,1-.06,1,.56v3a2.14,2.14,0,0,1-1,1.69l-43.84,25.32c-.54.31-1,.06-1-.57v-3A2.16,2.16,0,0,1,150.08,219.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,232.67a.58.58,0,0,1-.49-.28.57.57,0,0,1,.21-.77l86.88-50.16a.56.56,0,1,1,.56,1l-86.88,50.16A.57.57,0,0,1,149.1,232.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,238a.57.57,0,0,1-.28-1.06l86.88-50.15a.56.56,0,0,1,.77.2.57.57,0,0,1-.21.77l-86.88,50.16A.57.57,0,0,1,149.1,238Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,243.24a.58.58,0,0,1-.49-.28.57.57,0,0,1,.21-.77L235.7,192a.56.56,0,1,1,.56,1l-86.88,50.16A.55.55,0,0,1,149.1,243.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,248.53a.58.58,0,0,1-.49-.28.57.57,0,0,1,.21-.77l86.88-50.16a.56.56,0,1,1,.56,1l-86.88,50.16A.55.55,0,0,1,149.1,248.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,253.82a.58.58,0,0,1-.49-.28.57.57,0,0,1,.21-.77l86.88-50.16a.56.56,0,1,1,.56,1l-86.88,50.16A.55.55,0,0,1,149.1,253.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,259.11a.58.58,0,0,1-.49-.28.57.57,0,0,1,.21-.77L190,234.26a.57.57,0,0,1,.57,1L149.38,259A.57.57,0,0,1,149.1,259.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.25,347.33,129,318.57a4.61,4.61,0,0,0,2.08-3.61V288.18c0-1.33-.93-1.86-2.08-1.2L79.25,315.74a4.61,4.61,0,0,0-2.08,3.61v26.78C77.17,347.46,78.1,348,79.25,347.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,348.1a1.62,1.62,0,0,1-.78-.2,1.93,1.93,0,0,1-.85-1.77V319.35a5.07,5.07,0,0,1,2.32-4l49.76-28.77a1.74,1.74,0,0,1,2.8,1.62V315a5.07,5.07,0,0,1-2.32,4L79.5,347.75A2.44,2.44,0,0,1,78.32,348.1Zm51.62-60.92a1.38,1.38,0,0,0-.69.22L79.5,316.16a4.15,4.15,0,0,0-1.85,3.19v26.78a1,1,0,0,0,.37.93,1,1,0,0,0,1-.14l49.76-28.77a4.14,4.14,0,0,0,1.84-3.19V288.18a1,1,0,0,0-.37-.93A.58.58,0,0,0,129.94,287.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.12,317.58,91.76,312c.58-.33,1-.06,1,.6v11.13a2.29,2.29,0,0,1-1,1.81l-9.64,5.56c-.57.34-1,.07-1-.6V319.38A2.31,2.31,0,0,1,82.12,317.58Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,308.91l29.64-17.15c.23-.13.42,0,.42.24v1.46a.91.91,0,0,1-.42.72L97.13,311.33c-.23.14-.42,0-.42-.24v-1.46A.93.93,0,0,1,97.13,308.91Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,314.47l29.64-17.15c.23-.14.42,0,.42.24V299a.93.93,0,0,1-.42.72L97.13,316.89c-.23.13-.42,0-.42-.24v-1.46A.91.91,0,0,1,97.13,314.47Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,320l29.64-17.15c.23-.14.42,0,.42.24v1.46a.94.94,0,0,1-.42.72L97.13,322.45c-.23.13-.42,0-.42-.24v-1.46A.91.91,0,0,1,97.13,320Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5,334.57l45.27-26.14c.23-.13.42,0,.42.24v1.46a.91.91,0,0,1-.42.72L81.5,337c-.23.13-.42,0-.42-.24v-1.47A.94.94,0,0,1,81.5,334.57Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5,340.13,126.77,314c.23-.13.42,0,.42.24v1.46a.91.91,0,0,1-.42.72L81.5,342.55c-.23.14-.42,0-.42-.24v-1.46A.93.93,0,0,1,81.5,340.13Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.27,313.83a.38.38,0,0,1-.31-.18.36.36,0,0,1,.13-.49l1-.61a.37.37,0,0,1,.5.14.36.36,0,0,1-.13.49l-1,.6A.37.37,0,0,1,75.27,313.83Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.51,312a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49L80.52,310a.35.35,0,0,1,.49.14.36.36,0,0,1-.13.49l-2.19,1.26A.31.31,0,0,1,78.51,312Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.89,309.43a.36.36,0,0,1-.18-.67l2.19-1.27a.37.37,0,0,1,.5.13.36.36,0,0,1-.14.5l-2.19,1.26A.29.29,0,0,1,82.89,309.43Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.27,306.9a.38.38,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,87.27,306.9Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.66,304.37a.35.35,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,91.66,304.37Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,301.84a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.37.37,0,0,1,96,301.84Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59,299.21a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.31.31,0,0,1,100.59,299.21Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13,296.59a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.37.37,0,0,1,.5.13.36.36,0,0,1-.13.49l-2.2,1.27A.37.37,0,0,1,105.13,296.59Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68,294a.33.33,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,109.68,294Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.22,291.33a.36.36,0,0,1-.18-.67l2.2-1.27a.36.36,0,0,1,.36.63l-2.2,1.27A.34.34,0,0,1,114.22,291.33Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,288.71a.37.37,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.36.36,0,0,1,.49.13.35.35,0,0,1-.13.49L119,288.66A.41.41,0,0,1,118.77,288.71Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.32,286.08a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5L123.5,286A.31.31,0,0,1,123.32,286.08Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86,283.46a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49L128,283.41A.37.37,0,0,1,127.86,283.46Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41,280.83a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,132.41,280.83Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,278.2a.36.36,0,0,1-.18-.67l2.19-1.27a.37.37,0,0,1,.5.14.35.35,0,0,1-.14.49l-2.19,1.27A.37.37,0,0,1,137,278.2Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,275.58a.38.38,0,0,1-.32-.18.37.37,0,0,1,.14-.5l2.19-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,141.5,275.58Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,273a.36.36,0,0,1-.18-.67l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.2,1.26A.29.29,0,0,1,146,273Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.59,270.33a.37.37,0,0,1-.18-.68l2.19-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,150.59,270.33Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13,267.7a.38.38,0,0,1-.31-.18A.36.36,0,0,1,155,267l2.2-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,155.13,267.7Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.68,265.07a.34.34,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.14.35.35,0,0,1-.14.49L159.86,265A.39.39,0,0,1,159.68,265.07Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23,262.45a.38.38,0,0,1-.32-.18.37.37,0,0,1,.14-.5l2.19-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,164.23,262.45Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,259.82a.36.36,0,0,1-.18-.67l2.19-1.27a.37.37,0,0,1,.5.13.36.36,0,0,1-.14.5L169,259.77A.29.29,0,0,1,168.77,259.82Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,257.29a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,173.16,257.29Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.54,254.76a.37.37,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.41.41,0,0,1,177.54,254.76Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.92,252.23a.38.38,0,0,1-.31-.18.36.36,0,0,1,.13-.49l1-.61a.38.38,0,0,1,.5.14.35.35,0,0,1-.14.49l-1,.6A.35.35,0,0,1,181.92,252.23Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.67,353.6a.36.36,0,0,1-.36-.36V352a.36.36,0,1,1,.72,0v1.2A.36.36,0,0,1,73.67,353.6Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.67,350.09a.36.36,0,0,1-.36-.36v-2.3a.36.36,0,1,1,.72,0v2.3A.36.36,0,0,1,73.67,350.09Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,73.67,345.48Zm0-4.61a.36.36,0,0,1-.36-.36V338.2a.36.36,0,1,1,.72,0v2.31A.36.36,0,0,1,73.67,340.87Zm0-4.61a.37.37,0,0,1-.36-.37v-2.3a.36.36,0,0,1,.72,0v2.3A.37.37,0,0,1,73.67,336.26Zm0-4.62a.36.36,0,0,1-.36-.36V329a.36.36,0,1,1,.72,0v2.3A.36.36,0,0,1,73.67,331.64Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,73.67,327Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,0,1,.72,0v2.31A.36.36,0,0,1,73.67,322.42Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.67,317.81a.36.36,0,0,1-.36-.36v-1.21a.36.36,0,0,1,.72,0v1.21A.36.36,0,0,1,73.67,317.81Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,292.91a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l1-.6a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-1.05.6A.35.35,0,0,1,182,292.91Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.51,352.66a.35.35,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.41.41,0,0,1,78.51,352.66Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9,350.12a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.36.63l-2.19,1.27A.39.39,0,0,1,82.9,350.12Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.28,347.59a.38.38,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.2-1.27a.36.36,0,1,1,.36.62l-2.2,1.27A.35.35,0,0,1,87.28,347.59Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.67,345.06a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.19-1.26a.37.37,0,0,1,.5.13.36.36,0,0,1-.13.49L91.85,345A.37.37,0,0,1,91.67,345.06Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.06,342.52a.33.33,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.14.35.35,0,0,1-.14.49l-2.19,1.27A.39.39,0,0,1,96.06,342.52Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,339.9a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.2-1.26a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,100.6,339.9Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,337.27a.34.34,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.13.36.36,0,0,1-.14.5l-2.19,1.26A.31.31,0,0,1,105.15,337.27Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7,334.65a.37.37,0,0,1-.32-.19.35.35,0,0,1,.14-.49l2.19-1.26a.35.35,0,0,1,.49.13.36.36,0,0,1-.13.49l-2.19,1.27A.41.41,0,0,1,109.7,334.65Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24,332a.38.38,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.2-1.27a.36.36,0,0,1,.36.62l-2.2,1.27A.37.37,0,0,1,114.24,332Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.79,329.39a.33.33,0,0,1-.31-.18.35.35,0,0,1,.13-.49l2.19-1.27a.35.35,0,0,1,.49.14.36.36,0,0,1-.13.49L119,329.34A.31.31,0,0,1,118.79,329.39Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.33,326.77a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.2-1.26a.35.35,0,0,1,.49.13.36.36,0,0,1-.13.49l-2.2,1.27A.35.35,0,0,1,123.33,326.77Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88,324.14a.34.34,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.13.37.37,0,0,1-.14.5l-2.19,1.26A.31.31,0,0,1,127.88,324.14Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,321.51a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.36.63l-2.19,1.27A.39.39,0,0,1,132.43,321.51Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,318.89a.38.38,0,0,1-.31-.18.36.36,0,0,1,.13-.49L139,317a.37.37,0,0,1,.5.13.36.36,0,0,1-.13.49l-2.2,1.27A.37.37,0,0,1,137,318.89Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52,316.26a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.31.31,0,0,1,141.52,316.26Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,313.64a.38.38,0,0,1-.31-.18.37.37,0,0,1,.13-.5l2.2-1.26a.35.35,0,0,1,.49.13.36.36,0,0,1-.13.49l-2.2,1.27A.37.37,0,0,1,146.06,313.64Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61,311a.33.33,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.36.36,0,0,1,.49.13.34.34,0,0,1-.13.49L150.79,311A.41.41,0,0,1,150.61,311Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.15,308.38a.36.36,0,0,1-.18-.67l2.2-1.27a.36.36,0,0,1,.36.63l-2.19,1.27A.41.41,0,0,1,155.15,308.38Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7,305.76a.37.37,0,0,1-.18-.68l2.19-1.26a.37.37,0,0,1,.5.13.35.35,0,0,1-.14.49l-2.19,1.27A.41.41,0,0,1,159.7,305.76Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.25,303.13a.36.36,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.49.13.37.37,0,0,1-.13.5l-2.19,1.26A.31.31,0,0,1,164.25,303.13Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.79,300.51a.37.37,0,0,1-.31-.19.36.36,0,0,1,.13-.49l2.19-1.26a.36.36,0,1,1,.37.62l-2.2,1.27A.37.37,0,0,1,168.79,300.51Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.18,298a.33.33,0,0,1-.31-.18.36.36,0,0,1,.13-.49l2.19-1.27a.37.37,0,0,1,.5.13.36.36,0,0,1-.14.5l-2.19,1.26A.31.31,0,0,1,173.18,298Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.57,295.44a.38.38,0,0,1-.32-.18.35.35,0,0,1,.14-.49l2.19-1.27a.36.36,0,0,1,.36.62l-2.19,1.27A.41.41,0,0,1,177.57,295.44Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.27,354.52a.36.36,0,0,1-.18-.67l1-.6a.37.37,0,1,1,.37.63l-1,.6A.37.37,0,0,1,75.27,354.52Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,253.74a.36.36,0,0,1-.36-.36v-1.21a.36.36,0,0,1,.72,0v1.21A.36.36,0,0,1,184.6,253.74Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,286a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,1,1,.72,0v2.31A.36.36,0,0,1,184.6,286Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,1,1,.72,0v2.31A.36.36,0,0,1,184.6,281.41Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,1,1,.72,0v2.31A.36.36,0,0,1,184.6,276.8Zm0-4.62a.36.36,0,0,1-.36-.36v-2.3a.36.36,0,1,1,.72,0v2.3A.36.36,0,0,1,184.6,272.18Zm0-4.61a.36.36,0,0,1-.36-.36v-2.3a.36.36,0,1,1,.72,0v2.3A.36.36,0,0,1,184.6,267.57Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,1,1,.72,0v2.31A.36.36,0,0,1,184.6,263Zm0-4.61a.36.36,0,0,1-.36-.36v-2.31a.36.36,0,1,1,.72,0V258A.36.36,0,0,1,184.6,258.35Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,289.53a.36.36,0,0,1-.36-.36V288a.36.36,0,1,1,.72,0v1.2A.36.36,0,0,1,184.6,289.53Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,253.46a.35.35,0,0,1-.18-.05.33.33,0,0,1-.18-.31v-3.7a.33.33,0,0,1,.18-.31l3.2-1.85a.33.33,0,0,1,.36,0,.35.35,0,0,1,.18.31v3.7a.35.35,0,0,1-.18.31l-3.2,1.85A.41.41,0,0,1,183,253.46Zm.36-3.85v2.86l2.48-1.43v-2.87Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,294.15a.34.34,0,0,1-.18,0,.36.36,0,0,1-.18-.32v-3.7a.34.34,0,0,1,.18-.31l3.2-1.85a.38.38,0,0,1,.36,0,.35.35,0,0,1,.18.31v3.7a.38.38,0,0,1-.18.32l-3.2,1.85A.39.39,0,0,1,183,294.15Zm.36-3.85v2.87l2.48-1.43v-2.87Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.07,317.53a.37.37,0,0,1-.18,0,.35.35,0,0,1-.18-.31v-3.7a.35.35,0,0,1,.18-.31l3.2-1.85a.36.36,0,0,1,.54.31v3.7a.33.33,0,0,1-.18.31l-3.2,1.85A.41.41,0,0,1,72.07,317.53Zm.36-3.85v2.86l2.48-1.43v-2.87Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.07,358.23a.37.37,0,0,1-.18-.05.38.38,0,0,1-.18-.32v-3.7a.37.37,0,0,1,.18-.31l3.2-1.85a.38.38,0,0,1,.36,0,.33.33,0,0,1,.18.31V356a.36.36,0,0,1-.18.32l-3.2,1.85A.41.41,0,0,1,72.07,358.23Zm.36-3.86v2.87l2.48-1.43v-2.87Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.21,272a3.85,3.85,0,0,1-1.61,3.08c-.89.52-1.62,0-1.62-1.22a3.86,3.86,0,0,1,1.62-3.08C185.49,270.28,186.21,270.83,186.21,272Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,280a3.88,3.88,0,0,1-1.61,3.09c-.89.51-1.62,0-1.62-1.22a3.89,3.89,0,0,1,1.62-3.09C132.2,278.29,132.92,278.84,132.92,280Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,320.72a3.85,3.85,0,0,1-1.61,3.08c-.89.52-1.62,0-1.62-1.22a3.86,3.86,0,0,1,1.62-3.08C132.2,319,132.92,319.53,132.92,320.72Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.28,336.14a3.88,3.88,0,0,1-1.61,3.09c-.89.51-1.61,0-1.61-1.22a3.88,3.88,0,0,1,1.61-3.09C74.56,334.41,75.28,335,75.28,336.14Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,286.14A.31.31,0,0,1,135,286a.31.31,0,0,1,.11-.41l45.62-26.34a.3.3,0,1,1,.3.52L135.44,286.1A.28.28,0,0,1,135.29,286.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,288.92a.3.3,0,0,1-.26-.15.29.29,0,0,1,.11-.4L180.76,262a.31.31,0,0,1,.41.11.29.29,0,0,1-.11.4l-45.62,26.34A.28.28,0,0,1,135.29,288.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,291.7a.32.32,0,0,1-.26-.15.29.29,0,0,1,.11-.4l45.62-26.34a.3.3,0,0,1,.41.11.29.29,0,0,1-.11.4l-45.62,26.34A.42.42,0,0,1,135.29,291.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,294.47a.31.31,0,0,1-.26-.14.31.31,0,0,1,.11-.41l45.62-26.34a.3.3,0,1,1,.3.52l-45.62,26.33A.28.28,0,0,1,135.29,294.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,297.25a.3.3,0,0,1-.26-.15.29.29,0,0,1,.11-.4l45.62-26.34a.31.31,0,0,1,.41.11.29.29,0,0,1-.11.4l-45.62,26.34A.28.28,0,0,1,135.29,297.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,300a.3.3,0,0,1-.26-.15.29.29,0,0,1,.11-.4L156.78,287a.31.31,0,0,1,.41.11.29.29,0,0,1-.11.4L135.44,300A.28.28,0,0,1,135.29,300Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,306.42a.31.31,0,0,1-.26-.14.3.3,0,0,1,.11-.41l45.62-26.34a.3.3,0,1,1,.3.52l-45.62,26.33A.28.28,0,0,1,135.29,306.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,309.2a.3.3,0,0,1-.26-.15.29.29,0,0,1,.11-.4l45.62-26.34a.3.3,0,0,1,.41.11.29.29,0,0,1-.11.4l-45.62,26.34A.28.28,0,0,1,135.29,309.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,312a.32.32,0,0,1-.26-.15.29.29,0,0,1,.11-.4l45.62-26.34a.3.3,0,1,1,.3.51l-45.62,26.34A.42.42,0,0,1,135.29,312Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,314.75a.31.31,0,0,1-.26-.14.3.3,0,0,1,.11-.41l21.64-12.49a.3.3,0,1,1,.3.51l-21.64,12.49A.28.28,0,0,1,135.29,314.75Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.19,281.78a.24.24,0,0,1-.12,0,.22.22,0,0,1-.12-.21v-42a.25.25,0,0,1,.12-.21l33.78-19.5a.25.25,0,0,1,.24,0,.24.24,0,0,1,.12.21v42a.27.27,0,0,1-.12.21l-33.78,19.5Zm.24-42.11v41.46l33.3-19.23V220.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.79,262.28a.21.21,0,0,1-.12,0,.25.25,0,0,1-.12-.21V241a.25.25,0,0,1,.12-.21l28.58-16.5a.26.26,0,0,1,.24,0,.24.24,0,0,1,.12.21v21a.24.24,0,0,1-.12.21l-28.58,16.51Zm.24-21.11v20.45l28.1-16.23V224.94Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,264.88l7.24-4.18c.16-.09.28,0,.28.16v.86a.61.61,0,0,1-.28.48l-7.24,4.18c-.15.09-.27,0-.27-.16v-.86A.61.61,0,0,1,207.06,264.88Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,267.88l27.16-15.64c.15-.09.28,0,.28.16v.86a.62.62,0,0,1-.28.48l-27.16,15.64c-.15.09-.27,0-.27-.16v-.86A.61.61,0,0,1,207.06,267.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,273.88l27.16-15.64c.15-.09.28,0,.28.16v.86a.62.62,0,0,1-.28.48l-27.16,15.64c-.15.09-.27,0-.27-.16v-.86A.61.61,0,0,1,207.06,273.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,270.88l27.16-15.64c.15-.09.28,0,.28.16v.86a.62.62,0,0,1-.28.48l-27.16,15.64c-.15.09-.27,0-.27-.16v-.86A.61.61,0,0,1,207.06,270.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.37,245.77h0l-9.94-1.56a.25.25,0,0,1-.2-.28.23.23,0,0,1,.27-.2l9.95,1.57a.24.24,0,0,1,0,.47Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.74,242.84h0l-9.95-1.57a.24.24,0,0,1-.2-.27.22.22,0,0,1,.27-.2l10,1.56a.25.25,0,0,1,.2.28A.23.23,0,0,1,216.74,242.84Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.79,262.28a.25.25,0,0,1-.15,0,.23.23,0,0,1,0-.34l9.94-13a.24.24,0,0,1,.33,0,.23.23,0,0,1,0,.33L207,262.18A.26.26,0,0,1,206.79,262.28Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.41,237.84a.3.3,0,0,1-.15-.05.25.25,0,0,1,0-.34l10-13.07a.24.24,0,0,1,.38.3l-10,13.06A.23.23,0,0,1,225.41,237.84Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.08,241.78A2.78,2.78,0,0,0,220,244c0,.89.47,1.34,1.05,1a2.76,2.76,0,0,0,1-2.21C222.12,241.9,221.65,241.45,221.08,241.78Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.32,239.06l-.79.47v-.42c0-.27-.14-.4-.32-.3l-2.27,1.31a.82.82,0,0,0-.31.66v.42l-.8.46a1.71,1.71,0,0,0-.65,1.37v4.07c0,.55.29.83.65.62l4.49-2.59a1.71,1.71,0,0,0,.65-1.37v-4.07C224,239.14,223.68,238.86,223.32,239.06Zm-2.24,6.75c-.87.49-1.57-.18-1.57-1.51a4.13,4.13,0,0,1,1.57-3.32c.86-.5,1.56.18,1.56,1.51A4.15,4.15,0,0,1,221.08,245.81Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.76,257.78a.19.19,0,0,1-.12,0,.24.24,0,0,1-.12-.2v-42a.24.24,0,0,1,.12-.21l33.79-19.5a.21.21,0,0,1,.24,0,.24.24,0,0,1,.12.2v42a.24.24,0,0,1-.12.21l-33.79,19.5A.16.16,0,0,1,245.76,257.78Zm.24-42.11v41.45l33.31-19.23V196.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,238.27a.27.27,0,0,1-.12,0,.24.24,0,0,1-.12-.21V217a.24.24,0,0,1,.12-.21l28.59-16.5a.21.21,0,0,1,.24,0,.24.24,0,0,1,.12.2v21a.27.27,0,0,1-.12.21l-28.59,16.5A.24.24,0,0,1,248.36,238.27Zm.24-21.1v20.45l28.11-16.23V200.94Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.64,240.87l7.24-4.18a.17.17,0,0,1,.28.16v.86a.62.62,0,0,1-.28.48l-7.24,4.18c-.15.09-.28,0-.28-.16v-.86A.64.64,0,0,1,248.64,240.87Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.64,243.87l27.16-15.64a.17.17,0,0,1,.28.16v.86a.61.61,0,0,1-.28.48l-27.16,15.64c-.15.09-.28,0-.28-.16v-.86A.64.64,0,0,1,248.64,243.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.64,249.88l27.16-15.64c.15-.09.28,0,.28.16v.86a.64.64,0,0,1-.28.48l-27.16,15.64c-.15.08-.28,0-.28-.16v-.86A.61.61,0,0,1,248.64,249.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.64,246.87l27.16-15.64c.15-.08.28,0,.28.16v.86a.61.61,0,0,1-.28.48l-27.16,15.64c-.15.09-.28,0-.28-.16v-.86A.64.64,0,0,1,248.64,246.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.65,214.78a8.6,8.6,0,0,0-3.89,6.75c0,2.48,1.74,3.49,3.89,2.25a8.6,8.6,0,0,0,3.9-6.75C266.55,214.54,264.81,213.53,262.65,214.78Zm2,3.65-2.9,3.47c-.29.34-.52.26-.52-.18v-3.27a.76.76,0,0,1,.8-.76l2.34.09C264.85,217.8,265,218.09,264.69,218.43Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.17,126.86a1.59,1.59,0,0,0-1.44.2L77.94,217.42a4.8,4.8,0,0,0-2.16,3.75v9.07a1.56,1.56,0,0,0,.59,1.38c-.37-.24-3.64-2.09-4-2.33a1.54,1.54,0,0,1-.62-1.39v-9.07a4.78,4.78,0,0,1,2.17-3.75l156.78-90.37a1.53,1.53,0,0,1,1.55-.14C232.56,124.78,235.4,126.39,236.17,126.86Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.94,217.42l156.79-90.36c1.19-.69,2.16-.13,2.16,1.25v9.07a4.8,4.8,0,0,1-2.16,3.75L77.94,231.49c-1.2.69-2.17.13-2.17-1.25v-9.07A4.78,4.78,0,0,1,77.94,217.42Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.41,219l-4.06-2.35a4.37,4.37,0,0,0-.64,2.14v9.07a1.54,1.54,0,0,0,.62,1.39c.4.24,3.67,2.09,4,2.33a1.56,1.56,0,0,1-.59-1.38v-9.07A4.4,4.4,0,0,1,76.41,219Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.17,126.86c-.77-.47-3.61-2.08-4-2.29a1.53,1.53,0,0,0-1.55.14L73.88,215.08a4.32,4.32,0,0,0-1.53,1.61L76.41,219a4.35,4.35,0,0,1,1.53-1.62l156.79-90.36A1.59,1.59,0,0,1,236.17,126.86Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.77,137.53a4.64,4.64,0,0,1-2.17,3.6l-52.54,30.33c-1.19.69-2.16.2-2.16-1.09a4.65,4.65,0,0,1,2.16-3.6l52.54-30.33C227.8,135.75,228.77,136.24,228.77,137.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247,123.92l84-48.48c1.08-.62,1.95-.11,1.95,1.13v75.8a4.31,4.31,0,0,1-1.95,3.38l-84,48.48c-1.08.62-1.95.11-1.95-1.13V127.3A4.31,4.31,0,0,1,247,123.92Z",
    style: {
      fill: "#e6e6e6",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.44,137.05a5.19,5.19,0,0,0-.56-.89,3,3,0,0,0-.34-.37,3.7,3.7,0,0,0-1-.77,3.2,3.2,0,0,0-.6-.26,4.87,4.87,0,0,0-1.77-.23,3.59,3.59,0,0,0-.65.07l-.47.09-.46.11L281,135l-.46.19a4.41,4.41,0,0,1,0,.52v.06c0,.1,0,.2,0,.31s0,.2,0,.31c0,5.56-3.91,12.33-8.72,15.11a9,9,0,0,1-1.06.55h0a2.13,2.13,0,0,0,.06.45l0,.19c0,.17.07.33.11.49a2.23,2.23,0,0,0,.13.44,3.24,3.24,0,0,0,.16.47c.06.14.11.26.17.38a4.48,4.48,0,0,0,.61,1,4.39,4.39,0,0,0,.67.69l.07,0,.32.23.06,0a3.11,3.11,0,0,0,.4.22c.14.06.3.13.45.18a5.55,5.55,0,0,0,3.37,0c.32-.1.66-.23,1-.37s.69-.34,1-.54c4.82-2.78,8.73-9.54,8.73-15.11A8.08,8.08,0,0,0,287.44,137.05Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.53,127.32l-.89,1.77a1.27,1.27,0,0,0,.08,1.12,10.47,10.47,0,0,1,1,2.27.56.56,0,0,0,.77.36l4.6-2.07a.42.42,0,0,1,.36,0Zm-5.69-9.69-3.33-1.93a.66.66,0,0,0-.24,0,1.52,1.52,0,0,0-.21,0,.28.28,0,0,0-.13,0,1.84,1.84,0,0,0-.22.17s-.09,0-.11.09L280.88,120l-3.43-2-.07,0-2.49-1.43h0l-.12,0a.54.54,0,0,0-.26.07l-3.55,2.06-.41.23h0l-1.12.64-.07,0a.94.94,0,0,0-.2.16,1.61,1.61,0,0,0-.32.48h0a.91.91,0,0,0-.09.31l-.52,5.75a.29.29,0,0,1,0,.09,1.18,1.18,0,0,1-.08.31,1.89,1.89,0,0,1-.43.67,30.82,30.82,0,0,0-2.88,3,1,1,0,0,1-.43.27.92.92,0,0,1-.59,0l-3.3-1.17a1,1,0,0,0-.25,0l-.07,0-.07,0-.07,0-.12,0-.14.07a.39.39,0,0,0-.1.08.44.44,0,0,0-.12.15l-1.56,2.7-1.65,2.86-.59,1a.82.82,0,0,0-.09.51h0a.75.75,0,0,0,.25.46l2.66,2.3a.86.86,0,0,1,.13.14,1,1,0,0,1,.18.53,1.21,1.21,0,0,1-.05.34,29.29,29.29,0,0,0-1.19,4,1.92,1.92,0,0,1-.32.64,1.56,1.56,0,0,1-.35.37l-4.71,3.32a.65.65,0,0,0-.17.16c-.06.07-.1.15-.16.23h0a1.37,1.37,0,0,0-.2.63v6a.42.42,0,0,0,.18.38l6,3.46-2.18,4.4a.68.68,0,0,0,.27.89l8.13,4.72.11,0-.1-.05-.54-.32a.69.69,0,0,1-.28-.9l3.07-6.18a.91.91,0,0,0,.07-.25,1.32,1.32,0,0,0-.14-.86,10.33,10.33,0,0,1-1-2.28.55.55,0,0,0-.77-.36l-2.31,1-2.28,1a.42.42,0,0,1-.41,0h0a.41.41,0,0,1-.17-.38v-6a1.2,1.2,0,0,1,.2-.63,1.1,1.1,0,0,1,.32-.38l4.73-3.33a1.69,1.69,0,0,0,.34-.36,1.72,1.72,0,0,0,.31-.64,32,32,0,0,1,1.2-4,.92.92,0,0,0,.06-.33h0a1,1,0,0,0-.32-.69l-2.66-2.28a.79.79,0,0,1-.24-.46.75.75,0,0,1,.07-.53l1.08-1.87,1.35-2.33,1.37-2.37a.76.76,0,0,1,.59-.37h0a.73.73,0,0,1,.33,0l3.32,1.16a.92.92,0,0,0,.59,0,1,1,0,0,0,.43-.28,31.86,31.86,0,0,1,2.86-3,1.82,1.82,0,0,0,.44-.67,1.67,1.67,0,0,0,.1-.4l.52-5.75a.73.73,0,0,1,.09-.31,1.3,1.3,0,0,1,.53-.66l1-.55,2.08-1.21,2.11-1.22a.43.43,0,0,1,.39,0l0,0a.39.39,0,0,1,.2.35l.27,2.63.24,2.39a.54.54,0,0,0,.68.48,9.53,9.53,0,0,1,2.49-.25,1.28,1.28,0,0,0,.72-.23,1.45,1.45,0,0,0,.28-.27l3.82-5.74a.55.55,0,0,1,.12-.14.69.69,0,0,1,.6-.15.38.38,0,0,1,.15,0ZM276.4,170.57a.25.25,0,0,1-.08-.12.71.71,0,0,1,0-.17l-.5-5a.53.53,0,0,0-.69-.48,10.42,10.42,0,0,1-2.49.25,1.3,1.3,0,0,0-1,.49l-1.1,1.65,5.9,3.41Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06,120.07a.38.38,0,0,0-.15,0,.69.69,0,0,0-.6.15.55.55,0,0,0-.12.14l-3.82,5.74a1.45,1.45,0,0,1-.28.27,1.28,1.28,0,0,1-.72.23,9.53,9.53,0,0,0-2.49.25.54.54,0,0,1-.68-.48l-.24-2.39-.27-2.63a.39.39,0,0,0-.2-.35l0,0a.43.43,0,0,0-.39,0L280,122.19l-2.08,1.21-1,.55a1.3,1.3,0,0,0-.53.66.73.73,0,0,0-.09.31l-.52,5.75a1.67,1.67,0,0,1-.1.4,1.82,1.82,0,0,1-.44.67,31.86,31.86,0,0,0-2.86,3,1,1,0,0,1-.43.28.92.92,0,0,1-.59,0L268,133.91a.73.73,0,0,0-.33,0h0a.76.76,0,0,0-.59.37l-1.37,2.37L264.38,139l-1.08,1.87a.75.75,0,0,0-.07.53.79.79,0,0,0,.24.46l2.66,2.28a1,1,0,0,1,.32.69h0a.92.92,0,0,1-.06.33,32,32,0,0,0-1.2,4,1.72,1.72,0,0,1-.31.64,1.69,1.69,0,0,1-.34.36l-4.73,3.33a1.1,1.1,0,0,0-.32.38,1.2,1.2,0,0,0-.2.63v6a.41.41,0,0,0,.17.38h0a.42.42,0,0,0,.41,0l2.28-1,2.31-1a.55.55,0,0,1,.77.36,10.33,10.33,0,0,0,1,2.28,1.32,1.32,0,0,1,.14.86.91.91,0,0,1-.07.25l-3.07,6.18a.69.69,0,0,0,.28.9l.54.32.1.05-.11,0L256,165.18a.68.68,0,0,1-.27-.89l2.18-4.4-6-3.46a.42.42,0,0,1-.18-.38v-6a1.37,1.37,0,0,1,.2-.63h0c.06-.08.1-.16.16-.23a.65.65,0,0,1,.17-.16l4.71-3.32a1.56,1.56,0,0,0,.35-.37,1.92,1.92,0,0,0,.32-.64,29.29,29.29,0,0,1,1.19-4,1.21,1.21,0,0,0,.05-.34,1,1,0,0,0-.18-.53.86.86,0,0,0-.13-.14l-2.66-2.3a.75.75,0,0,1-.25-.46h0a.82.82,0,0,1,.09-.51l.59-1,1.65-2.86.45-.79,1.14-2a.7.7,0,0,1,.84-.3h.07l3,1.08h0l.26.09a.92.92,0,0,0,.59,0,1,1,0,0,0,.43-.27,30.82,30.82,0,0,1,2.88-3,1.89,1.89,0,0,0,.43-.67,1.18,1.18,0,0,0,.08-.31.29.29,0,0,0,0-.09l.52-5.75a.91.91,0,0,1,.09-.31h0a1.61,1.61,0,0,1,.32-.48,1.65,1.65,0,0,1,.27-.21l1.12-.64h0l.41-.23,3.55-2.06a.54.54,0,0,1,.26-.07l.12,0h0l2.49,1.43.07,0,3.43,2,2.72-4.08c0-.05.08-.05.11-.09a1.84,1.84,0,0,1,.22-.17.28.28,0,0,1,.13,0,1.52,1.52,0,0,1,.21,0,.66.66,0,0,1,.24,0l3.33,1.93Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.32,170.45a.71.71,0,0,1,0-.17l-.5-5a.53.53,0,0,0-.69-.48,10.42,10.42,0,0,1-2.49.25,1.3,1.3,0,0,0-1,.49l-1.1,1.65,5.9,3.41v0A.25.25,0,0,1,276.32,170.45Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.53,127.32l-.89,1.77a1.27,1.27,0,0,0,.08,1.12,10.47,10.47,0,0,1,1,2.27.56.56,0,0,0,.77.36l4.6-2.07a.42.42,0,0,1,.36,0Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.38,124.61a.73.73,0,0,0-.09.31l-.52,5.75a1.67,1.67,0,0,1-.1.4l-7.59-4.38h0a2.11,2.11,0,0,0,.1-.3.29.29,0,0,0,0-.09l.52-5.75a1.21,1.21,0,0,1,.09-.31Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.45,144.79l-7.6-4.39,0,0a1,1,0,0,0-.14-.51.86.86,0,0,0-.13-.14l-2.66-2.3a.75.75,0,0,1-.25-.46l7.6,4.39a.79.79,0,0,0,.24.46l2.66,2.28A1,1,0,0,1,266.45,144.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.27,168.67a.69.69,0,0,0,.28.9l.54.32h0L256,165.18a.68.68,0,0,1-.27-.89l2.18-4.4,1.6.92h0a.42.42,0,0,0,.41,0l2.28-1,4.25,2.46a.91.91,0,0,1-.07.25Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.4,170.57v0l-5.9-3.41,1.1-1.65a1.3,1.3,0,0,1,1-.49,10.42,10.42,0,0,0,2.49-.25.53.53,0,0,1,.69.48l.5,5a.71.71,0,0,0,0,.17A.25.25,0,0,0,276.4,170.57Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.22,140.75c0,5.57-3.91,12.33-8.73,15.11-.35.2-.7.38-1,.54s-.68.27-1,.37a5.55,5.55,0,0,1-3.37,0c-.15,0-.31-.12-.45-.18a3.11,3.11,0,0,1-.4-.22l-.06,0-.32-.23-.07,0a4.39,4.39,0,0,1-.67-.69,4.48,4.48,0,0,1-.61-1c-.06-.12-.11-.24-.17-.38a3.24,3.24,0,0,1-.16-.47,2.23,2.23,0,0,1-.13-.44c0-.16-.08-.32-.11-.49l0-.19a2.13,2.13,0,0,1-.06-.45h0a9,9,0,0,0,1.06-.55c4.81-2.78,8.72-9.55,8.72-15.11,0-.11,0-.2,0-.31s0-.21,0-.31v-.06a4.38,4.38,0,0,0,0-.52h0L281,135l.52-.18.46-.11.47-.09a3.59,3.59,0,0,1,.65-.07,4.87,4.87,0,0,1,1.77.23,3.2,3.2,0,0,1,.6.26,3.7,3.7,0,0,1,1,.77,3,3,0,0,1,.34.37,5.19,5.19,0,0,1,.56.89A8.08,8.08,0,0,1,288.22,140.75Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.46,130.74a.42.42,0,0,0-.36,0l-4.6,2.07a.56.56,0,0,1-.77-.36,10.47,10.47,0,0,0-1-2.27,1.27,1.27,0,0,1-.08-1.12l.89-1.77Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06,120.07a.38.38,0,0,0-.15,0,.69.69,0,0,0-.6.15.81.81,0,0,0-.12.14l-3.82,5.74a1.45,1.45,0,0,1-.28.27L285,125.08l-2-1.15-.27-2.63a.39.39,0,0,0-.2-.35l0,0-1.58-.92,2.72-4.08a.61.61,0,0,1,.33-.26.28.28,0,0,1,.13,0,.59.59,0,0,1,.45.06l3.33,1.93Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.88,149.77a1.69,1.69,0,0,1-.34.36l-4.73,3.33a1.1,1.1,0,0,0-.32.38l-7.59-4.38a1.88,1.88,0,0,1,.16-.23.65.65,0,0,1,.17-.16l4.71-3.32a1.56,1.56,0,0,0,.35-.37Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,120.94h0l0,0Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,120.94h0l0,0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.69,137.11v-6a.39.39,0,0,0-.59-.38l-4.6,2.07a.55.55,0,0,1-.76-.36,10.81,10.81,0,0,0-1-2.28,1.24,1.24,0,0,1-.07-1.11l3.07-6.18a.71.71,0,0,0-.28-.9l-3.32-1.92a.7.7,0,0,0-.92.22l-3.82,5.74a1.25,1.25,0,0,1-1,.5,10.29,10.29,0,0,0-2.48.25.54.54,0,0,1-.69-.49l-.51-5a.38.38,0,0,0-.62-.31l-5.16,3a1.39,1.39,0,0,0-.62,1l-.52,5.75a1.86,1.86,0,0,1-.54,1.07,31.86,31.86,0,0,0-2.86,3,1,1,0,0,1-1,.29L268,133.91a.81.81,0,0,0-.93.35l-3.79,6.57a.8.8,0,0,0,.16,1l2.66,2.29a1,1,0,0,1,.26,1,30.32,30.32,0,0,0-1.19,4,1.86,1.86,0,0,1-.67,1l-4.71,3.32a1.38,1.38,0,0,0-.53,1v6a.38.38,0,0,0,.59.38l4.59-2.07a.56.56,0,0,1,.77.36,10.8,10.8,0,0,0,1,2.28,1.24,1.24,0,0,1,.07,1.11l-3.06,6.18a.69.69,0,0,0,.27.9l3.33,1.92a.68.68,0,0,0,.91-.22l3.82-5.74a1.31,1.31,0,0,1,1-.5,9.93,9.93,0,0,0,2.49-.25.55.55,0,0,1,.69.49l.5,5a.39.39,0,0,0,.63.32l5.16-3a1.42,1.42,0,0,0,.62-1l.51-5.75a2,2,0,0,1,.54-1.07,30.73,30.73,0,0,0,2.87-3,1,1,0,0,1,1-.29l3.31,1.16a.81.81,0,0,0,.93-.34l3.8-6.58a.81.81,0,0,0-.17-1l-2.66-2.29a1,1,0,0,1-.26-1,30.38,30.38,0,0,0,1.2-4,1.9,1.9,0,0,1,.66-1l4.72-3.32A1.41,1.41,0,0,0,299.69,137.11Zm-20.2,18.76c-4.82,2.78-8.73.52-8.73-5s3.91-12.33,8.73-15.12,8.72-.52,8.72,5S284.31,153.08,279.49,155.87Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.69,137.11v-6a.39.39,0,0,0-.59-.38l-4.6,2.07a.55.55,0,0,1-.76-.36,10.81,10.81,0,0,0-1-2.28,1.24,1.24,0,0,1-.07-1.11l3.07-6.18a.71.71,0,0,0-.28-.9l-3.32-1.92a.7.7,0,0,0-.92.22l-3.82,5.74a1.25,1.25,0,0,1-1,.5,10.29,10.29,0,0,0-2.48.25.54.54,0,0,1-.69-.49l-.51-5a.38.38,0,0,0-.62-.31l-5.16,3a1.39,1.39,0,0,0-.62,1l-.52,5.75a1.86,1.86,0,0,1-.54,1.07,31.86,31.86,0,0,0-2.86,3,1,1,0,0,1-1,.29L268,133.91a.81.81,0,0,0-.93.35l-3.79,6.57a.8.8,0,0,0,.16,1l2.66,2.29a1,1,0,0,1,.26,1,30.32,30.32,0,0,0-1.19,4,1.86,1.86,0,0,1-.67,1l-4.71,3.32a1.38,1.38,0,0,0-.53,1v6a.38.38,0,0,0,.59.38l4.59-2.07a.56.56,0,0,1,.77.36,10.8,10.8,0,0,0,1,2.28,1.24,1.24,0,0,1,.07,1.11l-3.06,6.18a.69.69,0,0,0,.27.9l3.33,1.92a.68.68,0,0,0,.91-.22l3.82-5.74a1.31,1.31,0,0,1,1-.5,9.93,9.93,0,0,0,2.49-.25.55.55,0,0,1,.69.49l.5,5a.39.39,0,0,0,.63.32l5.16-3a1.42,1.42,0,0,0,.62-1l.51-5.75a2,2,0,0,1,.54-1.07,30.73,30.73,0,0,0,2.87-3,1,1,0,0,1,1-.29l3.31,1.16a.81.81,0,0,0,.93-.34l3.8-6.58a.81.81,0,0,0-.17-1l-2.66-2.29a1,1,0,0,1-.26-1,30.38,30.38,0,0,0,1.2-4,1.9,1.9,0,0,1,.66-1l4.72-3.32A1.41,1.41,0,0,0,299.69,137.11Zm-20.2,18.76c-4.82,2.78-8.73.52-8.73-5s3.91-12.33,8.73-15.12,8.72-.52,8.72,5S284.31,153.08,279.49,155.87Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.88,130.51l-1.78-1a.72.72,0,0,0-.56.34l-1.14,2h0l-.45.79-1.65,2.86-.59,1a.82.82,0,0,0-.09.51h0l7.6,4.39a.75.75,0,0,1,.07-.53l1.08-1.87,1.35-2.33,1.37-2.37a.76.76,0,0,1,.59-.37Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.88,130.51l-1.78-1a.72.72,0,0,0-.56.34l-1.14,2h0l-.45.79-1.65,2.86-.59,1a.82.82,0,0,0-.09.51h0l7.6,4.39a.75.75,0,0,1,.07-.53l1.08-1.87,1.35-2.33,1.37-2.37a.76.76,0,0,1,.59-.37Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.34,130.67a1,1,0,0,1-.59,0l-.26-.09h0l-3-1.07h0l-.06,0a.67.67,0,0,0-.28,0l.1.06h0l1.68,1,.57.33h0l5.24,3h0a.73.73,0,0,1,.33,0l3.32,1.16a.92.92,0,0,0,.59,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.46,120.93a.43.43,0,0,0-.39,0L280,122.19l-2.08,1.21-1,.55a1.3,1.3,0,0,0-.53.66l-7.59-4.38h0a1.61,1.61,0,0,1,.32-.48.94.94,0,0,1,.2-.16l.07,0,1.12-.64h0l.41-.23,3.55-2.06a.54.54,0,0,1,.26-.07l.12,0h0l2.49,1.43.07,0,3.43,2Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.46,120.93a.43.43,0,0,0-.39,0L280,122.19l-2.08,1.21-1,.55a1.3,1.3,0,0,0-.53.66l-7.59-4.38h0a1.61,1.61,0,0,1,.32-.48.94.94,0,0,1,.2-.16l.07,0,1.12-.64h0l.41-.23,3.55-2.06a.54.54,0,0,1,.26-.07l.12,0h0l2.49,1.43.07,0,3.43,2Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.56,140.94a2.85,2.85,0,0,0-2.22-1.76H319a4.23,4.23,0,0,0-2,.42c0,.24,0,.5,0,.77a12.49,12.49,0,0,1-5.67,9.82c-.22.13-.45.25-.66.35a4.6,4.6,0,0,0,.38,1.48,2.85,2.85,0,0,0,2.66,1.79H314l.3,0a1.18,1.18,0,0,0,.25,0,.35.35,0,0,0,.11,0l.15,0a8,8,0,0,0,3.68-2.38C321.38,148.21,322.75,143.59,321.56,140.94Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.49,151.27a8,8,0,0,1-3.68,2.38l-.15,0a.35.35,0,0,1-.11,0,1.18,1.18,0,0,1-.25,0l-.3,0h-.26a2.85,2.85,0,0,1-2.66-1.79,4.6,4.6,0,0,1-.38-1.48c.21-.1.44-.22.66-.35a12.49,12.49,0,0,0,5.67-9.82c0-.27,0-.53,0-.77a4.23,4.23,0,0,1,2-.42h.33a2.85,2.85,0,0,1,2.22,1.76C322.75,143.59,321.38,148.21,318.49,151.27Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.28,159.28l-1.46-2.21c-.09-.15-.37-.14-.6,0a10,10,0,0,1-.85.54l2.93,1.69A.05.05,0,0,1,319.28,159.28Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,141a11.17,11.17,0,0,1-.06,1.14c0,.2.16.37.41.39l2.42.14a.34.34,0,0,1,.18,0Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09,158.64a5.08,5.08,0,0,1-1.23-.72.5.5,0,0,0-.63.11l-2.89,2.64a.48.48,0,0,1-.31.14l2.83,1.63,1.75,1a.26.26,0,0,1-.12-.28l.89-4A.44.44,0,0,0,310.09,158.64Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.63,160.62l.06,0,.17.1,0,0a.17.17,0,0,1-.06-.08l-1.29-2.84a.49.49,0,0,1,0-.34,1,1,0,0,1,.16-.33l2.71-3.27a1.53,1.53,0,0,0,.24-.5.58.58,0,0,0,0-.22,12.21,12.21,0,0,1,0-2.34.39.39,0,0,0-.41-.38l-2.42-.15c-.25,0-.4-.19-.34-.4l1.34-4.49a.92.92,0,0,1,.6-.51l2.65-.64a1.13,1.13,0,0,0,.68-.49,24.41,24.41,0,0,1,1.42-2.48.93.93,0,0,0,.1-.2.42.42,0,0,0,0-.12l0-.13a.51.51,0,0,0,0-.25l-.86-2.92a.59.59,0,0,1,0-.34,1.42,1.42,0,0,1,.08-.18l.13-.17,3.1-3.27c.14-.14.3-.2.41-.14h0a.16.16,0,0,1,.08.06l1.44,2.21c.1.15.37.14.61,0a12.1,12.1,0,0,1,1.75-1,1.39,1.39,0,0,0,.62-.6l1.52-4.1a.39.39,0,0,1,.06-.11.85.85,0,0,1,.39-.28l.07,0,.1,0,2.82-.29h.07l.1,0a.15.15,0,0,1,.1,0,.22.22,0,0,1,.12.28l-.88,4a.46.46,0,0,0,.29.51,4.47,4.47,0,0,1,1.23.71.5.5,0,0,0,.63-.11l2.89-2.63c.15-.13.3-.18.41-.13L322,128.86a.19.19,0,0,0-.1,0c-.31-.17-.66-.38-1-.6h0l-1.13-.64-.45-.27-1-.59-.16-.1-.79-.45a.39.39,0,0,0-.28-.05l-2.82.28a.3.3,0,0,0-.13,0l-.12,0-.13.07-.09.08a.46.46,0,0,0-.14.21l-1.54,4.1a.19.19,0,0,1-.05.1.67.67,0,0,1-.11.14,1,1,0,0,1-.14.15l0,0a.38.38,0,0,1-.13.09l-.16.1c-.3.14-.58.3-.89.47l-3-1.71-.05,0a.24.24,0,0,0-.24,0,.39.39,0,0,0-.17.11h0l-2.2,2.32-.9.95a1.1,1.1,0,0,0-.14.18,1.89,1.89,0,0,0-.09.21.51.51,0,0,0,0,.24.43.43,0,0,1,0,0l.87,2.92a.73.73,0,0,1,0,.26.29.29,0,0,1,0,.09v0s0,0,0,0a1.18,1.18,0,0,1-.12.28,24.35,24.35,0,0,0-1.43,2.47,1.1,1.1,0,0,1-.67.51l-2.65.64a.85.85,0,0,0-.6.49l-1.34,4.5a.28.28,0,0,0,.11.32s1.18.7,2,1.19l1,.55c0,.42,0,.82.05,1.21v0a1.37,1.37,0,0,1,0,.19.8.8,0,0,1-.07.2,2,2,0,0,1-.17.29L298,153.88a.84.84,0,0,0-.16.33.67.67,0,0,0,0,.18.41.41,0,0,0,0,.16l1.28,2.84a.28.28,0,0,0,.09.1h0l.82.47c.11.07.25.14.38.23l3.45,2a4.27,4.27,0,0,1,.38.22l.21.12",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.63,160.62l.06,0,.17.1,0,0a.17.17,0,0,1-.06-.08l-1.29-2.84a.49.49,0,0,1,0-.34,1,1,0,0,1,.16-.33l2.71-3.27a1.53,1.53,0,0,0,.24-.5.58.58,0,0,0,0-.22,12.21,12.21,0,0,1,0-2.34.39.39,0,0,0-.41-.38l-2.42-.15c-.25,0-.4-.19-.34-.4l1.34-4.49a.92.92,0,0,1,.6-.51l2.65-.64a1.13,1.13,0,0,0,.68-.49,24.41,24.41,0,0,1,1.42-2.48.93.93,0,0,0,.1-.2.42.42,0,0,0,0-.12l0-.13a.51.51,0,0,0,0-.25l-.86-2.92a.59.59,0,0,1,0-.34,1.42,1.42,0,0,1,.08-.18l.13-.17,3.1-3.27c.14-.14.3-.2.41-.14h0a.16.16,0,0,1,.08.06l1.44,2.21c.1.15.37.14.61,0a12.1,12.1,0,0,1,1.75-1,1.39,1.39,0,0,0,.62-.6l1.52-4.1a.39.39,0,0,1,.06-.11.85.85,0,0,1,.39-.28l.07,0,.1,0,2.82-.29h.07l.1,0a.15.15,0,0,1,.1,0,.22.22,0,0,1,.12.28l-.88,4a.46.46,0,0,0,.29.51,4.47,4.47,0,0,1,1.23.71.5.5,0,0,0,.63-.11l2.89-2.63c.15-.13.3-.18.41-.13L322,128.86a.19.19,0,0,0-.1,0c-.31-.17-.66-.38-1-.6h0l-1.13-.64-.45-.27-1-.59-.16-.1-.79-.45a.39.39,0,0,0-.28-.05l-2.82.28a.3.3,0,0,0-.13,0l-.12,0-.13.07-.09.08a.46.46,0,0,0-.14.21l-1.54,4.1a.19.19,0,0,1-.05.1.67.67,0,0,1-.11.14,1,1,0,0,1-.14.15l0,0a.38.38,0,0,1-.13.09l-.16.1c-.3.14-.58.3-.89.47l-3-1.71-.05,0a.24.24,0,0,0-.24,0,.39.39,0,0,0-.17.11h0l-2.2,2.32-.9.95a1.1,1.1,0,0,0-.14.18,1.89,1.89,0,0,0-.09.21.51.51,0,0,0,0,.24.43.43,0,0,1,0,0l.87,2.92a.73.73,0,0,1,0,.26.29.29,0,0,1,0,.09v0s0,0,0,0a1.18,1.18,0,0,1-.12.28,24.35,24.35,0,0,0-1.43,2.47,1.1,1.1,0,0,1-.67.51l-2.65.64a.85.85,0,0,0-.6.49l-1.34,4.5a.28.28,0,0,0,.11.32s1.18.7,2,1.19l1,.55c0,.42,0,.82.05,1.21v0a1.37,1.37,0,0,1,0,.19.8.8,0,0,1-.07.2,2,2,0,0,1-.17.29L298,153.88a.84.84,0,0,0-.16.33.67.67,0,0,0,0,.18.41.41,0,0,0,0,.16l1.28,2.84a.28.28,0,0,0,.09.1h0l.82.47c.11.07.25.14.38.23l3.45,2a4.27,4.27,0,0,1,.38.22l.21.12",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.28,159.28l-1.46-2.21c-.09-.15-.37-.14-.6,0a10,10,0,0,1-.85.54l2.93,1.69A.05.05,0,0,1,319.28,159.28Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,141a11.17,11.17,0,0,1-.06,1.14c0,.2.16.37.41.39l2.42.14a.34.34,0,0,1,.18,0Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09,158.64a5.08,5.08,0,0,1-1.23-.72.5.5,0,0,0-.63.11l-2.89,2.64a.48.48,0,0,1-.31.14l2.83,1.63,1.75,1a.26.26,0,0,1-.12-.28l.89-4A.44.44,0,0,0,310.09,158.64Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,153.6a1.57,1.57,0,0,1-.18.31l-2.71,3.27a1,1,0,0,0-.16.33l-5.7-3.3a.84.84,0,0,1,.16-.33l2.71-3.28a2,2,0,0,0,.17-.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68,153.19a.83.83,0,0,1-.08.41l-5.71-3.29a.8.8,0,0,0,.07-.2,1.37,1.37,0,0,0,0-.19v0c0-.39-.05-.79-.05-1.2l2.67,1.54a.43.43,0,0,0,.26.09l2.42.15a.39.39,0,0,1,.41.38A12.21,12.21,0,0,0,306.68,153.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.47,144.11a.85.85,0,0,1-.36.17l-2.65.64a1,1,0,0,0-.49.32L299.26,142a.82.82,0,0,1,.3-.25.68.68,0,0,1,.2-.07l2.65-.64a1,1,0,0,0,.35-.17h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.52,149.92a.31.31,0,0,0,.08.31l-2.67-1.54h0L298,147l0,0a.28.28,0,0,1-.11-.32l1.34-4.5a.7.7,0,0,1,.09-.17l5.72,3.29a.62.62,0,0,0-.11.19Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.83,134.09l5.7,3.27a.55.55,0,0,0,0,.33l.86,2.92a.72.72,0,0,1,0,.38l-5.7-3.3v0s0-.06,0-.09a.73.73,0,0,0,0-.26l-.87-2.92a.49.49,0,0,1,0-.29",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.46,129.93a.51.51,0,0,0-.15.21l-1.52,4.1a.9.9,0,0,1-.31.38l-5.7-3.29A1,1,0,0,0,312,131a.19.19,0,0,0,.05-.1l1.54-4.1a.46.46,0,0,1,.14-.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.52,149.92a.31.31,0,0,0,.08.31l-2.67-1.54h0L298,147l0,0a.28.28,0,0,1-.11-.32l1.34-4.5a.7.7,0,0,1,.09-.17l5.72,3.29a.62.62,0,0,0-.11.19Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.52,149.92a.31.31,0,0,0,.08.31l-2.67-1.54h0L298,147l0,0a.28.28,0,0,1-.11-.32l1.34-4.5a.7.7,0,0,1,.09-.17l5.72,3.29a.62.62,0,0,0-.11.19Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.26,142l0,0,0,0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3,133.59h0c-.12-.08-.3,0-.44.13l-3.1,3.27a1.34,1.34,0,0,0-.22.36l-5.7-3.27a1.11,1.11,0,0,1,.08-.21,1.1,1.1,0,0,1,.14-.18l3.1-3.27a.48.48,0,0,1,.17-.12.24.24,0,0,1,.24,0h.05l3,1.71Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3,133.59h0c-.12-.08-.3,0-.44.13l-3.1,3.27a1.34,1.34,0,0,0-.22.36l-5.7-3.27a1.11,1.11,0,0,1,.08-.21,1.1,1.1,0,0,1,.14-.18l3.1-3.27a.48.48,0,0,1,.17-.12.24.24,0,0,1,.24,0h.05l3,1.71Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,129.47a.45.45,0,0,0-.26-.05l-2.82.29a.79.79,0,0,0-.47.22l-5.7-3.3.09-.08.13-.07.12,0a.27.27,0,0,1,.13,0l2.82-.28a.39.39,0,0,1,.28.05Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,129.47a.45.45,0,0,0-.26-.05l-2.82.29a.79.79,0,0,0-.47.22l-5.7-3.3.09-.08.13-.07.12,0a.27.27,0,0,1,.13,0l2.82-.28a.39.39,0,0,1,.28.05Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.77,148.59l.16.09h0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,142.66a.34.34,0,0,0-.18,0l-2.42-.14c-.25,0-.43-.19-.41-.39A11.17,11.17,0,0,0,326,141a9.48,9.48,0,0,0-.05-1.2,1.1,1.1,0,0,1,.26-.71l2.71-3.28a.71.71,0,0,0,.16-.67l-1.28-2.84a.24.24,0,0,0-.08-.09h0c-.11-.05-.26,0-.41.13l-2.89,2.63a.5.5,0,0,1-.63.11,4.47,4.47,0,0,0-1.23-.71.46.46,0,0,1-.29-.51l.88-4a.22.22,0,0,0-.12-.28.39.39,0,0,0-.27-.06l-2.82.29a.78.78,0,0,0-.62.43l-1.52,4.1a1.39,1.39,0,0,1-.62.6,12.1,12.1,0,0,0-1.75,1c-.24.16-.51.17-.61,0l-1.44-2.21c-.11-.15-.34-.13-.52.07l-3.1,3.27a.81.81,0,0,0-.24.69l.86,2.92a.94.94,0,0,1-.16.7,24.41,24.41,0,0,0-1.42,2.48,1.13,1.13,0,0,1-.68.49l-2.65.64a.92.92,0,0,0-.6.51l-1.34,4.49c-.06.21.09.39.34.4l2.42.15a.39.39,0,0,1,.41.38,12.21,12.21,0,0,0,0,2.34,1.14,1.14,0,0,1-.26.72l-2.71,3.27a.77.77,0,0,0-.16.67l1.26,2.83a.17.17,0,0,0,.06.06s0,0,0,0h0a.23.23,0,0,0,.11,0,.44.44,0,0,0,.31-.14l2.89-2.64a.5.5,0,0,1,.63-.11,5.08,5.08,0,0,0,1.23.72.44.44,0,0,1,.29.5l-.89,4a.26.26,0,0,0,.12.28h0a.5.5,0,0,0,.28,0l2.82-.28a.78.78,0,0,0,.62-.43l1.53-4.1a1.27,1.27,0,0,1,.61-.6c.3-.14.61-.3.9-.47a10,10,0,0,0,.85-.54c.23-.16.51-.17.6,0l1.46,2.21a.13.13,0,0,0,.06.07.38.38,0,0,0,.45-.14l3.11-3.27a.81.81,0,0,0,.23-.68l-.86-2.92a1,1,0,0,1,.16-.71,23.49,23.49,0,0,0,1.42-2.47,1.15,1.15,0,0,1,.68-.51l2.65-.64a.85.85,0,0,0,.6-.49l1.34-4.5a.3.3,0,0,0-.15-.35Zm-10.47,8.61a8,8,0,0,1-3.68,2.38l-.15,0a.35.35,0,0,1-.11,0,1.18,1.18,0,0,1-.25,0l-.3,0h-.26a2.85,2.85,0,0,1-2.66-1.79,4.6,4.6,0,0,1-.38-1.48,4.41,4.41,0,0,1-.05-.82,12.74,12.74,0,0,1,3.5-8,9.4,9.4,0,0,1,2.14-1.73,6.78,6.78,0,0,1,.71-.36,4.23,4.23,0,0,1,2-.42h.33a2.85,2.85,0,0,1,2.22,1.76C322.75,143.59,321.38,148.21,318.49,151.27Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,142.66a.34.34,0,0,0-.18,0l-2.42-.14c-.25,0-.43-.19-.41-.39A11.17,11.17,0,0,0,326,141a9.48,9.48,0,0,0-.05-1.2,1.1,1.1,0,0,1,.26-.71l2.71-3.28a.71.71,0,0,0,.16-.67l-1.28-2.84a.24.24,0,0,0-.08-.09h0c-.11-.05-.26,0-.41.13l-2.89,2.63a.5.5,0,0,1-.63.11,4.47,4.47,0,0,0-1.23-.71.46.46,0,0,1-.29-.51l.88-4a.22.22,0,0,0-.12-.28.39.39,0,0,0-.27-.06l-2.82.29a.78.78,0,0,0-.62.43l-1.52,4.1a1.39,1.39,0,0,1-.62.6,12.1,12.1,0,0,0-1.75,1c-.24.16-.51.17-.61,0l-1.44-2.21c-.11-.15-.34-.13-.52.07l-3.1,3.27a.81.81,0,0,0-.24.69l.86,2.92a.94.94,0,0,1-.16.7,24.41,24.41,0,0,0-1.42,2.48,1.13,1.13,0,0,1-.68.49l-2.65.64a.92.92,0,0,0-.6.51l-1.34,4.49c-.06.21.09.39.34.4l2.42.15a.39.39,0,0,1,.41.38,12.21,12.21,0,0,0,0,2.34,1.14,1.14,0,0,1-.26.72l-2.71,3.27a.77.77,0,0,0-.16.67l1.26,2.83a.17.17,0,0,0,.06.06s0,0,0,0h0a.23.23,0,0,0,.11,0,.44.44,0,0,0,.31-.14l2.89-2.64a.5.5,0,0,1,.63-.11,5.08,5.08,0,0,0,1.23.72.44.44,0,0,1,.29.5l-.89,4a.26.26,0,0,0,.12.28h0a.5.5,0,0,0,.28,0l2.82-.28a.78.78,0,0,0,.62-.43l1.53-4.1a1.27,1.27,0,0,1,.61-.6c.3-.14.61-.3.9-.47a10,10,0,0,0,.85-.54c.23-.16.51-.17.6,0l1.46,2.21a.13.13,0,0,0,.06.07.38.38,0,0,0,.45-.14l3.11-3.27a.81.81,0,0,0,.23-.68l-.86-2.92a1,1,0,0,1,.16-.71,23.49,23.49,0,0,0,1.42-2.47,1.15,1.15,0,0,1,.68-.51l2.65-.64a.85.85,0,0,0,.6-.49l1.34-4.5a.3.3,0,0,0-.15-.35Zm-10.47,8.61a8,8,0,0,1-3.68,2.38l-.15,0a.35.35,0,0,1-.11,0,1.18,1.18,0,0,1-.25,0l-.3,0h-.26a2.85,2.85,0,0,1-2.66-1.79,4.6,4.6,0,0,1-.38-1.48,4.41,4.41,0,0,1-.05-.82,12.74,12.74,0,0,1,3.5-8,9.4,9.4,0,0,1,2.14-1.73,6.78,6.78,0,0,1,.71-.36,4.23,4.23,0,0,1,2-.42h.33a2.85,2.85,0,0,1,2.22,1.76C322.75,143.59,321.38,148.21,318.49,151.27Z",
    style: {
      opacity: 0.45
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Vehicle--inject-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "397.66 134.58 379.29 169.14 373.43 165.4 391.74 131.16 397.66 134.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.2 179.22 379.29 169.14 373.43 165.4 356.27 175.81 362.2 179.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.27 179.07 362.2 182.49 362.2 179.22 356.27 175.81 356.27 179.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.58 136.14 397.66 134.58 379.29 169.14 362.2 179.22 362.2 182.49 382.04 170.67 400.58 136.14",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.34,94.77A1.45,1.45,0,0,0,366,95l-84,48.48a4.32,4.32,0,0,0-1.95,3.38V222.6a1.43,1.43,0,0,0,.53,1.25c-.33-.22-3.28-1.89-3.64-2.1a1.39,1.39,0,0,1-.55-1.25V144.7a4.29,4.29,0,0,1,1.95-3.38l83.94-48.49a1.39,1.39,0,0,1,1.4-.12C364.09,92.9,366.65,94.35,367.34,94.77Z",
    style: {
      fill: "#44C9F6",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.09,143.43,366,95c1.08-.62,1.95-.12,1.95,1.13v75.8a4.32,4.32,0,0,1-1.95,3.38l-84,48.47c-1.08.62-1.95.12-1.95-1.12v-75.8A4.29,4.29,0,0,1,282.09,143.43Z",
    style: {
      fill: "#44C9F6",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.71,144.89l-3.66-2.12a4,4,0,0,0-.57,1.93v75.8a1.39,1.39,0,0,0,.55,1.25c.36.21,3.31,1.88,3.64,2.1a1.43,1.43,0,0,1-.53-1.25V146.81A4,4,0,0,1,280.71,144.89Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,94.77c-.69-.42-3.25-1.87-3.57-2.06a1.39,1.39,0,0,0-1.4.12l-83.94,48.49a3.94,3.94,0,0,0-1.38,1.45l3.66,2.12a4,4,0,0,1,1.38-1.46L366,95A1.45,1.45,0,0,1,367.34,94.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,168.57l6.64,9.33-30-27.29-31.6,53.53v18.47c0,1.24.87,1.74,1.95,1.12l84-48.47a4.32,4.32,0,0,0,1.95-3.38V161.73l-22.36-16.1Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.71,123.69c3.91-2.26,7.08-.42,7.08,4.1a15.66,15.66,0,0,1-7.08,12.27c-3.92,2.26-7.09.43-7.09-4.09A15.66,15.66,0,0,1,338.71,123.69Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.91,95.59c.17,0,.18.44.18.49v75.8a3.44,3.44,0,0,1-1.5,2.6L281.64,223a1,1,0,0,1-.42.15c-.17,0-.18-.44-.18-.49v-75.8a3.41,3.41,0,0,1,1.5-2.6l83.95-48.48a.87.87,0,0,1,.42-.14m0-.9A1.76,1.76,0,0,0,366,95l-84,48.48a4.29,4.29,0,0,0-1.95,3.38v75.8c0,.88.44,1.39,1.08,1.39a1.78,1.78,0,0,0,.87-.27l84-48.47a4.32,4.32,0,0,0,1.95-3.38V96.08c0-.88-.44-1.39-1.08-1.39Z",
    style: {
      fill: "#44C9F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.36,147.22c2.89-2.67,9.68,2.3,9.68,5.16l-26.9,75.3-16-7.67Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.36,147.22c2.89-2.67,9.68,2.3,9.68,5.16l-26.9,75.3-16-7.67Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.19,119.92c2.89-2.41,5.76-3,8.06-2.13h0l14.22,6.79-.33.9a10.58,10.58,0,0,1,2,4.8c1.26,7.27-2.31,17-8,21.72a10.53,10.53,0,0,1-4.55,2.37l-.34.94-14.19-6.78h0c-2.38-.75-4.19-3.12-4.84-6.87C441,134.38,444.52,124.65,450.19,119.92Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.19,119.92c2.89-2.41,5.76-3,8.06-2.13h0l14.22,6.79-.33.9a10.58,10.58,0,0,1,2,4.8c1.26,7.27-2.31,17-8,21.72a10.53,10.53,0,0,1-4.55,2.37l-.34.94-14.19-6.78h0c-2.38-.75-4.19-3.12-4.84-6.87C441,134.38,444.52,124.65,450.19,119.92Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.71,126.82c-5.67,4.73-9.24,14.45-8,21.72s6.87,9.33,12.54,4.61,9.24-14.46,8-21.73S470.37,122.09,464.71,126.82Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,144.07a5.24,5.24,0,0,0,.81,2.13c1.13,1.64,3.16,1.76,5.19.08a12.26,12.26,0,0,0,3.81-10.39c-.39-2.26-1.64-3.46-3.22-3.4a4.44,4.44,0,0,0-2.77,1.2A12.18,12.18,0,0,0,462.08,144.07Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,144.07a5.24,5.24,0,0,0,.81,2.13c1.13,1.64,3.16,1.76,5.19.08a12.26,12.26,0,0,0,3.81-10.39c-.39-2.26-1.64-3.46-3.22-3.4a4.44,4.44,0,0,0-2.77,1.2A12.18,12.18,0,0,0,462.08,144.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,144.07a5.24,5.24,0,0,0,.81,2.13,4.56,4.56,0,0,0,2.79-1.21,12.21,12.21,0,0,0,3.8-10.37,5.24,5.24,0,0,0-.81-2.13,4.44,4.44,0,0,0-2.77,1.2A12.18,12.18,0,0,0,462.08,144.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.31,130.48,451,140.71a4.8,4.8,0,0,0-1.53-9.47l-.17,0-46.29-8a3.64,3.64,0,0,0,1.29,7.17Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.31,130.48,451,140.71a4.8,4.8,0,0,0-1.53-9.47l-.17,0-46.29-8a3.64,3.64,0,0,0,1.29,7.17Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,114.21c2.06-1.71,4.1-2.16,5.73-1.52h0l10.05,5.16-.23.64a7.57,7.57,0,0,1,1.4,3.42c.9,5.17-1.64,12.09-5.67,15.45a7.69,7.69,0,0,1-3.24,1.69l-.24.66-10-5.15h0c-1.7-.54-3-2.21-3.45-4.88C386.07,124.49,388.61,117.58,392.64,114.21Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,114.21c2.06-1.71,4.1-2.16,5.73-1.52h0l10.05,5.16-.23.64a7.57,7.57,0,0,1,1.4,3.42c.9,5.17-1.64,12.09-5.67,15.45a7.69,7.69,0,0,1-3.24,1.69l-.24.66-10-5.15h0c-1.7-.54-3-2.21-3.45-4.88C386.07,124.49,388.61,117.58,392.64,114.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.9,119.45c-4,3.36-6.57,10.28-5.67,15.45s4.89,6.64,8.92,3.28,6.57-10.28,5.67-15.45S406.93,116.09,402.9,119.45Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,131.72a3.84,3.84,0,0,0,.58,1.52c.8,1.16,2.25,1.25,3.69,0a8.66,8.66,0,0,0,2.71-7.38c-.28-1.61-1.17-2.47-2.29-2.42a3.14,3.14,0,0,0-2,.85A8.69,8.69,0,0,0,401,131.72Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,131.72a3.84,3.84,0,0,0,.58,1.52c.8,1.16,2.25,1.25,3.69,0a8.66,8.66,0,0,0,2.71-7.38c-.28-1.61-1.17-2.47-2.29-2.42a3.14,3.14,0,0,0-2,.85A8.69,8.69,0,0,0,401,131.72Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,131.72a3.84,3.84,0,0,0,.58,1.52,3.24,3.24,0,0,0,2-.86A8.71,8.71,0,0,0,406.3,125a3.73,3.73,0,0,0-.58-1.51,3.14,3.14,0,0,0-2,.85A8.69,8.69,0,0,0,401,131.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.23 121.09 392.3 117.64 372.76 92.49 377.56 91.51 398.23 121.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.23 121.09 400.58 118.48 378.45 86.89 356.83 98.76 356.83 103.04 377.19 92.11 398.23 121.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.83 103.04 349.99 99.09 349.99 94.81 356.83 98.76 356.83 103.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.99 94.81 371.6 82.94 378.45 86.89 356.83 98.76 349.99 94.81",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.06,323.18v12.7l-27.19-15.69a38,38,0,0,0-1.46-9.67v0a46.09,46.09,0,0,0-1.65-4.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.09,230.82v64.47c-4.75,3.42-8.92,9.14-11.65,15.54h0l-4.18,2.41v-18L373.8,263.33V200.78l12.2-7a3.93,3.93,0,0,1,.74-.33,2,2,0,0,1,1.63.14l59.32,34.25.07,0,.13.07.26.2.24.25a3.14,3.14,0,0,1,.37.65,2.26,2.26,0,0,1,.15.39l.09.38s0,.07,0,.1,0,.28.05.42S449.09,230.64,449.09,230.82Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.79,200.79l59.47,34.32,12.2-7a2.35,2.35,0,0,1,2.33-.22h0l-59.39-34.29a2.34,2.34,0,0,0-2.38.19Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.81,316.05a2.39,2.39,0,0,0,.77-1.54q.18-1.23.45-2.46a1.66,1.66,0,0,0-.09-1.2l-.24-.14c-.23-.14-.26-.68-.05-1.28l1.55-4.49c.23-.66.67-1.16,1-1.1s.78-.42,1.09-1c.38-.78.78-1.55,1.2-2.29a2.13,2.13,0,0,0,.32-1.64,1.72,1.72,0,0,1,.41-1.53l2.69-3.62c.33-.45.72-.66.93-.53l.47.27A1.43,1.43,0,0,0,436,293c.53-.54,1.07-1.05,1.63-1.53a2.36,2.36,0,0,0,.82-1.52,1.77,1.77,0,0,1,.84-1.34l3.1-1.79a.64.64,0,0,1,.63-.07l1.53.88a11.5,11.5,0,0,1,1.14-.23,1.52,1.52,0,0,0,1.1-1,1.07,1.07,0,0,1,1.05-.78l2.69.52a.51.51,0,0,1,.17.07l10.84,6.21a.75.75,0,0,1,.28.81l3.31,1.91a.55.55,0,0,1,.22.23l1.55,2.69a1.43,1.43,0,0,1-.12,1.45,2,2,0,0,0-.25,1.61,18.38,18.38,0,0,1,.44,1.94l1.1.64a.86.86,0,0,1,.29.77v4.15a1.82,1.82,0,0,1-.61,1.46,2.34,2.34,0,0,0-.75,1.54c-.12.82-.27,1.65-.45,2.47a1.68,1.68,0,0,0,.09,1.21l.23.13c.22.13.24.67,0,1.28l-1.55,4.49c-.23.66-.65,1.16-.94,1.1s-.75.43-1.06,1.07c-.38.79-.79,1.58-1.22,2.34a2.14,2.14,0,0,0-.34,1.61c.17.28,0,.95-.42,1.49l-2.69,3.62c-.34.46-.73.68-.93.56l-.41-.23a1.43,1.43,0,0,0-.77.45,22.63,22.63,0,0,1-1.68,1.58,2.31,2.31,0,0,0-.82,1.46,1.71,1.71,0,0,1-.83,1.27l-3.11,1.79a.68.68,0,0,1-.64.09l-1.39-.8a10.46,10.46,0,0,1-1.31.26,1.46,1.46,0,0,0-1.08.93,1,1,0,0,1-1,.72L442,340a.62.62,0,0,1-.19-.07L431,333.72a.73.73,0,0,1-.29-.81L427.44,331a.72.72,0,0,1-.24-.25l-1.55-2.69a1.42,1.42,0,0,1,.11-1.43,2.05,2.05,0,0,0,.24-1.6,18.21,18.21,0,0,1-.44-2v0l-1.08-.62a.89.89,0,0,1-.29-.78v-4.15A1.86,1.86,0,0,1,424.81,316.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,327.89v-4.15a1.86,1.86,0,0,1,.62-1.47,2.39,2.39,0,0,0,.77-1.54q.18-1.23.45-2.46c.14-.66,0-1.26-.26-1.31s-.35-.65-.12-1.31l1.55-4.49c.24-.67.67-1.16,1-1.1s.78-.42,1.09-1.06.78-1.54,1.2-2.28a2,2,0,0,0,.32-1.64,1.75,1.75,0,0,1,.41-1.53l2.69-3.62c.4-.54.87-.73,1-.43s.67.17,1.11-.27,1.07-1.05,1.63-1.53a2.39,2.39,0,0,0,.82-1.52,1.77,1.77,0,0,1,.84-1.34l3.11-1.79c.46-.27.83-.1.83.37a.58.58,0,0,0,.82.57,13.11,13.11,0,0,1,1.64-.36,1.52,1.52,0,0,0,1.1-1,1,1,0,0,1,1-.78l2.69.52c.4.08.58.55.4,1.05a1.11,1.11,0,0,0,.32,1.27,8.08,8.08,0,0,1,1.21.9.73.73,0,0,0,1.09-.2c.3-.4.73-.41,1,0l1.55,2.69a1.43,1.43,0,0,1-.12,1.45,2,2,0,0,0-.25,1.61,18.38,18.38,0,0,1,.44,1.94c.1.55.43.85.77.66s.62.14.62.75v4.15a1.82,1.82,0,0,1-.61,1.46,2.39,2.39,0,0,0-.76,1.54c-.11.82-.26,1.65-.44,2.47-.14.67,0,1.26.25,1.32s.33.64.1,1.3l-1.55,4.49c-.23.66-.65,1.16-.94,1.1s-.75.43-1.06,1.07c-.38.79-.79,1.58-1.22,2.34a2.14,2.14,0,0,0-.34,1.61c.17.28,0,.95-.42,1.49l-2.69,3.62c-.4.54-.86.75-1,.47s-.65-.13-1.09.31a22.63,22.63,0,0,1-1.68,1.58,2.31,2.31,0,0,0-.82,1.46,1.71,1.71,0,0,1-.83,1.27l-3.11,1.79c-.46.27-.84.13-.84-.3s-.37-.65-.82-.51a10.53,10.53,0,0,1-1.68.36,1.46,1.46,0,0,0-1.08.93,1,1,0,0,1-1,.72L442,340a.71.71,0,0,1-.43-1,1,1,0,0,0-.34-1.22,8.94,8.94,0,0,1-1.22-.93A.7.7,0,0,0,439,337a.52.52,0,0,1-.94,0l-1.55-2.69a1.42,1.42,0,0,1,.11-1.43,2,2,0,0,0,.24-1.6c-.17-.62-.32-1.27-.44-2s-.42-.86-.76-.66S435,328.5,435,327.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.59,287.63l9.26,5.32,0,0a.48.48,0,0,1,.2.44.58.58,0,0,0,.82.57l.52-.14c.38-.09.75-.17,1.12-.22a1.24,1.24,0,0,0,.67-.36l-10.83-6.22a1.23,1.23,0,0,1-.68.36C445.34,287.47,445,287.54,444.59,287.63Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M438.15,290.9,449,297.12a2,2,0,0,0,.33-.95,1.52,1.52,0,0,1,.23-.73l-10.84-6.21a1.43,1.43,0,0,0-.24.73A1.91,1.91,0,0,1,438.15,290.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.28,293.44l10.31,5.93s.05,0,.06,0a.29.29,0,0,1,.11.11.33.33,0,0,0,.37.15,1.41,1.41,0,0,0,.74-.43c.53-.54,1.08-1.05,1.63-1.53a2.55,2.55,0,0,0,.5-.58l-10.85-6.22a2.79,2.79,0,0,1-.49.58c-.56.47-1.1,1-1.64,1.53A1.29,1.29,0,0,1,435.28,293.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.81,304l10.84,6.21a.44.44,0,0,1,.36-.13c.3.06.78-.42,1.09-1.05s.78-1.55,1.2-2.3a2.06,2.06,0,0,0,.32-1.63.64.64,0,0,1-.06-.4l-10.84-6.22a.63.63,0,0,0,.06.4,2.09,2.09,0,0,1-.32,1.64c-.43.74-.82,1.5-1.2,2.28s-.79,1.12-1.09,1.06A.48.48,0,0,0,427.81,304Z",
    style: {
      fill: "#263238"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M438.65,310.19,427.81,304a.48.48,0,0,1,.36-.14.45.45,0,0,0,.16,0L439.17,310a.31.31,0,0,1-.16,0A.44.44,0,0,0,438.65,310.19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M430.78,298.86a.63.63,0,0,1-.06-.4l10.84,6.22a.64.64,0,0,0,.06.4,1,1,0,0,1,.05.57l-10.84-6.22A1,1,0,0,0,430.78,298.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.4,316.56l10.86,6.21a1.08,1.08,0,0,1,.39-.5,2.35,2.35,0,0,0,.77-1.54c.12-.82.27-1.63.45-2.46a1.54,1.54,0,0,0-.11-1.22h0l-.14-.08-.12-.07-10.55-6a1.61,1.61,0,0,1,.09,1.2c-.18.82-.33,1.65-.45,2.46a2.37,2.37,0,0,1-.77,1.54A1.21,1.21,0,0,0,424.4,316.56Z",
    style: {
      fill: "#263238"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M424.81,316.05a1.42,1.42,0,0,0,.46-.56l10.84,6.21a1.37,1.37,0,0,1-.46.57,1.08,1.08,0,0,0-.39.5l-10.86-6.21A1.21,1.21,0,0,1,424.81,316.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.53,327.2l10.84,6.22a1.24,1.24,0,0,1,.23-.55,1.77,1.77,0,0,0,.28-.76,1.82,1.82,0,0,0,0-.84,18.21,18.21,0,0,1-.44-2v0c-.1-.54-.42-.84-.76-.65a.3.3,0,0,1-.36,0l-9.72-5.57v0c.12.69.27,1.35.44,2a2,2,0,0,1-.25,1.6A1.23,1.23,0,0,0,425.53,327.2Z",
    style: {
      fill: "#263238"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M436.6,332.87a1.24,1.24,0,0,0-.23.55l-10.84-6.22a1.23,1.23,0,0,1,.22-.55A1.52,1.52,0,0,0,426,326l10.84,6.21A1.73,1.73,0,0,1,436.6,332.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M462.13,294.69a8.62,8.62,0,0,1,1.2.91.73.73,0,0,0,1.09-.21.56.56,0,0,1,.71-.25l0,0-3.23-1.86a1.05,1.05,0,0,0-.05.19A1.07,1.07,0,0,0,462.13,294.69Z",
    style: {
      fill: "#263238"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431,333.71a0,0,0,0,1,0,0l0,0a1.52,1.52,0,0,1,.2.11l10.48,6,.09.05a.78.78,0,0,1-.22-.91,1,1,0,0,0-.33-1.22,7.65,7.65,0,0,1-1.23-.93A.69.69,0,0,0,439,337a.56.56,0,0,1-.61.27l-.12-.07-7.53-4.3A.71.71,0,0,0,431,333.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.13,338.61l1.38.8a.41.41,0,0,1-.18-.39c0-.43-.38-.65-.83-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.39,332.77l.32.18,0,0A.26.26,0,0,0,457.39,332.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,303.07c.09.55.43.85.76.65a.36.36,0,0,1,.28,0l-.09-.05-.15-.09Z",
    style: {
      fill: "#263238"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M446.4,287.05l10.83,6.22a1.53,1.53,0,0,0,.44-.64,1.27,1.27,0,0,1,.46-.62l-10.85-6.21a1.19,1.19,0,0,0-.46.62A1.66,1.66,0,0,1,446.4,287.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.93,321.77c0,6.73,2.25,11.47,5.78,13.51l2.39,1.37c-3.48-2.07-5.68-6.79-5.68-13.46,0-12.29,7.47-26.58,16.69-31.9,4-2.3,7.64-2.55,10.51-1.11L455.57,289c-2.94-1.71-6.76-1.55-10.94.87C435.41,295.19,427.93,309.48,427.93,321.77Z",
    style: {
      fill: "#37474f"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M430.42,323.2c0,6.67,2.2,11.38,5.68,13.45l.73.38c-3.48-2.06-4.8-6.23-4.8-12.9,0-12.29,7.48-26.58,16.69-31.9,4.13-2.39,7-3.11,9.94-1.48l-1-.57c-2.87-1.44-6.53-1.19-10.51,1.11C437.89,296.61,430.42,310.9,430.42,323.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M447.28,285.8,458.13,292a.75.75,0,0,1,.58-.16l1.11.21,1.58.31a.38.38,0,0,1,.1,0l-.17-.11-9.85-5.64-.23-.13-.23-.14-.09-.05-.12-.07-.08,0-.08,0-.09,0-2.7-.51A.72.72,0,0,0,447.28,285.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.72,289.23l10.84,6.21a1.81,1.81,0,0,1,.6-.6l3.11-1.79a.65.65,0,0,1,.58-.1l-9.26-5.32-1-.56-.35-.21-.19-.11a.68.68,0,0,0-.63.08l-3.1,1.8A1.72,1.72,0,0,0,438.72,289.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.72,298.46l10.84,6.22a2.47,2.47,0,0,1,.47-1.13l2.69-3.62c.3-.41.65-.62.87-.56l-10.31-5.93-.46-.26c-.23-.13-.6.07-.94.52l-2.7,3.64A2.35,2.35,0,0,0,430.72,298.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.67,310.69l.07.05.2.11,10.55,6a1.4,1.4,0,0,1,0-1.24l1.55-4.49a2.22,2.22,0,0,1,.61-1L427.81,304a2.1,2.1,0,0,0-.6,1l-1.56,4.48C425.45,310,425.46,310.53,425.67,310.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.19,317.53v4.14a.89.89,0,0,0,.29.78l1.08.62,9.72,5.57a1,1,0,0,1-.24-.75v-4.15a2.18,2.18,0,0,1,.22-1h0l-10.86-6.21A2.34,2.34,0,0,0,424.19,317.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.65,328.08l1.55,2.69a.58.58,0,0,0,.24.25l.73.42.27.15,2.28,1.32,7.53,4.3A.74.74,0,0,1,438,337l-1.55-2.69a1.37,1.37,0,0,1-.12-.88l-10.84-6.22A1.3,1.3,0,0,0,425.65,328.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.42,321.55c0-6.84,4.16-14.79,9.29-17.75s9.29.18,9.29,7-4.16,14.79-9.29,17.75S442.42,328.39,442.42,321.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 451.71,
    cy: 316.18,
    rx: 11.56,
    ry: 6.54,
    transform: "translate(-16.09 608.03) rotate(-66.95)",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.43,319.23c0-3.88,2.37-8.4,5.28-10.09s5.28.11,5.28,4-2.36,8.4-5.28,10.09S446.43,323.12,446.43,319.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.68,317.94a7.28,7.28,0,0,1,3-5.8c1.68-1,3,.06,3,2.29a7.26,7.26,0,0,1-3,5.8C450,321.2,448.68,320.17,448.68,317.94Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.38,313.64a.81.81,0,0,1,.33-.63c.18-.1.33,0,.33.25a.79.79,0,0,1-.33.63C451.53,314,451.38,313.89,451.38,313.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,315.54c-.13-.1-.13-.38,0-.63s.34-.36.47-.27.13.38,0,.63S450.16,315.63,450,315.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.66,317.81c-.18.1-.33,0-.33-.25a.79.79,0,0,1,.33-.63c.18-.11.33,0,.33.25A.81.81,0,0,1,449.66,317.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.5,319.13c-.13.25-.34.37-.47.27s-.13-.38,0-.62.34-.37.47-.27S450.63,318.88,450.5,319.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,318.73a.81.81,0,0,1-.33.63c-.18.1-.33,0-.33-.25a.79.79,0,0,1,.33-.63C451.89,318.37,452,318.48,452,318.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.4,316.83c.12.1.12.38,0,.63s-.34.36-.47.27-.13-.38,0-.63S453.27,316.74,453.4,316.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.76,314.56c.18-.1.33,0,.33.25a.79.79,0,0,1-.33.63c-.18.11-.33,0-.33-.25A.81.81,0,0,1,453.76,314.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.93,313.24c.13-.25.34-.37.47-.27s.12.38,0,.62-.34.37-.47.27S452.8,313.49,452.93,313.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.49,316.89a2.92,2.92,0,0,1,1.22-2.34c.68-.39,1.23,0,1.23.93a2.93,2.93,0,0,1-1.23,2.34C451,318.21,450.49,317.8,450.49,316.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.44,310.83h0a44.22,44.22,0,0,0-1.77,5,37.42,37.42,0,0,0-1.58,9.68l-18,10.42V323.18l17.21-9.94Z",
    style: {
      fill: "#263238"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 367.17,
    y: 323.51,
    width: 5.78,
    height: 5.78,
    transform: "translate(740.13 652.81) rotate(180)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M437.44,310.83h0a44.22,44.22,0,0,0-1.77,5L416.05,327.1v-3.92l17.21-9.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.09,230.82v64.47c-4.75,3.42-8.92,9.14-11.65,15.54h0l-4.18,2.41V235.11l12.19-7.05a2.59,2.59,0,0,1,1.91-.37,1.6,1.6,0,0,1,.33.11l.07,0,.13.07.26.2.24.25a2.75,2.75,0,0,1,.37.65,2.26,2.26,0,0,1,.15.39l.09.38s0,.07,0,.1,0,.28.05.42S449.09,230.64,449.09,230.82Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.09,230.82v64.47c-4.75,3.42-8.92,9.14-11.65,15.54h0l-4.18,2.41V235.11l12.19-7.05a2.59,2.59,0,0,1,1.91-.37,1.6,1.6,0,0,1,.33.11l.07,0,.13.07.26.2.24.25a2.75,2.75,0,0,1,.37.65,2.26,2.26,0,0,1,.15.39l.09.38s0,.07,0,.1,0,.28.05.42S449.09,230.64,449.09,230.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.76 235.97 433.26 235.11 433.26 313.25 431.76 314.11 431.76 235.97",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.32,285.84V239.66a3.47,3.47,0,0,1,1.45-2.77l7-4c.8-.46,1.45,0,1.45,1.1v46.18a3.49,3.49,0,0,1-1.45,2.78l-7,4C437,287.41,436.32,286.91,436.32,285.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.09 285.11 433.26 294.25 433.26 295.21 449.09 286.07 449.09 285.11",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.06 323.18 393.76 310.31 403.67 304.59 425.97 317.46 416.06 323.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.68,313.66a2.8,2.8,0,0,0,.92-1.84c.14-1,.32-1.95.53-2.92a1.92,1.92,0,0,0-.1-1.44l-.29-.17c-.27-.16-.31-.8-.06-1.52l1.86-5.35c.27-.79.78-1.38,1.14-1.31s.93-.5,1.3-1.26c.45-.92.93-1.83,1.43-2.72a2.5,2.5,0,0,0,.39-2,2,2,0,0,1,.48-1.81l3.21-4.32c.4-.54.85-.79,1.11-.64l.56.32a1.65,1.65,0,0,0,.89-.52c.63-.64,1.28-1.25,1.94-1.82a2.79,2.79,0,0,0,1-1.81,2.09,2.09,0,0,1,1-1.59l3.7-2.14a.78.78,0,0,1,.75-.09l1.82,1.05c.46-.11.91-.2,1.35-.26a1.86,1.86,0,0,0,1.32-1.2,1.26,1.26,0,0,1,1.24-.93l3.21.62a.66.66,0,0,1,.21.08l12.91,7.41a.88.88,0,0,1,.34,1l3.94,2.27a.71.71,0,0,1,.26.28l1.85,3.21a1.7,1.7,0,0,1-.14,1.72,2.43,2.43,0,0,0-.31,1.92,20.18,20.18,0,0,1,.54,2.32l1.31.75a1.07,1.07,0,0,1,.34.93v4.93a2.16,2.16,0,0,1-.73,1.75,2.8,2.8,0,0,0-.9,1.83c-.14,1-.31,2-.52,2.95a2,2,0,0,0,.09,1.43l.28.16c.27.16.3.8,0,1.53L363,319.8c-.27.8-.77,1.39-1.12,1.32s-.89.51-1.26,1.27c-.46.95-.94,1.88-1.45,2.79a2.52,2.52,0,0,0-.41,1.91c.2.34,0,1.14-.5,1.78l-3.21,4.32c-.4.54-.86.8-1.11.66l-.48-.28a1.74,1.74,0,0,0-.91.55c-.66.66-1.32,1.29-2,1.88a2.78,2.78,0,0,0-1,1.74,2,2,0,0,1-1,1.51l-3.7,2.13a.81.81,0,0,1-.77.11l-1.65-.95a13,13,0,0,1-1.56.31,1.75,1.75,0,0,0-1.29,1.11,1.19,1.19,0,0,1-1.22.85l-3.2-.62a.53.53,0,0,1-.22-.08l-12.91-7.4a.87.87,0,0,1-.34-1l-3.92-2.26a.87.87,0,0,1-.28-.29L315.68,328a1.72,1.72,0,0,1,.13-1.71,2.4,2.4,0,0,0,.29-1.9,22.36,22.36,0,0,1-.52-2.34v0l-1.28-.74a1.05,1.05,0,0,1-.34-.93v-4.94A2.21,2.21,0,0,1,314.68,313.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,327.76v-4.94a2.18,2.18,0,0,1,.74-1.75,2.84,2.84,0,0,0,.92-1.84c.14-1,.32-2,.53-2.92.18-.8.05-1.5-.3-1.57s-.42-.77-.15-1.56l1.85-5.35c.28-.79.79-1.38,1.15-1.31s.93-.5,1.3-1.26c.45-.93.93-1.84,1.43-2.72a2.5,2.5,0,0,0,.38-2,2.06,2.06,0,0,1,.49-1.81l3.2-4.32c.48-.65,1-.87,1.25-.51s.79.2,1.32-.33,1.28-1.25,1.94-1.82a2.79,2.79,0,0,0,1-1.81,2.09,2.09,0,0,1,1-1.59l3.7-2.14c.55-.32,1-.12,1,.44a.69.69,0,0,0,1,.68,13.39,13.39,0,0,1,1.95-.42,1.87,1.87,0,0,0,1.32-1.2,1.26,1.26,0,0,1,1.24-.93l3.21.62c.47.09.69.66.48,1.26a1.3,1.3,0,0,0,.38,1.51,10.53,10.53,0,0,1,1.44,1.07.85.85,0,0,0,1.29-.24c.36-.48.88-.49,1.15,0l1.85,3.21a1.7,1.7,0,0,1-.14,1.72,2.43,2.43,0,0,0-.31,1.92,20.18,20.18,0,0,1,.54,2.32c.11.65.51,1,.92.77s.73.17.73.91v4.93a2.16,2.16,0,0,1-.73,1.75,2.8,2.8,0,0,0-.9,1.83c-.14,1-.31,2-.52,2.95-.17.79-.06,1.49.29,1.56s.4.76.12,1.56L363,319.8c-.27.8-.77,1.39-1.12,1.32s-.89.51-1.26,1.27c-.46.95-.94,1.88-1.45,2.79a2.52,2.52,0,0,0-.41,1.91c.2.34,0,1.14-.5,1.78l-3.21,4.32c-.48.64-1,.89-1.21.55s-.77-.15-1.29.38-1.32,1.29-2,1.88a2.78,2.78,0,0,0-1,1.74,2,2,0,0,1-1,1.51l-3.7,2.13c-.55.32-1,.16-1-.36s-.44-.76-1-.61a12.64,12.64,0,0,1-2,.44,1.75,1.75,0,0,0-1.29,1.11,1.19,1.19,0,0,1-1.22.85l-3.2-.62c-.48-.09-.71-.62-.51-1.19a1.24,1.24,0,0,0-.4-1.45,10.23,10.23,0,0,1-1.46-1.11.83.83,0,0,0-1.26.19.62.62,0,0,1-1.12,0l-1.85-3.21a1.7,1.7,0,0,1,.13-1.71,2.44,2.44,0,0,0,.29-1.9,22.33,22.33,0,0,1-.53-2.34c-.11-.65-.5-1-.9-.78S326.86,328.49,326.86,327.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.25,279.8l11,6.33.06,0a.62.62,0,0,1,.23.53.7.7,0,0,0,1,.69c.21-.07.41-.12.62-.17a10.76,10.76,0,0,1,1.33-.26,1.54,1.54,0,0,0,.8-.43l-12.9-7.42a1.54,1.54,0,0,1-.81.43C339.15,279.6,338.71,279.69,338.25,279.8Z",
    style: {
      fill: "#263238"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M330.58,283.69l12.92,7.41a2.29,2.29,0,0,0,.39-1.13,1.7,1.7,0,0,1,.29-.87l-12.92-7.4a1.67,1.67,0,0,0-.29.87A2.36,2.36,0,0,1,330.58,283.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.16,286.72l12.28,7.06.08,0a.27.27,0,0,1,.13.13.38.38,0,0,0,.44.17,1.57,1.57,0,0,0,.88-.51c.63-.64,1.28-1.25,1.95-1.82a2.8,2.8,0,0,0,.58-.69l-12.92-7.41a3.31,3.31,0,0,1-.59.69c-.66.57-1.31,1.17-1.95,1.82A1.59,1.59,0,0,1,327.16,286.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.25,299.27l12.93,7.4a.54.54,0,0,1,.42-.15c.36.07.93-.5,1.3-1.26.45-.93.93-1.84,1.43-2.73a2.42,2.42,0,0,0,.38-1.95.79.79,0,0,1-.07-.48l-12.91-7.4a.7.7,0,0,0,.07.47,2.53,2.53,0,0,1-.38,2c-.51.88-1,1.79-1.43,2.72-.38.76-.94,1.33-1.31,1.26A.56.56,0,0,0,318.25,299.27Z",
    style: {
      fill: "#263238"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M331.18,306.67l-12.93-7.4a.56.56,0,0,1,.43-.16.35.35,0,0,0,.2,0l12.92,7.4a.36.36,0,0,1-.2,0A.54.54,0,0,0,331.18,306.67Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321.8,293.17a.7.7,0,0,1-.07-.47l12.91,7.4a.79.79,0,0,0,.07.48,1.15,1.15,0,0,1,.06.69l-12.92-7.42A1.2,1.2,0,0,0,321.8,293.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,314.26l12.93,7.4a1.26,1.26,0,0,1,.47-.59,2.79,2.79,0,0,0,.91-1.84c.15-1,.33-1.94.54-2.92a1.78,1.78,0,0,0-.13-1.46h0l-.17-.1-.15-.09L316,307.47a1.9,1.9,0,0,1,.11,1.42c-.22,1-.39,2-.54,2.93a2.84,2.84,0,0,1-.92,1.84A1.43,1.43,0,0,0,314.2,314.26Z",
    style: {
      fill: "#263238"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M314.68,313.66a1.57,1.57,0,0,0,.55-.68l12.92,7.41a1.7,1.7,0,0,1-.55.68,1.26,1.26,0,0,0-.47.59l-12.93-7.4A1.43,1.43,0,0,1,314.68,313.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.54,326.94l12.91,7.41a1.69,1.69,0,0,1,.28-.66,2,2,0,0,0,.33-.9,2.19,2.19,0,0,0,0-1,22.93,22.93,0,0,1-.53-2.34v0c-.11-.65-.5-1-.9-.78a.38.38,0,0,1-.43,0L315.57,322v0a23.8,23.8,0,0,0,.53,2.34,2.36,2.36,0,0,1-.29,1.9A1.49,1.49,0,0,0,315.54,326.94Z",
    style: {
      fill: "#263238"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M328.73,333.69a1.69,1.69,0,0,0-.28.66l-12.91-7.41a1.49,1.49,0,0,1,.27-.66,2,2,0,0,0,.32-.82l12.91,7.4A2,2,0,0,1,328.73,333.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.15,288.21a9.76,9.76,0,0,1,1.43,1.08.87.87,0,0,0,1.3-.25.67.67,0,0,1,.84-.3l-.05,0-3.85-2.22a1.42,1.42,0,0,0-.05.22A1.28,1.28,0,0,0,359.15,288.21Z",
    style: {
      fill: "#263238"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.07,334.7h0l0,0,.24.14L334.84,342l.11.05a.9.9,0,0,1-.26-1.08,1.24,1.24,0,0,0-.4-1.45,9.54,9.54,0,0,1-1.46-1.11.83.83,0,0,0-1.26.19.67.67,0,0,1-.73.32l-.14-.08-9-5.12A.85.85,0,0,0,322.07,334.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.47,340.54l1.65.95a.48.48,0,0,1-.23-.46c0-.52-.45-.78-1-.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.5,333.58l.38.21,0-.05A.33.33,0,0,0,353.5,333.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,298.2c.11.65.51,1,.91.77a.43.43,0,0,1,.34-.05l-.11-.06-.19-.11Z",
    style: {
      fill: "#263238"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M340.41,279.1l12.9,7.42a1.88,1.88,0,0,0,.52-.77,1.43,1.43,0,0,1,.55-.73l-12.92-7.41a1.5,1.5,0,0,0-.55.74A2,2,0,0,1,340.41,279.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,320.47c0,8,2.68,13.67,6.89,16.1l2.85,1.63c-4.15-2.46-6.77-8.08-6.77-16,0-14.65,8.89-31.67,19.89-38,4.74-2.74,9.09-3,12.51-1.32l-2.44-1.41c-3.5-2-8.05-1.84-13,1C327.31,288.8,318.4,305.83,318.4,320.47Z",
    style: {
      fill: "#37474f"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M321.37,322.17c0,7.95,2.62,13.57,6.77,16l.86.45c-4.14-2.46-5.72-7.43-5.72-15.37,0-14.65,8.91-31.67,19.9-38,4.91-2.84,8.36-3.7,11.84-1.76l-1.25-.68c-3.42-1.71-7.77-1.42-12.51,1.33C330.26,290.5,321.37,307.53,321.37,322.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.46,277.61,354.38,285a.88.88,0,0,1,.69-.2l1.33.26,1.88.36.12,0-.2-.13-11.74-6.73-.27-.15-.28-.16-.11-.06-.14-.09-.09-.05-.1,0a.45.45,0,0,0-.11,0l-3.21-.62A.87.87,0,0,0,341.46,277.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.26,281.7l12.92,7.4a2.07,2.07,0,0,1,.7-.71l3.71-2.14a.83.83,0,0,1,.7-.12l-11-6.33-1.19-.68-.42-.24-.23-.13a.76.76,0,0,0-.74.09L332,281A2.13,2.13,0,0,0,331.26,281.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.73,292.7l12.91,7.4a3,3,0,0,1,.56-1.34l3.2-4.31c.36-.48.78-.74,1-.67l-12.28-7.06-.55-.31c-.27-.16-.72.08-1.12.62l-3.21,4.33A2.66,2.66,0,0,0,321.73,292.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.71,307.27l.09.06.23.14,12.57,7.18a1.7,1.7,0,0,1,0-1.48l1.85-5.34a2.67,2.67,0,0,1,.73-1.16l-12.93-7.4a2.88,2.88,0,0,0-.71,1.16l-1.86,5.34C315.44,306.46,315.46,307.08,315.71,307.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,315.41v4.94c0,.48.13.81.34.93l1.28.74,11.59,6.64a1.17,1.17,0,0,1-.29-.9v-4.94a2.77,2.77,0,0,1,.26-1.15h0l-12.93-7.4A2.73,2.73,0,0,0,314,315.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.68,328l1.85,3.21a.87.87,0,0,0,.28.29l.87.5.33.19,2.72,1.57,9,5.12a.7.7,0,0,1-.25-.26l-1.85-3.21a1.76,1.76,0,0,1-.15-1l-12.91-7.41A1.55,1.55,0,0,0,315.68,328Z",
    style: {
      fill: "#37474f"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.74,
    cy: 313.82,
    rx: 16.99,
    ry: 9.61,
    transform: "translate(-77.79 509.99) rotate(-66.95)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.74,
    cy: 313.82,
    rx: 13.77,
    ry: 7.79,
    transform: "translate(-77.79 509.99) rotate(-66.95)",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.45,317.45c0-4.63,2.81-10,6.29-12s6.29.12,6.29,4.75-2.82,10-6.29,12S340.45,322.08,340.45,317.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.12,315.91c0-2.67,1.62-5.76,3.62-6.92s3.62.08,3.62,2.74-1.62,5.76-3.62,6.91S343.12,318.57,343.12,315.91Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.34,310.79a.93.93,0,0,1,.4-.75c.21-.13.39,0,.39.29a1,1,0,0,1-.39.76C346.52,311.21,346.34,311.08,346.34,310.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.73,313c-.15-.11-.15-.44,0-.74s.41-.44.56-.32.15.45,0,.74S344.89,313.16,344.73,313Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.3,315.75c-.22.13-.4,0-.4-.3a1,1,0,0,1,.4-.75c.21-.12.39,0,.39.3A1,1,0,0,1,344.3,315.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.29,317.33c-.15.29-.4.43-.56.32s-.15-.45,0-.74.41-.44.56-.32S345.44,317,345.29,317.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.13,316.85a1,1,0,0,1-.39.75c-.22.12-.4,0-.4-.3a.93.93,0,0,1,.4-.75C347,316.42,347.13,316.56,347.13,316.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.74,314.59c.16.12.16.45,0,.74s-.4.44-.55.32-.16-.44,0-.74S348.59,314.48,348.74,314.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18,311.88c.22-.12.39,0,.39.3a.92.92,0,0,1-.39.75c-.22.13-.39,0-.39-.29A1,1,0,0,1,349.18,311.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.19,310.31c.15-.3.4-.44.55-.32s.16.45,0,.74-.4.44-.55.32S348,310.6,348.19,310.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.28,314.66a3.5,3.5,0,0,1,1.46-2.79c.8-.47,1.46,0,1.46,1.1a3.53,3.53,0,0,1-1.46,2.8C345.93,316.23,345.28,315.74,345.28,314.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.15,326.37c-.73-.42-1.32-.07-1.32.77v17.07l-34.69-20.08v-17a2.91,2.91,0,0,0-1.32-2.28Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.15,326.37c-.73-.42-1.32-.07-1.32.77v17.07l-34.69-20.08v-17a2.91,2.91,0,0,0-1.32-2.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.87,343.42a2.8,2.8,0,0,0,.92-1.84c.14-1,.32-1.95.54-2.92a2,2,0,0,0-.11-1.44l-.29-.17c-.27-.16-.31-.8-.06-1.52l1.86-5.35c.27-.79.79-1.38,1.15-1.31s.92-.5,1.29-1.26c.45-.92.93-1.83,1.44-2.72a2.49,2.49,0,0,0,.38-2,2,2,0,0,1,.48-1.81l3.21-4.32c.4-.54.85-.79,1.12-.64l.55.32a1.65,1.65,0,0,0,.89-.52c.63-.64,1.28-1.25,1.94-1.82a2.79,2.79,0,0,0,1-1.81,2.09,2.09,0,0,1,1-1.59l3.7-2.14a.78.78,0,0,1,.75-.09l1.82,1.05a13.54,13.54,0,0,1,1.36-.26,1.86,1.86,0,0,0,1.31-1.2,1.26,1.26,0,0,1,1.24-.93l3.21.62a.66.66,0,0,1,.21.08l12.91,7.41a.88.88,0,0,1,.34,1l3.94,2.27a.71.71,0,0,1,.26.28l1.85,3.21a1.68,1.68,0,0,1-.14,1.72,2.39,2.39,0,0,0-.3,1.92,22.53,22.53,0,0,1,.53,2.32l1.31.75c.21.12.34.45.34.93v4.93a2.19,2.19,0,0,1-.72,1.75,2.74,2.74,0,0,0-.91,1.83c-.14,1-.31,2-.52,3a2,2,0,0,0,.09,1.43l.28.16c.27.16.3.8,0,1.53l-1.85,5.34c-.27.8-.77,1.39-1.11,1.32s-.9.51-1.27,1.27c-.46,1-.94,1.88-1.45,2.79a2.52,2.52,0,0,0-.41,1.91c.2.34,0,1.14-.5,1.78L405.26,363c-.4.54-.86.8-1.1.66l-.49-.28a1.68,1.68,0,0,0-.91.55c-.66.66-1.32,1.29-2,1.88a2.78,2.78,0,0,0-1,1.74,2,2,0,0,1-1,1.51l-3.7,2.13a.81.81,0,0,1-.77.11l-1.65-.95a13,13,0,0,1-1.56.31,1.75,1.75,0,0,0-1.29,1.11,1.19,1.19,0,0,1-1.22.85l-3.2-.62a.58.58,0,0,1-.22-.08l-12.91-7.4a.87.87,0,0,1-.34-1L368,361.25a.87.87,0,0,1-.28-.29l-1.85-3.21A1.72,1.72,0,0,1,366,356a2.4,2.4,0,0,0,.29-1.9,22.36,22.36,0,0,1-.52-2.34v0l-1.28-.74a1.05,1.05,0,0,1-.34-.93v-4.94A2.21,2.21,0,0,1,364.87,343.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,357.52v-4.94a2.18,2.18,0,0,1,.73-1.75,2.84,2.84,0,0,0,.92-1.84c.14-1,.32-1.95.53-2.92.18-.8.05-1.5-.3-1.57s-.42-.77-.15-1.56l1.85-5.35c.28-.79.79-1.38,1.15-1.31s.93-.5,1.3-1.26c.45-.93.93-1.84,1.43-2.72a2.5,2.5,0,0,0,.38-2,2.06,2.06,0,0,1,.49-1.81l3.21-4.32c.47-.65,1-.87,1.24-.51s.79.2,1.32-.33,1.28-1.25,1.94-1.82a2.79,2.79,0,0,0,1-1.81,2.09,2.09,0,0,1,1-1.59l3.7-2.14c.55-.32,1-.12,1,.44a.7.7,0,0,0,1,.68,13,13,0,0,1,1.94-.42,1.86,1.86,0,0,0,1.32-1.2,1.26,1.26,0,0,1,1.24-.93l3.21.62c.48.09.69.66.48,1.26a1.3,1.3,0,0,0,.38,1.51,10,10,0,0,1,1.44,1.07.86.86,0,0,0,1.3-.24c.35-.48.87-.49,1.14,0l1.86,3.21a1.72,1.72,0,0,1-.15,1.72,2.43,2.43,0,0,0-.31,1.92,20.18,20.18,0,0,1,.54,2.32c.11.65.51,1,.92.77s.73.17.73.91v4.93a2.19,2.19,0,0,1-.72,1.75,2.74,2.74,0,0,0-.91,1.83c-.14,1-.31,2-.52,3-.17.79-.06,1.49.29,1.56s.4.76.12,1.56l-1.85,5.34c-.27.8-.77,1.39-1.11,1.32s-.9.51-1.27,1.27c-.46,1-.94,1.88-1.45,2.79a2.52,2.52,0,0,0-.41,1.91c.2.34,0,1.14-.5,1.78L405.26,363c-.48.64-1,.89-1.21.55s-.77-.15-1.29.38-1.32,1.29-2,1.88a2.78,2.78,0,0,0-1,1.74,2,2,0,0,1-1,1.51l-3.7,2.13c-.55.32-1,.16-1-.36s-.44-.77-1-.61a12.64,12.64,0,0,1-2,.44,1.75,1.75,0,0,0-1.29,1.11,1.19,1.19,0,0,1-1.22.85l-3.2-.62c-.48-.09-.71-.62-.51-1.19a1.24,1.24,0,0,0-.4-1.45A10.23,10.23,0,0,1,383,368.2a.83.83,0,0,0-1.26.19.62.62,0,0,1-1.12,0l-1.85-3.21a1.7,1.7,0,0,1,.13-1.71,2.44,2.44,0,0,0,.29-1.9,22.33,22.33,0,0,1-.53-2.34c-.11-.65-.5-1-.9-.78S377.06,358.25,377.06,357.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.44,309.56l11,6.33.06,0a.62.62,0,0,1,.23.53.7.7,0,0,0,1,.69c.21-.07.41-.12.62-.17a10.76,10.76,0,0,1,1.33-.26,1.54,1.54,0,0,0,.8-.43l-12.9-7.42a1.5,1.5,0,0,1-.81.43C389.34,309.36,388.9,309.45,388.44,309.56Z",
    style: {
      fill: "#263238"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M380.77,313.45l12.92,7.41a2.29,2.29,0,0,0,.39-1.13,1.7,1.7,0,0,1,.29-.87l-12.92-7.4a1.67,1.67,0,0,0-.29.87A2.26,2.26,0,0,1,380.77,313.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.35,316.48l12.28,7.06.08,0a.27.27,0,0,1,.13.13.38.38,0,0,0,.44.17,1.57,1.57,0,0,0,.88-.51c.63-.64,1.28-1.25,1.95-1.82a2.8,2.8,0,0,0,.58-.69l-12.92-7.41a3.31,3.31,0,0,1-.59.69c-.66.57-1.31,1.17-1.94,1.82A1.65,1.65,0,0,1,377.35,316.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.44,329l12.93,7.4a.54.54,0,0,1,.42-.15c.36.07.93-.5,1.3-1.26.45-.93.93-1.84,1.43-2.73a2.42,2.42,0,0,0,.38-2,.79.79,0,0,1-.07-.48l-12.91-7.4a.7.7,0,0,0,.07.47,2.54,2.54,0,0,1-.38,2c-.51.88-1,1.79-1.43,2.72-.37.76-.94,1.33-1.3,1.26A.56.56,0,0,0,368.44,329Z",
    style: {
      fill: "#263238"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M381.37,336.43,368.44,329a.56.56,0,0,1,.44-.16.32.32,0,0,0,.19,0l12.92,7.4a.36.36,0,0,1-.2,0A.54.54,0,0,0,381.37,336.43Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M372,322.93a.7.7,0,0,1-.07-.47l12.91,7.4a.79.79,0,0,0,.07.48,1.13,1.13,0,0,1,.06.68L372,323.61A1.2,1.2,0,0,0,372,322.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.39,344l12.93,7.4a1.26,1.26,0,0,1,.47-.59,2.75,2.75,0,0,0,.91-1.84c.15-1,.33-1.94.54-2.92a1.83,1.83,0,0,0-.12-1.46h0l-.17-.1-.15-.09-12.57-7.19a1.93,1.93,0,0,1,.11,1.43c-.22,1-.39,2-.54,2.93a2.84,2.84,0,0,1-.92,1.84A1.51,1.51,0,0,0,364.39,344Z",
    style: {
      fill: "#263238"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M364.87,343.42a1.57,1.57,0,0,0,.55-.68l12.92,7.41a1.7,1.7,0,0,1-.55.68,1.26,1.26,0,0,0-.47.59L364.39,344A1.51,1.51,0,0,1,364.87,343.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,356.7l12.92,7.41a1.54,1.54,0,0,1,.27-.66,2,2,0,0,0,.33-.9,2.19,2.19,0,0,0,0-1,22.93,22.93,0,0,1-.53-2.34v0c-.11-.65-.49-1-.9-.78a.38.38,0,0,1-.43,0l-11.59-6.64v0c.15.82.33,1.61.53,2.34A2.36,2.36,0,0,1,366,356,1.49,1.49,0,0,0,365.73,356.7Z",
    style: {
      fill: "#263238"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M378.92,363.45a1.54,1.54,0,0,0-.27.66l-12.92-7.41A1.49,1.49,0,0,1,366,356a2,2,0,0,0,.32-.82l12.92,7.4A2.15,2.15,0,0,1,378.92,363.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.34,318a9.76,9.76,0,0,1,1.43,1.08.87.87,0,0,0,1.3-.25.67.67,0,0,1,.84-.3l-.05,0L409,316.24c0,.06,0,.14-.05.22A1.29,1.29,0,0,0,409.34,318Z",
    style: {
      fill: "#263238"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M372.26,364.46a0,0,0,0,1,0,0l0,0,.24.14L385,371.79l.11,0a.91.91,0,0,1-.26-1.08,1.24,1.24,0,0,0-.4-1.45A9.54,9.54,0,0,1,383,368.2a.83.83,0,0,0-1.26.19.67.67,0,0,1-.73.32l-.14-.08-9-5.12A.85.85,0,0,0,372.26,364.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392.67,370.3l1.64.95a.48.48,0,0,1-.23-.46c0-.52-.45-.78-1-.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.69,363.34l.38.21,0-.05A.32.32,0,0,0,403.69,363.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,328c.11.65.51,1,.91.77a.43.43,0,0,1,.34-.05l-.11-.06-.19-.11Z",
    style: {
      fill: "#263238"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M390.6,308.86l12.9,7.42a1.88,1.88,0,0,0,.52-.77,1.43,1.43,0,0,1,.55-.73l-12.92-7.41a1.5,1.5,0,0,0-.55.74A1.9,1.9,0,0,1,390.6,308.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.59,350.23c0,8,2.68,13.67,6.89,16.1l2.85,1.63c-4.15-2.46-6.77-8.08-6.77-16,0-14.65,8.9-31.67,19.89-38,4.74-2.74,9.09-3,12.51-1.32l-2.44-1.41c-3.5-2-8-1.84-13,1C377.5,318.56,368.59,335.59,368.59,350.23Z",
    style: {
      fill: "#37474f"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M371.56,351.93c0,7.95,2.62,13.57,6.77,16l.86.45c-4.14-2.46-5.72-7.43-5.72-15.37,0-14.65,8.91-31.67,19.9-38,4.91-2.84,8.36-3.7,11.84-1.76l-1.25-.68c-3.42-1.71-7.77-1.42-12.51,1.33C380.46,320.26,371.56,337.28,371.56,351.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,307.37l12.92,7.41a.89.89,0,0,1,.69-.2l1.33.26,1.88.36.12,0-.2-.13-11.74-6.73-.27-.15-.28-.16L396,308l-.14-.09-.09-.05-.1-.05-.11,0-3.21-.62A.87.87,0,0,0,391.65,307.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.45,311.46l12.92,7.4a2.07,2.07,0,0,1,.7-.71l3.71-2.14a.83.83,0,0,1,.7-.12l-11-6.33-1.19-.68-.42-.24-.22-.13a.78.78,0,0,0-.75.09l-3.7,2.14A2.13,2.13,0,0,0,381.45,311.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.92,322.46l12.91,7.4a3,3,0,0,1,.56-1.34l3.2-4.31c.36-.48.78-.74,1-.67l-12.28-7.06-.55-.31c-.27-.16-.72.08-1.12.62l-3.21,4.33A2.76,2.76,0,0,0,371.92,322.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.9,337l.09.06.23.13,12.57,7.19a1.7,1.7,0,0,1,0-1.48l1.85-5.34a2.67,2.67,0,0,1,.73-1.16L368.44,329a2.88,2.88,0,0,0-.71,1.16l-1.86,5.34C365.64,336.22,365.65,336.84,365.9,337Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.14,345.17v4.94c0,.48.13.81.34.93l1.28.74,11.59,6.64a1.17,1.17,0,0,1-.29-.9v-4.94a2.77,2.77,0,0,1,.26-1.15h0L364.39,344A2.89,2.89,0,0,0,364.14,345.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.87,357.74l1.85,3.22a.87.87,0,0,0,.28.29l.88.5.32.19,2.72,1.57,9,5.12a.78.78,0,0,1-.25-.26l-1.85-3.21a1.69,1.69,0,0,1-.14-1.05l-12.92-7.41A1.51,1.51,0,0,0,365.87,357.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.93,
    cy: 343.58,
    rx: 16.99,
    ry: 9.61,
    transform: "translate(-74.64 574.28) rotate(-66.95)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.93,
    cy: 343.58,
    rx: 13.77,
    ry: 7.79,
    transform: "translate(-74.63 574.29) rotate(-66.95)",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.64,347.21c0-4.63,2.81-10,6.29-12s6.29.12,6.29,4.75-2.82,10-6.29,12S390.64,351.84,390.64,347.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.31,345.67c0-2.67,1.62-5.76,3.62-6.92s3.62.08,3.62,2.74-1.62,5.76-3.62,6.91S393.31,348.33,393.31,345.67Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.53,340.55a.93.93,0,0,1,.4-.75c.22-.13.39,0,.39.29a1,1,0,0,1-.39.76C396.71,341,396.53,340.84,396.53,340.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.92,342.8c-.15-.11-.15-.44,0-.74s.41-.44.56-.32.15.45,0,.74S395.08,342.92,394.92,342.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.49,345.51c-.22.13-.4,0-.4-.3a.94.94,0,0,1,.4-.75c.21-.12.39,0,.39.3A1,1,0,0,1,394.49,345.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.48,347.09c-.15.29-.4.43-.56.32s-.15-.45,0-.74.41-.44.56-.32S395.63,346.79,395.48,347.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.32,346.61a.93.93,0,0,1-.39.75c-.22.12-.4,0-.4-.3a.93.93,0,0,1,.4-.75C397.15,346.18,397.32,346.32,397.32,346.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.93,344.35c.16.12.16.45,0,.74s-.4.44-.55.32-.16-.44,0-.74S398.78,344.24,398.93,344.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.37,341.64c.22-.12.39,0,.39.3a.92.92,0,0,1-.39.75c-.22.13-.39,0-.39-.3A.93.93,0,0,1,399.37,341.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.38,340.07c.15-.3.4-.44.55-.32s.16.44,0,.74-.4.44-.55.32S398.22,340.36,398.38,340.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.47,344.42a3.5,3.5,0,0,1,1.46-2.79c.81-.47,1.46,0,1.46,1.1a3.51,3.51,0,0,1-1.46,2.8C396.12,346,395.47,345.5,395.47,344.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.37,280.17l1.92-5.57,16.5-47.78,21.64,12.43,28.38,16.3L378.24,309Zm-5.76,1.63v16.56l11.21,6.47,37.33,21.55,10.92,6.3c3.71-7.26,8.92-13.46,14.68-16.78,9-5.18,16.57-1.86,19.31,7.28l15.7-9.07V236L372.3,201.65l-25.09,14.48-.06,0-1.38.8a2.07,2.07,0,0,0-.25.15,7.68,7.68,0,0,0-2.41,2.86,11.06,11.06,0,0,0-.6,1.41l-19.43,57.72A8.52,8.52,0,0,0,322.61,281.8Zm66.31,24.69,16.16-49.33a5,5,0,0,1,2-2.7l19.51-11.27a1.58,1.58,0,0,1,1.17-.22,2.89,2.89,0,0,1,.16,1v40.79a3.93,3.93,0,0,1-1.64,3.13L390,308.82a1.55,1.55,0,0,1-1.17.23A4.15,4.15,0,0,1,388.92,306.49Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.3,201.64l-25.09,14.49a.09.09,0,0,1-.06,0l-1.38.81-.25.15a7.68,7.68,0,0,0-2.41,2.86,7.93,7.93,0,0,0-.59,1.41l-19.44,57.73a8.41,8.41,0,0,0-.47,2.68v16.56l11.21,6.47,37.33,21.55,10.92,6.3c3.71-7.26,8.92-13.46,14.67-16.78,9-5.18,16.58-1.86,19.32,7.28l15.7-9.07V236ZM378.24,309l-49.87-28.79,1.93-5.57,16.49-47.78,21.64,12.43,28.38,16.31Zm49.65-24.21a3.94,3.94,0,0,1-1.64,3.13L390,308.82a1.6,1.6,0,0,1-1.17.24,4.18,4.18,0,0,1,.11-2.57l16.16-49.33a5,5,0,0,1,2-2.7l19.51-11.27a1.53,1.53,0,0,1,1.17-.21,2.73,2.73,0,0,1,.16,1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.81 255.56 378.24 308.96 328.37 280.17 330.3 274.6 346.79 226.82 368.43 239.25 396.81 255.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.52,218,404,252.3a6,6,0,0,1,1.25-1L431.76,236,372.3,201.65l-25.09,14.48-.06,0-1.38.8a2.07,2.07,0,0,0-.25.15A6.45,6.45,0,0,0,344.52,218Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.46,216l-1.69,1a8.2,8.2,0,0,0-3.25,4.43l-19.44,57.72a8.57,8.57,0,0,0-.47,2.69v1.57S339.94,231.6,342,225.56,344.74,217.56,347.46,216Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.58,308.79l-19.8-11.28a2.66,2.66,0,0,0-4.32,2.49v11a8.31,8.31,0,0,0,3.81,6.59l19.8,11.28a3.74,3.74,0,0,0,1.84.56,2.29,2.29,0,0,0,1.18-.31,3,3,0,0,0,1.3-2.74v-11A8.33,8.33,0,0,0,362.58,308.79Zm-22.88,3.65a5.48,5.48,0,0,1-.21-1.41v-.34l25.82,14.76.05,0v.94a3.55,3.55,0,0,1-.06.67Zm25.66,6.24-25.82-14.76-.05,0v-1.64L365.31,317l.05,0Zm-25.87-13.61,25.82,14.76.05,0v1.64l-25.82-14.76-.05,0Zm0,2.81,25.82,14.76.05,0v1.64l-25.82-14.76-.05,0Zm25.87,7.51v.48l-25.82-14.76-.05,0V300a4.39,4.39,0,0,1,0-.53l25.66,14.68A5.36,5.36,0,0,1,365.36,315.39Zm-25.09-17.24a1.26,1.26,0,0,1,.67-.17,2.7,2.7,0,0,1,1.33.42l19.8,11.28a7,7,0,0,1,2.59,3L339.9,298.5A1.12,1.12,0,0,1,340.27,298.15ZM362.58,328l-19.8-11.28A6.78,6.78,0,0,1,340.3,314L364.87,328a1,1,0,0,1-.29.25A2,2,0,0,1,362.58,328Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.88,309.15l-19.8-11.28a2.66,2.66,0,0,0-4.32,2.49v11a8.29,8.29,0,0,0,3.81,6.59l19.8,11.28a3.71,3.71,0,0,0,1.84.56,2.29,2.29,0,0,0,1.18-.31,3,3,0,0,0,1.29-2.74v-11A8.32,8.32,0,0,0,361.88,309.15ZM339,312.79a5.77,5.77,0,0,1-.2-1.4v-.34l25.82,14.76h.05v.95a3.37,3.37,0,0,1-.06.66ZM364.66,319l-25.82-14.76,0,0v-1.64l25.82,14.76.05,0Zm-25.87-13.61,25.82,14.76.05,0v1.64l-25.82-14.76,0,0Zm0,2.81L364.61,323l.05,0v1.64l-25.82-14.77h0Zm25.87,7.5v.49l-25.82-14.76,0,0v-1.09a4.39,4.39,0,0,1,0-.53l25.66,14.67A5.51,5.51,0,0,1,364.66,315.74ZM339.57,298.5a1.35,1.35,0,0,1,.67-.16,2.78,2.78,0,0,1,1.33.41L361.37,310a7.1,7.1,0,0,1,2.59,3l-24.77-14.16A1.3,1.3,0,0,1,339.57,298.5Zm22.31,29.87-19.8-11.28a6.94,6.94,0,0,1-2.49-2.77l24.58,14.05a1.13,1.13,0,0,1-.29.25A2,2,0,0,1,361.88,328.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.69,319.17v4.19a1.48,1.48,0,0,1-.66,1.15l-1.16.66a1.46,1.46,0,0,1-1.32,0l-8.59-5a1.47,1.47,0,0,1-.66-1.14v-4.2c0-.42.3-.59.66-.38l8.59,5a1.46,1.46,0,0,0,1.32,0l1.16-.67C384.39,318.57,384.69,318.74,384.69,319.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.61 285.42 332.66 291.23 332.66 296.95 322.61 291.14 322.61 285.42",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.8 200.78 433.26 235.11 431.76 235.97 372.3 201.65 373.8 200.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.07,316.13v16.55c3.71-7.26,8.92-13.46,14.68-16.78,9-5.18,16.57-1.86,19.31,7.28l15.7-9.07V236l-26.53,15.32a8.23,8.23,0,0,0-3.26,4.43l-19.43,57.72A8.57,8.57,0,0,0,382.07,316.13Zm6.85-9.64,16.16-49.33a5,5,0,0,1,2-2.7l19.51-11.27a1.58,1.58,0,0,1,1.17-.22,2.89,2.89,0,0,1,.16,1v40.79a3.93,3.93,0,0,1-1.64,3.13L390,308.82a1.55,1.55,0,0,1-1.17.23A4.15,4.15,0,0,1,388.92,306.49Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.23,251.29a8.19,8.19,0,0,0-3.26,4.42l-19.43,57.73a8.57,8.57,0,0,0-.47,2.69v16.55c3.71-7.26,8.92-13.46,14.67-16.78,9-5.18,16.58-1.86,19.32,7.28l15.7-9.07V236Zm22.66,33.46a3.94,3.94,0,0,1-1.64,3.13L390,308.82a1.6,1.6,0,0,1-1.17.24,4.18,4.18,0,0,1,.11-2.57l16.16-49.33a5,5,0,0,1,2-2.7l19.51-11.27a1.53,1.53,0,0,1,1.17-.21,2.73,2.73,0,0,1,.16,1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.92,250.32l-1.69,1a8.2,8.2,0,0,0-3.25,4.43l-19.44,57.72a8.57,8.57,0,0,0-.47,2.69v1.57s17.33-51.77,19.41-57.81S404.2,251.88,406.92,250.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,244v40.8a3.94,3.94,0,0,1-1.64,3.13L390,308.82a1.6,1.6,0,0,1-1.17.24,4.18,4.18,0,0,1,.11-2.57l16.16-49.33a5,5,0,0,1,2-2.7l19.51-11.27a1.53,1.53,0,0,1,1.17-.21A2.73,2.73,0,0,1,427.89,244Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Barrier--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--barrier--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.84,384.69l-3.22,1.86a1.27,1.27,0,0,1-1.17,0l-1-.59a1,1,0,0,1-.45-1l10.69-50.61a1.78,1.78,0,0,1,.72-1l3.22-1.85a1.27,1.27,0,0,1,1.17,0l1,.59a1,1,0,0,1,.44,1l-10.69,50.6A1.74,1.74,0,0,1,278.84,384.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.84,384.69l-3.22,1.86c-.32.19-.52,0-.45-.32l10.69-50.61a1.72,1.72,0,0,1,.73-1l3.22-1.86c.32-.18.52,0,.44.33l-10.69,50.6A1.74,1.74,0,0,1,278.84,384.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 381.39 278.07 376.87 280.27 375.61 300.58 387.34 301.54 392.95 299.34 394.22 277.12 381.39",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.34 394.22 277.12 381.39 278.07 376.87 298.39 388.6 299.34 394.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,398.62l-3.22,1.86a1.27,1.27,0,0,1-1.17,0l-1-.59a1.62,1.62,0,0,1-.7-1l-10.74-63.27a1,1,0,0,1,.47-1l3.22-1.86a1.33,1.33,0,0,1,1.17,0l1,.59a1.65,1.65,0,0,1,.7,1l10.74,63.26A1,1,0,0,1,303,398.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.12,335.62l.4,2.4,10.34,60.86a1.68,1.68,0,0,0,.69,1l1,.59a1.27,1.27,0,0,0,1.17,0l3.22-1.86a1,1,0,0,0,.47-1l-10.7-63,0-.22a1.69,1.69,0,0,0-.7-1l-1-.59a1.36,1.36,0,0,0-1.18,0l-3.21,1.86A1,1,0,0,0,286.12,335.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.7,334.36l10.74,63.26a1,1,0,0,1-.47,1l-3.22,1.86a.44.44,0,0,1-.7-.33l-10.74-63.26a1,1,0,0,1,.47-1L292,334A.44.44,0,0,1,292.7,334.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.15,336.82l1.69,1a2.57,2.57,0,0,0,1.68.23,2.08,2.08,0,0,0,.65-.23l5.57-3.21,0-.22a1.69,1.69,0,0,0-.7-1l-1-.59a1.36,1.36,0,0,0-1.18,0c.09-.36.33-.49,0-.67l-1-.59a1.27,1.27,0,0,0-1.17,0l-3.22,1.85a1.78,1.78,0,0,0-.72,1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,332.87a.82.82,0,0,1,.48-.68l6.44-3.72a2.61,2.61,0,0,1,2.34,0l3.15,1.82a.83.83,0,0,1,.48.67c0,.25,0,1.22,0,1.47a.83.83,0,0,1-.48.67l-6.44,3.72a2.61,2.61,0,0,1-2.34,0L281.68,335a.83.83,0,0,1-.48-.67C281.19,334.08,281.2,333.11,281.2,332.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,332.87a.82.82,0,0,1,.48-.68l4.32-2.5v7.41a2.5,2.5,0,0,1-1.17-.28L281.68,335a.83.83,0,0,1-.48-.67C281.19,334.08,281.2,333.11,281.2,332.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.17,335.36l6.44-3.72a.71.71,0,0,0,0-1.35l-3.15-1.82a2.61,2.61,0,0,0-2.34,0l-6.44,3.72a.71.71,0,0,0,0,1.35l3.15,1.82A2.61,2.61,0,0,0,287.17,335.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.21,325h0L289,323.76h0a2.34,2.34,0,0,0-2.35.35,7.46,7.46,0,0,0-3.08,6,2.39,2.39,0,0,0,1.09,2.12h0l2.18,1.28h0a2.39,2.39,0,0,0,2.36-.36,7.4,7.4,0,0,0,3.07-6A2.38,2.38,0,0,0,291.21,325Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.81,333.47l-2.13-1.26h0a2.39,2.39,0,0,1-1.09-2.12,6.84,6.84,0,0,1,.65-3l2.18,1.28a6.57,6.57,0,0,0-.65,3A2.4,2.4,0,0,0,286.81,333.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.22,333.14a7.4,7.4,0,0,0,3.07-6c-.1-2.14-1.64-2.93-3.45-1.77a7.42,7.42,0,0,0-3.07,6C285.87,333.51,287.42,334.3,289.22,333.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.71,333c-1.06.05-1.24-1.14-1.26-1.66a6.81,6.81,0,0,1,2.76-5.37,2.47,2.47,0,0,1,1.14-.42c1.07-.05,1.24,1.14,1.26,1.66a6.75,6.75,0,0,1-2.76,5.37,2.32,2.32,0,0,1-1.14.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.21,326a2.54,2.54,0,0,1,1-.4,2.69,2.69,0,0,1,.3,1.13,6.79,6.79,0,0,1-2.77,5.37,2.51,2.51,0,0,1-1,.41,2.59,2.59,0,0,1-.29-1.14A6.81,6.81,0,0,1,289.21,326Z",
    style: {
      fill: "#44C9F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,413.83l-3.22,1.85a1.27,1.27,0,0,1-1.17,0l-1-.59a1,1,0,0,1-.44-1l10.69-50.6a1.7,1.7,0,0,1,.72-1l3.22-1.86a1.33,1.33,0,0,1,1.17,0l1,.59a1,1,0,0,1,.45,1L229.1,412.83A1.75,1.75,0,0,1,228.37,413.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,413.83l-3.22,1.85c-.32.19-.52.05-.44-.32l10.69-50.61a1.72,1.72,0,0,1,.72-1l3.22-1.86c.32-.19.52,0,.45.32L229.1,412.83A1.75,1.75,0,0,1,228.37,413.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.6 410.6 227.55 406.08 229.74 404.82 250.06 416.55 251.01 422.17 248.82 423.43 226.6 410.6",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.82 423.43 226.6 410.6 227.55 406.08 247.87 417.81 248.82 423.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5,427.76l-3.22,1.86a1.31,1.31,0,0,1-1.16,0l-1-.6a1.64,1.64,0,0,1-.7-1l-10.74-63.26a1,1,0,0,1,.47-1l3.22-1.86a1.27,1.27,0,0,1,1.17,0l1,.59a1.62,1.62,0,0,1,.7,1L253,426.75A1,1,0,0,1,252.5,427.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.65,364.76l.41,2.39L246.39,428a1.64,1.64,0,0,0,.7,1l1,.6a1.36,1.36,0,0,0,1.18,0l3.21-1.86a1.08,1.08,0,0,0,.48-1l-10.71-63.05,0-.22a1.62,1.62,0,0,0-.69-1l-1-.59a1.27,1.27,0,0,0-1.17,0l-3.22,1.85A1.06,1.06,0,0,0,235.65,364.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.23,363.49,253,426.75a1,1,0,0,1-.47,1l-3.22,1.86a.43.43,0,0,1-.69-.33L237.85,366a1,1,0,0,1,.47-1l3.21-1.85A.44.44,0,0,1,242.23,363.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.69,366l1.68,1a2.53,2.53,0,0,0,1.69.23,2,2,0,0,0,.65-.23l5.56-3.21,0-.22a1.62,1.62,0,0,0-.69-1l-1-.59a1.27,1.27,0,0,0-1.17,0c.08-.37.32-.49,0-.68l-1-.59a1.27,1.27,0,0,0-1.17,0l-3.22,1.86a1.69,1.69,0,0,0-.73,1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.73,362a.83.83,0,0,1,.49-.69l6.43-3.71a2.54,2.54,0,0,1,2.34,0l3.15,1.82a.83.83,0,0,1,.49.66v1.47a.82.82,0,0,1-.49.68L236.71,366a2.54,2.54,0,0,1-2.34,0l-3.15-1.82a.83.83,0,0,1-.49-.66C230.73,363.22,230.74,362.25,230.73,362Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.73,362a.83.83,0,0,1,.49-.69l4.32-2.49v7.4a2.36,2.36,0,0,1-1.17-.28l-3.15-1.82a.83.83,0,0,1-.49-.66C230.73,363.22,230.74,362.25,230.73,362Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.71,364.49l6.43-3.71c.65-.38.65-1,0-1.35L240,357.61a2.54,2.54,0,0,0-2.34,0l-6.43,3.71c-.65.38-.65,1,0,1.35l3.15,1.82A2.54,2.54,0,0,0,236.71,364.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.75,354.18h0l-2.17-1.27h0a2.39,2.39,0,0,0-2.36.36,7.4,7.4,0,0,0-3.07,6,2.38,2.38,0,0,0,1.08,2.13h0l2.17,1.28h0a2.34,2.34,0,0,0,2.35-.35,7.43,7.43,0,0,0,3.08-6A2.35,2.35,0,0,0,240.75,354.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,362.6l-2.13-1.25h0a2.35,2.35,0,0,1-1.08-2.12,6.62,6.62,0,0,1,.65-3L236,357.5a6.76,6.76,0,0,0-.65,3A2.38,2.38,0,0,0,236.35,362.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75,362.28a7.43,7.43,0,0,0,3.08-6c-.1-2.14-1.65-2.94-3.45-1.78a7.47,7.47,0,0,0-3.08,6C235.41,362.64,237,363.44,238.75,362.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.24,362.13c-1.06.05-1.23-1.14-1.26-1.66a6.79,6.79,0,0,1,2.77-5.37,2.45,2.45,0,0,1,1.14-.43c1.06-.05,1.23,1.15,1.26,1.66a6.81,6.81,0,0,1-2.76,5.37,2.38,2.38,0,0,1-1.15.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75,355.1a2.51,2.51,0,0,1,1-.41,2.52,2.52,0,0,1,.29,1.13,6.78,6.78,0,0,1-2.76,5.37,2.43,2.43,0,0,1-1,.41,2.69,2.69,0,0,1-.3-1.13A6.79,6.79,0,0,1,238.75,355.1Z",
    style: {
      fill: "#44C9F6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "233.34 372.96 301.35 333.7 300.24 333.06 232.24 372.32 233.34 372.96",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.34 372.96 301.35 333.7 300.24 333.06 232.24 372.32 233.34 372.96",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.34 372.96 236.65 392.6 304.65 353.33 301.35 333.7 233.34 372.96",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.24 372.32 235.54 391.96 236.65 392.6 233.34 372.96 232.24 372.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.93 376.41 234.75 387.27 235.86 387.91 234.03 377.05 232.93 376.41",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "232.93 376.41 234.75 387.27 235.86 387.91 234.03 377.05",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.58 369.36 236.65 392.6 233.34 372.96 239.58 369.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.41 356.94 301.35 333.7 304.65 353.33 298.41 356.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.06 386 251 362.76 244.25 366.66 241.31 389.9 248.06 386",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.48 379.41 262.42 356.17 255.67 360.07 252.73 383.31 259.48 379.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.9 372.82 273.84 349.58 267.09 353.48 264.15 376.71 270.9 372.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.32 366.23 285.26 342.99 278.51 346.88 275.57 370.12 282.32 366.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.74 359.63 296.68 336.39 289.93 340.29 286.99 363.53 293.74 359.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.25 366.66 243.14 366.02 249.9 362.13 251 362.76 244.25 366.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.67 360.07 254.56 359.43 261.32 355.53 262.42 356.17 255.67 360.07",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.09 353.48 265.98 352.84 272.74 348.94 273.84 349.58 267.09 353.48",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.51 346.88 277.4 346.24 284.16 342.35 285.26 342.99 278.51 346.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.93 340.29 288.82 339.65 295.58 335.76 296.68 336.39 289.93 340.29",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.34 372.96 232.24 372.32 238.48 368.72 239.58 369.36 233.34 372.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.03 377.05 235.86 387.91 303.86 348.65 302.04 337.79 234.03 377.05",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.68,383.63a1.7,1.7,0,0,1-.71-1.33l-.75-4.72q-.06-.33.36-.57l.29-.16c.28-.16.44-.14.47.08l.74,4.62a.86.86,0,0,0,.27.58.4.4,0,0,0,.49,0,.94.94,0,0,0,.4-.52,1.65,1.65,0,0,0,.06-.77l-.74-4.62c0-.21.09-.4.37-.56l.28-.16c.28-.16.44-.14.47.08l.75,4.72a3.29,3.29,0,0,1-.2,1.86,2.76,2.76,0,0,1-1.18,1.3A1.36,1.36,0,0,1,238.68,383.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.46,381.65l-1-6.5c0-.22.09-.4.37-.56l.19-.11a.36.36,0,0,1,.24-.08c.06,0,.12.05.18.14l1.82,2.57a5.66,5.66,0,0,1,.37.65l0,0a6.4,6.4,0,0,1-.19-.77l-.51-3.24c0-.21.08-.4.36-.56l.17-.1c.28-.16.44-.14.47.08l1,6.5c0,.22-.09.4-.37.56l-.14.08a.45.45,0,0,1-.24.09c-.07,0-.13-.05-.19-.15l-1.92-2.65a4.37,4.37,0,0,1-.3-.54l0,.05a5.91,5.91,0,0,1,.16.66l.54,3.34c0,.22-.09.4-.37.56l-.17.1C242.65,381.89,242.49,381.87,242.46,381.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,379.35a.43.43,0,0,1-.11-.27l-1-6.3a.78.78,0,0,1,0-.35.39.39,0,0,1,.19-.21l1.37-.79a1.13,1.13,0,0,1,1.52.08,4.93,4.93,0,0,1,.86,2.42,7.3,7.3,0,0,1,0,2.93,2.67,2.67,0,0,1-1.24,1.68l-1.37.79C247,379.38,246.89,379.39,246.84,379.35Zm1.34-2.12a1.08,1.08,0,0,0,.47-.82,7,7,0,0,0-.11-1.82,5.26,5.26,0,0,0-.44-1.62.41.41,0,0,0-.63-.19L247,373l.71,4.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,377a.38.38,0,0,1-.12-.27l-1-6.3a.66.66,0,0,1,0-.35.37.37,0,0,1,.18-.21l2.13-1.23a.12.12,0,0,1,.17,0,.82.82,0,0,1,.12.36l.05.31a1.52,1.52,0,0,1,0,.42.3.3,0,0,1-.14.21l-1.27.73.23,1.48,1.13-.65a.13.13,0,0,1,.18,0,1,1,0,0,1,.11.36l0,.31a1.15,1.15,0,0,1,0,.41.3.3,0,0,1-.14.22l-1.12.65.26,1.64,1.27-.73a.13.13,0,0,1,.18,0,1,1,0,0,1,.11.36l.05.31a1.52,1.52,0,0,1,0,.42.29.29,0,0,1-.13.21l-2.14,1.23C251.12,377,251.05,377,251,377Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.17,374.89l-1-6.4a.66.66,0,0,1,0-.35.47.47,0,0,1,.2-.22l1.21-.7a1.2,1.2,0,0,1,1.13-.15c.32.15.54.59.65,1.31a2.89,2.89,0,0,1-.41,2.11v0a.59.59,0,0,1,.35.24,1.59,1.59,0,0,1,.29.49l.74,1.71,0,.11c0,.18-.1.36-.4.53l-.26.15c-.25.14-.41.14-.47,0l-.69-1.71a.52.52,0,0,0-.2-.23q-.09,0-.27.06l-.18.1.37,2.3c0,.22-.09.41-.38.57l-.25.14C254.37,375.13,254.2,375.11,254.17,374.89Zm.91-4.65a.57.57,0,0,0,.23-.38,1.56,1.56,0,0,0,0-.72.89.89,0,0,0-.21-.55.24.24,0,0,0-.32,0l-.38.22.27,1.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.11,371.5a4.87,4.87,0,0,1-.9-2.51,7,7,0,0,1,0-3,2.84,2.84,0,0,1,1.34-1.75,2.16,2.16,0,0,1,.64-.25c.16,0,.26.08.3.31a2.63,2.63,0,0,1,0,.74c0,.25-.1.37-.2.38a1.19,1.19,0,0,0-.48.16,1.26,1.26,0,0,0-.56.93,5.76,5.76,0,0,0,.06,1.82,4.15,4.15,0,0,0,.48,1.58.53.53,0,0,0,.78.17,1,1,0,0,0,.22-.16,2.45,2.45,0,0,0,.23-.23l.06,0c.1-.06.19,0,.26.13a1.84,1.84,0,0,1,.18.62.71.71,0,0,1,0,.29.56.56,0,0,1-.14.26,2.25,2.25,0,0,1-.31.3,3,3,0,0,1-.41.28C260,371.92,259.5,371.91,259.11,371.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35,367.19c-.39-2.42,0-4,1.31-4.72a1.17,1.17,0,0,1,1.54.07,4.67,4.67,0,0,1,.92,2.48,7.18,7.18,0,0,1,0,3,2.77,2.77,0,0,1-1.26,1.69Q261.93,370.84,261.35,367.19ZM264,368a2.34,2.34,0,0,0,.12-.84,10.34,10.34,0,0,0-.14-1.45,8.5,8.5,0,0,0-.3-1.33,1,1,0,0,0-.35-.57.41.41,0,0,0-.45,0,1,1,0,0,0-.39.45,2.13,2.13,0,0,0-.13.85,8.7,8.7,0,0,0,.14,1.43,7.79,7.79,0,0,0,.3,1.35,1.11,1.11,0,0,0,.36.57.44.44,0,0,0,.45,0A.91.91,0,0,0,264,368Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28,367.89l-1-6.5c0-.21.09-.4.37-.56l.18-.11a.48.48,0,0,1,.24-.08.24.24,0,0,1,.18.15l1.82,2.56c.1.14.22.36.38.65l0,0a7.63,7.63,0,0,1-.18-.76l-.52-3.24c0-.22.09-.41.37-.57l.17-.1c.28-.16.43-.13.47.08l1,6.5c0,.22-.09.41-.37.57l-.14.08a.56.56,0,0,1-.24.08.23.23,0,0,1-.19-.14l-1.93-2.66a4.37,4.37,0,0,1-.3-.54l0,.05a4.58,4.58,0,0,1,.17.66l.53,3.34q.06.33-.36.57l-.18.1C266.47,368.14,266.32,368.11,266.28,367.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,365.44a.68.68,0,0,1-.57-.11.54.54,0,0,1-.15-.3,2,2,0,0,1,0-.64c0-.24.1-.38.19-.43a.31.31,0,0,1,.2,0l.21,0a.8.8,0,0,0,.52-.08,1,1,0,0,0,.37-.38,1,1,0,0,0,.08-.62.82.82,0,0,0-.16-.41.52.52,0,0,0-.26-.19,2,2,0,0,0-.41-.1,1.67,1.67,0,0,1-.94-.46,2.28,2.28,0,0,1-.46-1.17,3,3,0,0,1,.19-1.67,2.41,2.41,0,0,1,1-1.16,1.6,1.6,0,0,1,.53-.19.9.9,0,0,1,.47,0,.3.3,0,0,1,.18.27,2.44,2.44,0,0,1,0,.61c0,.23-.08.37-.16.41a.39.39,0,0,1-.22,0,1.1,1.1,0,0,0-.49.12.78.78,0,0,0-.37.4,1.05,1.05,0,0,0,0,.46.7.7,0,0,0,.23.49,1.36,1.36,0,0,0,.52.18l.18,0a1.44,1.44,0,0,1,.86.46,2.23,2.23,0,0,1,.42,1.1,3.7,3.7,0,0,1,0,1.15,2.93,2.93,0,0,1-.4,1.08,2.36,2.36,0,0,1-.83.8A1.94,1.94,0,0,1,271,365.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.37,363.23l-.87-5.48-.8.46a.13.13,0,0,1-.18,0,1,1,0,0,1-.11-.35l-.05-.32a1.21,1.21,0,0,1,0-.42.32.32,0,0,1,.14-.21l2.74-1.58a.13.13,0,0,1,.18,0,.71.71,0,0,1,.11.35l.05.32a1,1,0,0,1,0,.41.3.3,0,0,1-.14.22l-.81.47.87,5.47q.06.33-.36.57l-.3.17C274.56,363.47,274.41,363.44,274.37,363.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,361.73l-1-6.4a.67.67,0,0,1,0-.35.49.49,0,0,1,.21-.22l1.2-.7a1.22,1.22,0,0,1,1.14-.15c.32.15.53.59.65,1.31a2.89,2.89,0,0,1-.41,2.11v0a.65.65,0,0,1,.35.24,2.11,2.11,0,0,1,.29.49l.73,1.71.05.11c0,.18-.11.36-.41.53l-.25.15c-.25.14-.41.14-.48,0l-.68-1.71a.59.59,0,0,0-.2-.23.32.32,0,0,0-.28.06l-.17.1.36,2.3c0,.21-.09.41-.38.57l-.24.14C277.16,362,277,361.94,277,361.73Zm.92-4.65a.61.61,0,0,0,.23-.38,1.9,1.9,0,0,0,0-.72,1.12,1.12,0,0,0-.21-.56.26.26,0,0,0-.33,0l-.38.22.27,1.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,359.16a1.72,1.72,0,0,1-.72-1.33l-.75-4.72c0-.22.09-.41.37-.57l.29-.16c.28-.17.43-.14.47.08l.73,4.62a.91.91,0,0,0,.28.58.39.39,0,0,0,.48,0,1,1,0,0,0,.41-.52,1.65,1.65,0,0,0,.06-.77l-.74-4.62c0-.22.09-.4.37-.56l.28-.17c.28-.16.43-.13.47.09l.75,4.72a3.3,3.3,0,0,1-.2,1.86,2.8,2.8,0,0,1-1.18,1.3A1.38,1.38,0,0,1,281.07,359.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.12,356.48a4.91,4.91,0,0,1-.91-2.51,7.19,7.19,0,0,1,.05-3,2.87,2.87,0,0,1,1.34-1.75,2.06,2.06,0,0,1,.64-.25c.16,0,.26.08.3.31a2.7,2.7,0,0,1,0,.75c0,.24-.1.36-.21.37a1.2,1.2,0,0,0-1,1.1,5.77,5.77,0,0,0,.06,1.82,4.15,4.15,0,0,0,.48,1.57.51.51,0,0,0,.77.17,1.53,1.53,0,0,0,.23-.15l.23-.23s0,0,.06-.05.18,0,.26.13a2.09,2.09,0,0,1,.18.63.87.87,0,0,1,0,.28.7.7,0,0,1-.14.27c-.08.08-.18.18-.31.29a3.81,3.81,0,0,1-.41.29C286.05,356.91,285.51,356.89,285.12,356.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.84,354.87,288,349.4l-.8.46a.13.13,0,0,1-.18,0,1,1,0,0,1-.11-.36l-.05-.31a1.21,1.21,0,0,1,0-.42.3.3,0,0,1,.14-.21L289.7,347a.12.12,0,0,1,.18,0,1,1,0,0,1,.11.36l.05.32a1.15,1.15,0,0,1,0,.41.34.34,0,0,1-.14.22l-.81.46.87,5.48c0,.21-.09.4-.36.56l-.3.17C289,355.11,288.88,355.09,288.84,354.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.42,353.38l-1-6.5c0-.22.09-.41.37-.57l.3-.18c.27-.16.43-.12.47.1l1,6.5q.06.33-.36.57l-.3.18C291.61,353.64,291.46,353.61,291.42,353.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.69,349.1q-.58-3.63,1.31-4.73a1.18,1.18,0,0,1,1.54.08,4.63,4.63,0,0,1,.92,2.47,7.14,7.14,0,0,1,0,3,2.72,2.72,0,0,1-1.26,1.7C293.9,352.37,293.07,351.52,292.69,349.1Zm2.65.77a2.36,2.36,0,0,0,.12-.85,10.35,10.35,0,0,0-.14-1.44,10.06,10.06,0,0,0-.3-1.34,1.18,1.18,0,0,0-.35-.57.44.44,0,0,0-.45,0,.91.91,0,0,0-.39.45,2.11,2.11,0,0,0-.13.84,8.62,8.62,0,0,0,.13,1.44,8.21,8.21,0,0,0,.31,1.34,1,1,0,0,0,.36.57.42.42,0,0,0,.45,0A.94.94,0,0,0,295.34,349.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62,349.8l-1-6.5c0-.21.08-.4.36-.56l.19-.11a.48.48,0,0,1,.24-.08q.09,0,.18.15l1.82,2.56a5.09,5.09,0,0,1,.37.65l0,0a6,6,0,0,1-.18-.77l-.52-3.24c0-.21.09-.4.36-.56l.18-.1c.28-.16.43-.14.47.08l1,6.5c0,.22-.09.41-.36.57l-.14.07a.51.51,0,0,1-.25.09c-.07,0-.13-.05-.19-.14l-1.92-2.66a4.37,4.37,0,0,1-.3-.54l0,.05a6.5,6.5,0,0,1,.17.66l.53,3.34c0,.22-.09.4-.37.57l-.17.09C297.81,350.05,297.66,350,297.62,349.8Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.66,252.17,178,327.6v0a1,1,0,0,1-.48.52,2.82,2.82,0,0,1-2.53,0,1,1,0,0,1-.52-.62.74.74,0,0,1,0-.21,2,2,0,0,1,.1-.52l27.79-75.85a1.79,1.79,0,0,1,2.3-1.06A1.77,1.77,0,0,1,205.66,252.17Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.66,252.17,178,327.6v0a1,1,0,0,1-.48.52,2.82,2.82,0,0,1-2.53,0,1,1,0,0,1-.52-.62.74.74,0,0,1,0-.21,2,2,0,0,1,.1-.52l27.79-75.85a1.79,1.79,0,0,1,2.3-1.06A1.77,1.77,0,0,1,205.66,252.17Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.51,
    y: 294.71,
    width: 4,
    height: 32.09,
    transform: "translate(-177.87 313.44) rotate(-60)",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.51,
    y: 294.71,
    width: 4,
    height: 32.09,
    transform: "translate(-177.87 313.44) rotate(-60)",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.72,
    y: 283.05,
    width: 4,
    height: 32.09,
    transform: "translate(-157.66 325.11) rotate(-60)",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.72,
    y: 283.05,
    width: 4,
    height: 32.09,
    transform: "translate(-157.66 325.11) rotate(-60)",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.05,247l14.82-8.56a4.11,4.11,0,0,1,3.72-.29,4.07,4.07,0,0,1,2.27,3l24.61,115.11a2.24,2.24,0,0,1,0,.24,1,1,0,0,1,0,.25,1,1,0,0,1-.51.62,2.82,2.82,0,0,1-2.53,0,1.12,1.12,0,0,1-.49-.54l0-.11L200.36,241.84c-.05-.25-.15-.4-.23-.43a.64.64,0,0,0-.47.12l-14.83,8.56",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.05,247l14.82-8.56a4.11,4.11,0,0,1,3.72-.29,4.07,4.07,0,0,1,2.27,3l24.61,115.11a2.24,2.24,0,0,1,0,.24,1,1,0,0,1,0,.25,1,1,0,0,1-.51.62,2.82,2.82,0,0,1-2.53,0,1.12,1.12,0,0,1-.49-.54l0-.11L200.36,241.84c-.05-.25-.15-.4-.23-.43a.64.64,0,0,0-.47.12l-14.83,8.56",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.49,302.09l-9-5.22a1.2,1.2,0,0,1-.53-.93v-.22a1.2,1.2,0,0,1,.53-.93l21.67-12.51a1.19,1.19,0,0,1,1.07,0l9,5.22a1.18,1.18,0,0,1,.54.93v.22a1.18,1.18,0,0,1-.54.93l-21.66,12.51A1.21,1.21,0,0,1,195.49,302.09Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,300.94v1.27a1.16,1.16,0,0,0,.54-.12l10.83-6.26,10.83-6.25a1.18,1.18,0,0,0,.54-.93v-.22a1.08,1.08,0,0,0-.16-.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.08,295.19a1.18,1.18,0,0,0-.15.53v.22a1.2,1.2,0,0,0,.53.93l9,5.22a1.19,1.19,0,0,0,.54.12v-1.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.58,283.78l-15-8.66a1.2,1.2,0,0,1-.53-.94V274a1.2,1.2,0,0,1,.53-.93l21.67-12.51a1.19,1.19,0,0,1,1.07,0l15,8.66a1.21,1.21,0,0,1,.54.93v.22a1.21,1.21,0,0,1-.54.93l-21.66,12.51A1.21,1.21,0,0,1,191.58,283.78Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.12,282.63v1.28a1.2,1.2,0,0,0,.54-.13l10.83-6.25,10.83-6.26a1.21,1.21,0,0,0,.54-.93v-.22a1.08,1.08,0,0,0-.16-.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.19,273.44a1.18,1.18,0,0,0-.15.53v.21a1.2,1.2,0,0,0,.53.94l15,8.66a1.16,1.16,0,0,0,.54.13v-1.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24,357l-9-5.21a1.18,1.18,0,0,1-.54-.93v-.22a1.18,1.18,0,0,1,.54-.93l21.66-12.51a1.21,1.21,0,0,1,1.08,0l9,5.22a1.21,1.21,0,0,1,.54.93v.21a1.21,1.21,0,0,1-.54.94L208.31,357A1.13,1.13,0,0,1,207.24,357Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.83,350.11a1.08,1.08,0,0,0-.16.53v.22a1.18,1.18,0,0,0,.54.93l9,5.21a1.05,1.05,0,0,0,.54.13v-1.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78,355.86v1.27a1,1,0,0,0,.53-.13l10.84-6.25L230,344.5a1.21,1.21,0,0,0,.54-.94v-.21a1.2,1.2,0,0,0-.16-.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.32,338.7l-9-5.22a1.2,1.2,0,0,1-.53-.93v-.21a1.22,1.22,0,0,1,.53-.94L216,318.9a1.19,1.19,0,0,1,1.07,0l9,5.21a1.18,1.18,0,0,1,.54.93v.22a1.18,1.18,0,0,1-.54.93L204.4,338.7A1.21,1.21,0,0,1,203.32,338.7Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.91,331.81a1.12,1.12,0,0,0-.15.53v.21a1.2,1.2,0,0,0,.53.93l9,5.22a1.2,1.2,0,0,0,.54.13v-1.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.86,337.55v1.28a1.16,1.16,0,0,0,.54-.13l10.83-6.26,10.83-6.25a1.18,1.18,0,0,0,.54-.93V325a1.08,1.08,0,0,0-.16-.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.41,320.39l-9-5.21a1.18,1.18,0,0,1-.54-.93V314a1.18,1.18,0,0,1,.54-.93L212,300.59a1.21,1.21,0,0,1,1.08,0l9,5.21a1.23,1.23,0,0,1,.54.94V307a1.19,1.19,0,0,1-.54.93l-21.66,12.51A1.21,1.21,0,0,1,199.41,320.39Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,313.5a1.08,1.08,0,0,0-.16.53v.22a1.18,1.18,0,0,0,.54.93l4.51,2.6,4.52,2.61a1.05,1.05,0,0,0,.54.13v-1.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,319.24v1.28a1.08,1.08,0,0,0,.54-.13l10.83-6.25,10.83-6.26a1.19,1.19,0,0,0,.54-.93v-.21a1.05,1.05,0,0,0-.16-.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41,310.74l-.75-8-6.77.4s2.29,8.74,2.67,9.55C218.74,312.87,222.41,310.74,222.41,310.74Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.52,313.49a3.87,3.87,0,0,1,0,.9c-.06,1-.13,2.07-.19,3.1a8.31,8.31,0,0,1-.16,1.22,8,8,0,0,0,0,1.47c0,.52,0,1,0,1.54a2.9,2.9,0,0,0,0,.66c.06.22-3.23,2.15-4.56,2.9l-.24.12a2.11,2.11,0,0,1-2.17-.48,3.69,3.69,0,0,1,.85-4.07s.17,0,.12-1.3c0-.93,0-1.87-.13-2.8-.09-.68-.23-1.36-.35-2s-.2-1.33-.4-2.27a1.19,1.19,0,0,1,0-.72,1,1,0,0,1,.33-.36,7.22,7.22,0,0,1,4.29-1.64.78.78,0,0,1,.52.13.76.76,0,0,1,.2.4,4.12,4.12,0,0,0,.33,1.1,3.3,3.3,0,0,0,.6.64,3.3,3.3,0,0,1,1,1.3A1.94,1.94,0,0,1,224.52,313.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.17,313.83c.62.23.48,1.92.11,3.55a7.77,7.77,0,0,0-.36,3.54c.22,1.35.34,2-.21,2.46a53.93,53.93,0,0,1-4.9,2.6,16.1,16.1,0,0,0,.92-5.09c.07-3,.25-4.92,1.62-6.3A2.63,2.63,0,0,1,225.17,313.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.2,323.39a8.2,8.2,0,0,0,3.67,1.55c2,.2,2-.55,2.23-2.87s.22-5.53,1.11-7a3.8,3.8,0,0,1,3-1.93c.13-.06.73.38.93.65a3.32,3.32,0,0,0-2.55,1.05c-1.21,1.21-1.4,3.74-1.43,6s-.09,4.95-1.92,5.25a6.66,6.66,0,0,1-5-1.45A.93.93,0,0,1,214.2,323.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,320.85a4.06,4.06,0,0,0-.42.63h0a4.43,4.43,0,0,0-.35,3.36c-2.34-.19-3-1.45-3-1.45a2.24,2.24,0,0,1,1.19-2,3.06,3.06,0,0,1,.5-.27l0,0A3.42,3.42,0,0,1,218,320.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,320a.66.66,0,0,0-.27.42,1.32,1.32,0,0,0,.68,1.2c.25.14.46.08.06-.4a1.49,1.49,0,0,1-.37-.55A2.53,2.53,0,0,1,218.15,320Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.11,318.35a.7.7,0,0,0-.18.38,2,2,0,0,0,.82,1.26c.43.18.19-.25,0-.47a3.71,3.71,0,0,1-.45-.7A2.42,2.42,0,0,1,218.11,318.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,316.57a.47.47,0,0,0-.1.41,2.22,2.22,0,0,0,1,.73c.19,0,.34-.12,0-.34a6.13,6.13,0,0,1-.63-.44A1.37,1.37,0,0,1,218,316.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.15,305.8a9.54,9.54,0,0,0-6.28,1.66s-.62-1.68-3.71-12.63c-1.14-4-1.89-7.48-2.57-10.07a29.7,29.7,0,0,1-1.19-6.09c-.55-6.94-.72-27.19-1-29.8,0,0,14.4-4.4,14.41-4.37a26.74,26.74,0,0,1,0,12.47c-1.2,8.46-2.26,17.72-2.65,22.28a26.31,26.31,0,0,1,1.93,7C221.46,289,222.15,305.8,222.15,305.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.12,312.75c-.27-.05-.12.9-.06,1.26s.61,1.25,2.54,1.83,3.72.22,5,.51,3.32,1.64,4.47,1.94a6.42,6.42,0,0,0,4.13-.37c.32-.18,1-.65,1-1s.05-.79,0-.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,316.15a3.84,3.84,0,0,1-1.91,1.25,6,6,0,0,1-3.35,0,9.84,9.84,0,0,1-2-.89,11.25,11.25,0,0,0-2.19-.8,29.06,29.06,0,0,0-3.85-.42,4.11,4.11,0,0,1-2.38-.9,2.88,2.88,0,0,1-.73-2.22,1.43,1.43,0,0,1,.07-.58c.08-.17.21-.2.38-.31.4-.24.75-.56,1.17-.77.57-.29,2.82-1,3.75-.66l.49.11c.38.08,1.86.24,2.25.25a1.76,1.76,0,0,0,1.1-.3c.27-.21.45-.52.75-.67a1.54,1.54,0,0,1,1.06,0,2.8,2.8,0,0,0,1.83,0c.7-.26,1.32-.9,2-1.18a.59.59,0,0,1,.67.13,1.07,1.07,0,0,1,.16.79,16.66,16.66,0,0,0,.24,2.72C207.8,313,208.54,314.36,208.13,316.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.38,309.91a1.37,1.37,0,0,0-1.14.6,2.48,2.48,0,0,0-.32.6,1.64,1.64,0,0,0-.1.9.16.16,0,0,0,.18.12.19.19,0,0,0,.15-.15,3.37,3.37,0,0,1,.38-1.16,1.5,1.5,0,0,1,.33-.42,1.38,1.38,0,0,1,.48-.25,1.07,1.07,0,0,1,.23,0l.12,0a.18.18,0,0,0-.1-.16A.4.4,0,0,0,198.38,309.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.64,310.09a.93.93,0,0,0-.63.11,1.28,1.28,0,0,0-.42.58,2.54,2.54,0,0,0-.26.85c0,.15-.07.75.22.67a.21.21,0,0,0,.15-.14.8.8,0,0,0,.05-.21,3.5,3.5,0,0,1,.23-.9c.13-.32.37-.75.76-.8h.12c0-.07-.06-.11-.12-.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74,309.8a.83.83,0,0,0-.42.23,1.59,1.59,0,0,0-.27.45,2.82,2.82,0,0,0-.22.94,1.33,1.33,0,0,0,.11.71c0,.08.13.17.22.14s.1-.19.12-.27a4,4,0,0,0,0-.49,2.91,2.91,0,0,1,.71-1.62l.05-.07c0-.05-.09-.06-.13-.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.1,309.88c-.47-.09-1.55.39-2.26,1.75a10.33,10.33,0,0,0-.8,3.58,3.74,3.74,0,0,1-2.35-1.36,2.55,2.55,0,0,1-.59-1.21,2.67,2.67,0,0,1,.83-2c.81-.7,1.63-1.14,3.71-1.11,1.88,0,2,.49,2,.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.59,303.16s.24,4.26.4,5.41c.1.64-.37,1.3-2.27,1.88-1.35.4-2.77,0-2.79-.39L201,306Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,245.45l-23.16,2.4s-5,30.32-5.16,33.56c-.08,2.35,7,25.15,7,25.15s4.4.59,6.25-1.58c-.2-3.06-.53-10.82-.75-13.61a43,43,0,0,0-2-10.66S209.69,265,211.8,258C222.22,254,222.07,245.45,222.07,245.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.16 208.68 206.12 216.95 214.98 215.66 214.04 206.73 205.16 208.68",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.52,211.35c2.48-.26,4.72.22,6,2.61s3,11.06,3.63,15c.61,3.7.89,4.38-1.11,5.69-1.32.86-6.82,3.71-6.82,3.71Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47,211.19c2.7-.31,4.8-.2,5.82.73s2.1,1.89,2.83,5.49,1.69,8.73,1.69,8.73-2,4.22-9.29,3.63Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47,211.19c2.7-.31,4.8-.2,5.82.73s2.1,1.89,2.83,5.49,1.69,8.73,1.69,8.73-2,4.22-9.29,3.63Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,215.37a5.78,5.78,0,0,0-6.09-4.13s-.65.06-1.25.16c-.31,1.35-6.19,2.85-8.87,1.63-1.06.28-3.8.81-4.68,1.11-2.52.83-3.56,3.32-4,11.55,0,0,1.57,18.81,1.57,24.08a31.44,31.44,0,0,0,14.94.26c7.52-1.68,8.54-4.58,8.54-4.58l-.72-8.64S222.79,220.42,221.87,215.37Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,215.37a5.78,5.78,0,0,0-6.09-4.13s-.65.06-1.25.16c-.31,1.35-6.19,2.85-8.87,1.63-1.06.28-3.8.81-4.68,1.11-2.52.83-3.56,3.32-4,11.55,0,0,1.57,18.81,1.57,24.08a31.44,31.44,0,0,0,14.94.26c7.52-1.68,8.54-4.58,8.54-4.58l-.72-8.64S222.79,220.42,221.87,215.37Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.78,208.6a2.16,2.16,0,0,1,1.94,1.69c0,.7-1.47,1.2-1.47,1.2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brush--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.13,204l1.81,10.56a.68.68,0,0,0,.5.5,2.2,2.2,0,0,0,2-.33.73.73,0,0,0,.32-.64l-1.81-10.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.38 206.24 166.87 208.32 166.13 204 168.91 203.52 169.38 206.24",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.86,194.81l.37,2.15,1.68-1.39.76,4.42a4.66,4.66,0,0,1-1.46,4l-3,2.45a1.58,1.58,0,0,1-1.38.42s-1.81-.65-2.18-.81a1.52,1.52,0,0,1-.79-1.22l-.76-4.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.26,206.41l3-2.45a4.66,4.66,0,0,0,1.46-4l-.76-4.42-6.71,5.57.76,4.42A1.3,1.3,0,0,0,167.26,206.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.2 201.14 170.91 195.57 169.81 189.12 163.09 194.69 164.2 201.14",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.2 201.14 163.09 194.69 161.05 193.93 162.15 200.38 164.2 201.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.53 203.06 171.24 197.49 171.39 198.36 164.69 203.98 164.53 203.06",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.53 203.06 162.48 202.3 162.64 203.22 164.69 203.98 164.53 203.06",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,195.9s.89,1.43,2.13,1.3l-.43-2.51-2-.76Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,195.9s.89,1.43,2.13,1.3l-.43-2.51-2-.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.52,197.2a2.71,2.71,0,0,0,2.49-.73c.77-.81.68-3.18,2.38-3.52a2.79,2.79,0,0,1,2.23.89l-.81-4.72-6.72,5.57Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.81 189.12 167.76 188.36 161.05 193.93 163.09 194.69 169.81 189.12",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.81 189.12 167.76 188.36 161.05 193.93 163.09 194.69 169.81 189.12",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.18,214.07c-1.69.36-1.9-.13-6.46,2.64-4.24,2.57-11.61,6.81-14.38,8.39a45.11,45.11,0,0,1-7.25-8.9,3.78,3.78,0,0,1-.38-2c.16-1.73-.21-1.88-.27-3.44-.05-1.22.3-1.88,0-2a1.37,1.37,0,0,0-1.68.82,6.94,6.94,0,0,0-.53,1.89s-2.57,2.29-2.84,0l-.49-2.91a2.45,2.45,0,0,0-2.6,2c-.33,1.52-.54,4.84.59,7,.54,1,2.83,1.88,4.09,2.71,1.41.93,5.69,10.12,8.32,11.89,1.62,1.07,2.67.87,4.76.16,4.69-1.59,16.15-7.32,16.15-7.32S203,222.13,201.18,214.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.61,214c-3.72-.08-5.8,1.88-9.86,4.23l-5.84,3.37s-1.14,5.64,3.18,8.21l9.78-4.56C201.61,223.46,203.54,218.53,201.61,214Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.61,214c-3.72-.08-5.8,1.88-9.86,4.23l-5.84,3.37s-1.14,5.64,3.18,8.21l9.78-4.56C201.61,223.46,203.54,218.53,201.61,214Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,198s-2,3.92-1.81,4.22a6.63,6.63,0,0,0,1.71.75Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.43,200.45a2.32,2.32,0,1,1,2.39-2.32A2.37,2.37,0,0,1,200.43,200.45Zm0-4.13a1.81,1.81,0,1,0,1.86,1.81A1.83,1.83,0,0,0,200.43,196.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.07,190.37c-4.07.83-5.24,2.57-5.63,8.83-.4,6.55.1,8,1,8.84.59.59,3.2.88,4.77.8,5.69-.27,7.87-2.09,10.09-5.38,2.61-3.88,3.3-9.13.5-11.29C211.85,189.14,206.72,190,205.07,190.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.43,208c.59.59,3.2.88,4.77.8l-.11-.92A28,28,0,0,1,200.43,208Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.26 197.65 205.49 198.55 205.19 199.05 198.26 198.17 198.26 197.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.53,192.37a2.23,2.23,0,0,0,.61.27,2.37,2.37,0,0,0,2.82,2.83,1.64,1.64,0,0,0,.13,1.38,1.61,1.61,0,0,0,1.15.77c-.14,0,0,1.1,0,1.2a1.06,1.06,0,0,0,.72.83s.64-2.42,2.74-2.12,2.4,2.93,1.07,4.52-2.56,1-2.58,1c.13.06.17.83.21,1a11.56,11.56,0,0,0,.54,1.73,3.56,3.56,0,0,0,2.14,2.19c.75.33,4.25-.07,5-.92,1.24-3.12,3-4.28,4.37-7a11,11,0,0,0,1.42-4.15A3.82,3.82,0,0,0,218.3,192a1.78,1.78,0,0,0-1.74-2.89,2.87,2.87,0,0,0-1.34-2.91,2.84,2.84,0,0,0-2.08-.28c-.2,0-1.74.67-1.7.93a2.58,2.58,0,0,0-5-.17,4.25,4.25,0,0,0-2.56-1.8,2.86,2.86,0,0,0-2.59.55,2.66,2.66,0,0,0-.28,2.93,2,2,0,0,0-1.86.72,2.3,2.3,0,0,0-.54,1.82A1.88,1.88,0,0,0,199.53,192.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.91,201l.08-2.74a1.37,1.37,0,1,0-.08,2.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.45,263.84l-27.69,75.34v0l-.07.17a1.21,1.21,0,0,1-.44.43,2.82,2.82,0,0,1-2.53,0,1,1,0,0,1-.52-.62.67.67,0,0,1,0-.2,1.91,1.91,0,0,1,.1-.53l27.8-75.85a1.78,1.78,0,1,1,3.35,1.23Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.45,263.84l-27.69,75.34v0l-.07.17a1.21,1.21,0,0,1-.44.43,2.82,2.82,0,0,1-2.53,0,1,1,0,0,1-.52-.62.67.67,0,0,1,0-.2,1.91,1.91,0,0,1,.1-.53l27.8-75.85a1.78,1.78,0,1,1,3.35,1.23Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.83,250.09a2.79,2.79,0,0,0-1.19,2.67l24.62,115.12a1.27,1.27,0,0,1,0,.28.67.67,0,0,1,0,.2,1,1,0,0,1-.51.62,2.76,2.76,0,0,1-2.53,0,1.18,1.18,0,0,1-.49-.51s0,0,0,0l0-.15L180.15,253.52a6.38,6.38,0,0,1,2.9-6.53",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.26,367.88,183.64,252.76a2.79,2.79,0,0,1,1.19-2.67l-1.78-3.1a6.38,6.38,0,0,0-2.9,6.53L204.72,368.3l0,.15s0,0,0,0a1.18,1.18,0,0,0,.49.51,2.76,2.76,0,0,0,2.53,0,1,1,0,0,0,.51-.62.67.67,0,0,0,0-.2A1.27,1.27,0,0,0,208.26,367.88Z",
    style: {
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signal--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.33,292.71a.8.8,0,0,1,.48-.67,2.61,2.61,0,0,1,2.37,0,.83.83,0,0,1,.49.67h0V396.36c0,.53-.75.95-1.67.95s-1.67-.42-1.67-.95h0V292.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.34,262.69,88.59,247.53a2.47,2.47,0,0,0-.27-.21L86,246a1,1,0,0,0-1.45.52L68,281.74a2.22,2.22,0,0,0,.44,2.4l15.75,15.15a1.65,1.65,0,0,0,.27.21l2.29,1.32a1,1,0,0,0,1.45-.52l16.63-35.21A2.21,2.21,0,0,0,104.34,262.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.78,265.09,88.15,300.3a1,1,0,0,1-1.72.32L70.67,285.46a2.26,2.26,0,0,1-.44-2.4l16.64-35.21a1,1,0,0,1,1.72-.32l15.75,15.16A2.21,2.21,0,0,1,104.78,265.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.06,284s0-.1,0-.14l16.07-34L103,264.13s0,.1,0,.15l-16.07,34Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.59,300.76l-2.18-1.26a1.56,1.56,0,0,1-.27-.2L68.39,284.14a2.11,2.11,0,0,1-.58-1.3l2.26,1.31a2.2,2.2,0,0,0,.61,1.31l15.75,15.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.25,254.32c.41-.23.74,0,.74.43a1.62,1.62,0,0,1-.74,1.28c-.41.24-.74.05-.74-.42A1.64,1.64,0,0,1,88.25,254.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.67,292.81c.41-.24.74-.05.74.42a1.64,1.64,0,0,1-.74,1.29c-.41.23-.74,0-.74-.43A1.62,1.62,0,0,1,86.67,292.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,265.84l.8-1.53,2.19-.48a1.74,1.74,0,0,0-.91-1.45c-.82-.35-2,.32-2.8,1.62a5.8,5.8,0,0,0-.94,3.26,1.6,1.6,0,0,1-.2.82l-1.12,2.13-.66,1.24L90,272.69l.56-1,1-2a1.14,1.14,0,0,1,.68-.62A3.9,3.9,0,0,0,94.5,267l.15-.33-2.2.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.59,275.18l-1,1.88-1,2a1.09,1.09,0,0,1-.68.62,3.86,3.86,0,0,0-2.26,2.11c-.06.11-.11.22-.16.33l2.2-.49.29,1.27-.8,1.53-2.18.48a1.71,1.71,0,0,0,.9,1.45c.82.35,2-.32,2.8-1.62a5.8,5.8,0,0,0,.94-3.26,1.58,1.58,0,0,1,.2-.82l1.28-2.44.86-1.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.53,277.26l-6-4.71a.6.6,0,0,0-.9.15l-.7,1.19a.59.59,0,0,0,.1.73l5.69,5.53c.22.23.45.08.62-.18l1.08-2C94.64,277.69,94.66,277.38,94.53,277.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.01 270.18 86.67 273.23 87.13 272.45 83.46 269.4 83.24 268.54 81.24 267.49 80.84 268.33 82.17 269.98 83.01 270.18",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paint--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,347.86H122l1.17,18.48h0c0,1.72,1.09,3.45,3.34,4.78,4.51,2.67,11.86,2.75,16.42.18,2.3-1.3,3.45-3,3.45-4.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.82,342.1c-5.11,2.88-5.17,7.64-.12,10.63s13.29,3.07,18.4.2,5.16-7.64.11-10.63S130.93,339.23,125.82,342.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.84,347.64a3.32,3.32,0,0,1-.18,1,6.28,6.28,0,0,1-3.12,3.28,19.27,19.27,0,0,1-17.26-.18,6.35,6.35,0,0,1-3-3.29,3.12,3.12,0,0,1-.18-1.09c0-1.58,1.19-3.11,3.3-4.28a17.3,17.3,0,0,1,8.64-2,17.48,17.48,0,0,1,8.62,2.14C145.72,344.51,146.86,346.05,146.84,347.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,349.7a17.41,17.41,0,0,0-8.64,2l-.13.07,0,0a19.27,19.27,0,0,0,17.26.18l.13-.07,0,0A17.7,17.7,0,0,0,135,349.7Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.86,353.88a8.16,8.16,0,0,1-2.36-.89,3.35,3.35,0,0,1-1.61-1.75,1.7,1.7,0,0,1-.1-.59,1.83,1.83,0,0,1,.18-.75,15.5,15.5,0,0,0-5.59,1.77l-.13.07,0,0a17.65,17.65,0,0,0,8.6,2.13C135.21,353.9,135.54,353.89,135.86,353.88Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.9,354.8c.51-.28.92,0,.91.54a2,2,0,0,1-.93,1.58c-.51.29-.92.05-.91-.54A2,2,0,0,1,139.9,354.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27,353c-1.12,2.87-2,6.78.52,8.64l.4.28v1.21c-.33-.2-.67-.43-1-.67-3.73-2.77-1.44-8.81,0-11.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33,356.1c-.14.29-3.72,7.15-9.62,8.53a8.8,8.8,0,0,1-2,.24,10.25,10.25,0,0,1-5.5-1.72v-1.21a9,9,0,0,0,7.29,1.71c5.45-1.27,8.93-7.95,9-8a.5.5,0,0,1,.68-.21A.49.49,0,0,1,140.33,356.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWip1);
export default __webpack_public_path__ + "static/media/wip-1.1020af31aaccb6499a92a71ed69bed71.svg";
export { ForwardRef as ReactComponent };